import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import leftBar from '@/components/env-bigData/leftBar';
import ratio from '@/components/env-bigData/ratio';
import warn from '@/components/border/warn';
import dataTable from '@/components/border/dataTable';
import ranking from '@/components/border/ranking';
import ball from '@/components/env-bigData/ball';
import calendarRange from '@/components/env-bigData/calendarRange';
import pieData from '@/components/env-bigData/pieData';
import typeBar from '@/components/env-bigData/typeBar';
import autoPie from '@/components/env-bigData/autoPie';
import { cityData } from '@/utils/rizhao_city';
import flagImg from '@/assets/others/红旗.png';
import _ from 'lodash'; // import multiHistogram from '@/components/env-bigData/multiHistogram'

var map;
export default {
  name: 'cockpit',
  props: ['isFullscreen', 'tab', 'tabId'],
  components: {
    // multiHistogram,
    border: border,
    leftBar: leftBar,
    ratio: ratio,
    warn: warn,
    dataTable: dataTable,
    ranking: ranking,
    ball: ball,
    calendarRange: calendarRange,
    pieData: pieData,
    typeBar: typeBar,
    autoPie: autoPie
  },
  data: function data() {
    return {
      ballState: true,
      lastTreeNode: {},
      //上条数据
      selectedTreeNode: {},
      //目前选中数据
      polyLineArr: [],
      //绘制的边界线数组
      markerList: [],
      //绘制坐标点
      polygonList: [],
      //绘制区域
      lineList: [],
      //绘制线段
      areaList: [],
      //绘制面
      areaType: 0,
      //区域类型
      areaId: '0',
      tabTitle: '面源分析',
      marginTop: '45px',
      sideHeight: '97%',
      leftInfo: [{
        name: '村庄面积',
        icon: 'global',
        value: '104',
        unit: 'km²'
      }, {
        name: '人口',
        icon: 'team',
        value: '1743159',
        unit: '人'
      }, {
        name: '耕地面积',
        icon: 'flag',
        value: '86',
        unit: 'km²'
      }],
      leftTempList: [{
        title: '温度',
        icon: 'flag',
        unit: '℃',
        value: '14'
      }, {
        title: '湿度',
        icon: 'flag',
        unit: '%',
        value: '71'
      }, {
        title: '气压',
        icon: 'flag',
        value: '75',
        unit: 'Pa'
      }],
      leftBarValue: [75, 69, 17, 6, 3, 18],
      leftBarTitle: ['细微粒物PM2.5', '亚微米颗粒物PM1.0', '臭氧', '一氧化碳', '二氧化硫', '二氧化氮'],
      dateList: [],
      waterWarnList: [],
      zoom: 10,
      center: [119.1, 35.2],
      bounds: '119.662149,35.589281;119.665756,35.581552;119.666538,35.575902;119.665755,35.570248;119.663024,35.563031;119.649869,35.537642;119.639246,35.509444;119.635214,35.50448;119.632998,35.502901;119.631131,35.502141;119.629263,35.501672;119.628681,35.500855;119.627282,35.493793;119.625527,35.486178;119.618976,35.459462;119.617109,35.454792;119.61513,35.451641;119.613029,35.449831;119.600204,35.443526;119.597411,35.44061;119.592519,35.433375;119.586926,35.421941;119.579706,35.406542;119.577374,35.395924;119.577495,35.390787;119.578785,35.385577;119.583091,35.381839;119.586705,35.378802;119.589028,35.376116;119.58973,35.372614;119.588802,35.368062;119.586938,35.363863;119.584025,35.360537;119.579138,35.357625;119.5718,35.355181;119.56308,35.352627;119.548608,35.349621;119.543764,35.34794;119.540407,35.341252;119.542161,35.329829;119.55273,35.330005;119.554277,35.329266;119.554929,35.328201;119.554684,35.326239;119.553544,35.324933;119.552078,35.324445;119.542714,35.32414;119.540597,35.323818;119.539132,35.322595;119.538643,35.32047;119.538478,35.296755;119.536912,35.291378;119.531309,35.291954;119.533106,35.297015;119.532943,35.300205;119.532536,35.301351;119.531234,35.302417;119.529688,35.302994;119.528467,35.303733;119.523535,35.303218;119.520441,35.303792;119.518239,35.308216;119.51601,35.318086;119.509319,35.321692;119.502406,35.321713;119.493484,35.318601;119.486122,35.314812;119.476529,35.308338;119.451118,35.285394;119.424578,35.255313;119.417119,35.24411;119.411297,35.231623;119.405197,35.203444;119.399392,35.176638;119.397667,35.166887;119.416631,35.167464;119.416974,35.158164;119.396064,35.157827;119.3937,35.144465;119.393545,35.143591;119.395304,35.139825;119.397708,35.137687;119.413994,35.130204;119.41895,35.128284;119.428257,35.121193;119.432435,35.11138;119.431359,35.108974;119.42946,35.108151;119.426611,35.108214;119.412873,35.110747;119.415222,35.100607;119.408782,35.094887;119.398581,35.094504;119.400973,35.076345;119.395929,35.075757;119.394668,35.082399;119.381552,35.082651;119.374044,35.078695;119.37726,35.075166;119.38037,35.070279;119.357468,35.072823;119.356862,35.078034;119.354073,35.080057;119.350521,35.083887;119.343744,35.083642;119.305845,35.076683;119.301805,35.093155;119.301323,35.093472;119.300301,35.094861;119.300301,35.095904;119.300019,35.096729;119.299584,35.097402;119.298715,35.097814;119.297758,35.098356;119.29678,35.098941;119.295346,35.099982;119.294737,35.101328;119.293912,35.103456;119.293738,35.104195;119.293738,35.104825;119.293542,35.106715;119.293064,35.107931;119.292586,35.1083;119.292325,35.108691;119.292021,35.109038;119.291739,35.109776;119.291557,35.110243;119.291313,35.110434;119.291053,35.110694;119.290444,35.111372;119.290131,35.111684;119.289825,35.112101;119.289046,35.112809;119.28785,35.113934;119.287044,35.114935;119.286668,35.115157;119.285959,35.115128;119.285542,35.115169;119.28493,35.115377;119.284401,35.115446;119.2834,35.115459;119.280228,35.115134;119.277951,35.115341;119.276701,35.115566;119.274589,35.115399;119.273795,35.115492;119.273452,35.115606;119.273196,35.115727;119.273096,35.115777;119.272797,35.116176;119.272299,35.116382;119.271687,35.116381;119.271459,35.116353;119.270997,35.116388;119.269773,35.116579;119.26915,35.116754;119.267841,35.117081;119.267293,35.117173;119.26682,35.117432;119.266002,35.117795;119.265675,35.117937;119.265568,35.118016;119.265298,35.118251;119.265028,35.118528;119.264601,35.118528;119.264409,35.118571;119.264238,35.118706;119.264152,35.118976;119.263996,35.119254;119.263697,35.119553;119.263338,35.119606;119.26294,35.119606;119.262306,35.119542;119.261674,35.119862;119.260795,35.120336;119.260731,35.120378;119.259586,35.12067;119.259337,35.120741;119.259134,35.120894;119.257861,35.120979;119.256951,35.121328;119.256325,35.121855;119.255898,35.122424;119.255519,35.122634;119.254758,35.12279;119.254033,35.122933;119.253613,35.122926;119.253457,35.122869;119.253372,35.122762;119.253272,35.122691;119.25313,35.122641;119.252931,35.122627;119.252675,35.122698;119.251985,35.122954;119.250755,35.123659;119.249919,35.124353;119.249769,35.124513;119.248919,35.123137;119.246264,35.123138;119.243384,35.123029;119.240729,35.122919;119.238847,35.121921;119.237294,35.118596;119.235308,35.116379;119.232758,35.115605;119.22955,35.115165;119.227009,35.114059;119.226229,35.111066;119.223801,35.108629;119.220707,35.10719;119.217275,35.107084;119.213739,35.107199;119.210308,35.108093;119.206773,35.109871;119.203239,35.110876;119.197713,35.120864;119.197211,35.126463;119.196657,35.129901;119.196329,35.130409;119.196266,35.130435;119.196296,35.130461;119.195116,35.132289;119.193453,35.134786;119.192024,35.136507;119.18998,35.138118;119.187763,35.139065;119.184948,35.139514;119.178487,35.138915;119.174226,35.139034;119.169255,35.139986;119.166552,35.141545;119.164232,35.143157;119.163565,35.14482;119.162959,35.147593;119.163072,35.149922;119.163401,35.154133;119.16451,35.156904;119.165446,35.158121;119.169595,35.160277;119.173132,35.161702;119.172621,35.162008;119.171755,35.162368;119.171238,35.16226;119.170338,35.163009;119.169935,35.163513;119.169337,35.163678;119.168748,35.164186;119.1685,35.164406;119.16821,35.164954;119.167891,35.165312;119.167214,35.165777;119.166619,35.166059;119.16602,35.166189;119.165462,35.166199;119.164879,35.166505;119.163976,35.167572;119.163285,35.168197;119.162631,35.169805;119.161904,35.170469;119.161784,35.170895;119.161807,35.17177;119.161722,35.172268;119.160596,35.173589;119.160285,35.175931;119.160028,35.176577;119.159361,35.177551;119.158946,35.177897;119.158195,35.179328;119.157768,35.180564;119.157619,35.181974;119.157313,35.18244;119.155891,35.183343;119.154808,35.184202;119.153586,35.185679;119.153076,35.187105;119.152348,35.187733;119.149189,35.189282;119.148167,35.189184;119.147801,35.189417;119.147288,35.189472;119.146867,35.189327;119.144723,35.189062;119.144394,35.188608;119.144019,35.188497;119.143089,35.188561;119.142161,35.188308;119.140571,35.187842;119.140259,35.187652;119.140249,35.187642;119.14023,35.187635;119.140025,35.187511;119.139917,35.187488;119.135385,35.191652;119.135324,35.193813;119.135385,35.195866;119.136105,35.199856;119.136322,35.200964;119.137154,35.201962;119.139035,35.202346;119.143013,35.20273;119.14887,35.203275;119.153185,35.203322;119.156997,35.203429;119.16131,35.20414;119.164515,35.205909;119.167608,35.208897;119.170207,35.212329;119.171367,35.215542;119.17297,35.219476;119.173958,35.22341;119.174348,35.226346;119.174019,35.228897;119.174573,35.230336;119.177943,35.232826;119.179545,35.235704;119.180923,35.239029;119.182144,35.241853;119.182309,35.246454;119.181981,35.25233;119.182587,35.255266;119.183748,35.256539;119.187498,35.258196;119.188494,35.259802;119.188053,35.26141;119.187005,35.262687;119.185186,35.264685;119.18452,35.266182;119.183472,35.269732;119.182918,35.274002;119.182312,35.277828;119.18104,35.282709;119.179551,35.287589;119.178503,35.288811;119.177395,35.289754;119.174909,35.289983;119.172588,35.289931;119.16811,35.289385;119.164083,35.289558;119.16054,35.290617;119.158496,35.291841;119.156616,35.292896;119.155958,35.293897;119.156729,35.294949;119.158003,35.296554;119.159242,35.298631;119.158636,35.300154;119.157639,35.301709;119.152616,35.305847;119.148249,35.310648;119.145087,35.312968;119.143216,35.314038;119.141976,35.315341;119.141396,35.316727;119.14137,35.317781;119.141284,35.320831;119.142029,35.322131;119.142697,35.322436;119.143962,35.323238;119.14579,35.32476;119.147203,35.325783;119.148191,35.32675;119.148503,35.327832;119.148607,35.329661;119.148529,35.332044;119.147888,35.334151;119.147342,35.334624;119.146484,35.334875;119.145211,35.334987;119.143746,35.335044;119.140869,35.33538;119.137246,35.335413;119.133736,35.335585;119.118766,35.332816;119.105683,35.330641;119.101689,35.329088;119.096158,35.326869;119.094881,35.326814;119.093775,35.327694;119.092742,35.33003;119.092224,35.335128;119.09106,35.336235;119.089618,35.337785;119.088063,35.338948;119.087229,35.340555;119.087229,35.342607;119.087012,35.346208;119.086899,35.349977;119.086239,35.352748;119.08557,35.354244;119.084189,35.354964;119.082746,35.355738;119.080582,35.356179;119.078418,35.357508;119.077861,35.358893;119.078418,35.360666;119.078531,35.363106;119.077758,35.36499;119.075532,35.366095;119.073097,35.365649;119.069984,35.364091;119.065774,35.364567;119.048892,35.371479;119.048614,35.373342;119.044565,35.377012;119.042284,35.378003;119.038008,35.380264;119.031563,35.382632;119.028506,35.384563;119.024333,35.386877;119.019332,35.388636;119.013834,35.389341;119.01055,35.389111;119.002829,35.389252;119.001936,35.389173;118.999657,35.388967;118.998376,35.38846;118.996267,35.387625;118.990988,35.384895;118.990479,35.384671;118.986927,35.383108;118.984427,35.382215;118.983259,35.380272;118.982867,35.378553;118.982981,35.378296;118.984373,35.375176;118.986038,35.372519;118.987092,35.369307;118.988485,35.366986;118.988929,35.364436;118.989653,35.362388;118.989651,35.360667;118.989208,35.358395;118.988371,35.35551;118.986872,35.353123;118.983534,35.350842;118.980642,35.348838;118.978648,35.346393;118.975528,35.342782;118.973029,35.34017;118.970417,35.338556;118.96803,35.336776;118.966027,35.335719;118.963694,35.334938;118.961813,35.334156;118.961066,35.334106;118.960089,35.33404;118.958365,35.334369;118.956808,35.335088;118.954588,35.335914;118.951648,35.336241;118.949759,35.33668;118.94721,35.336954;118.944653,35.336618;118.943398,35.336251;118.943338,35.336233;118.941599,35.335724;118.935337,35.331171;118.934111,35.330781;118.932389,35.330778;118.930451,35.331277;118.925576,35.335151;118.924247,35.336869;118.923248,35.339196;118.923022,35.341857;118.923171,35.343551;118.92336,35.345683;118.921971,35.348396;118.921531,35.348604;118.918729,35.349933;118.917654,35.350444;118.915264,35.351442;118.910775,35.353603;118.907381,35.354788;118.904846,35.355508;118.900992,35.356121;118.896966,35.356419;118.892488,35.356929;118.889549,35.357267;118.888586,35.357458;118.886574,35.358319;118.883573,35.360055;118.877546,35.362384;118.87721,35.362514;118.873656,35.364376;118.872746,35.364921;118.871592,35.366218;118.871038,35.367219;118.870864,35.368166;118.870812,35.368761;118.871074,35.370389;118.871593,35.372194;118.872364,35.373856;118.873535,35.375782;118.874012,35.376921;118.874098,35.377411;118.874047,35.377991;118.873994,35.378672;118.874013,35.379513;118.874186,35.380511;118.874377,35.381458;118.874256,35.382264;118.87397,35.384157;118.873996,35.38491;118.874151,35.386906;118.874151,35.388483;118.873692,35.389676;118.873103,35.390638;118.872488,35.391918;118.871855,35.39297;118.871336,35.39355;118.870391,35.393848;118.869672,35.393956;118.86903,35.393939;118.868051,35.393782;118.866863,35.393048;118.865746,35.391701;118.863856,35.388376;118.862651,35.385871;118.860624,35.382792;118.859679,35.381708;118.857669,35.380221;118.855069,35.378842;118.851483,35.376939;118.849109,35.375418;118.847134,35.373109;118.845332,35.371659;118.844284,35.37117;118.843149,35.370803;118.842317,35.370752;118.841287,35.370754;118.838178,35.371268;118.836428,35.37171;118.834661,35.372467;118.8337,35.372695;118.832851,35.372733;118.831447,35.372682;118.829005,35.37225;118.827645,35.372076;118.826173,35.372062;118.823592,35.372188;118.822596,35.372349;118.820984,35.372738;118.819036,35.373196;118.817875,35.373287;118.816775,35.373306;118.814878,35.373012;118.812184,35.372682;118.808779,35.372442;118.806171,35.371956;118.804169,35.371329;118.800989,35.369898;118.799464,35.369479;118.79754,35.36943;118.79071,35.370314;118.787139,35.370722;118.78485,35.370953;118.784122,35.371057;118.783402,35.371286;118.782162,35.371813;118.780168,35.373129;118.778538,35.374355;118.776422,35.376251;118.774956,35.376758;118.773611,35.375971;118.773256,35.374622;118.773099,35.37098;118.772926,35.370489;118.77224,35.369507;118.771668,35.369211;118.768952,35.368019;118.765872,35.367287;118.764388,35.367042;118.761976,35.366936;118.760804,35.366814;118.759702,35.3665;118.758634,35.365992;118.756533,35.364871;118.754363,35.364152;118.753234,35.363854;118.751472,35.36373;118.749874,35.363608;118.74825,35.363345;118.746635,35.362695;118.743994,35.36103;118.742309,35.360206;118.74098,35.359697;118.739469,35.35952;118.73509,35.361551;118.733674,35.362424;118.732674,35.363319;118.729624,35.365014;118.727261,35.366817;118.723897,35.368469;118.722889,35.36754;118.72155,35.366487;118.720228,35.365749;118.718706,35.365126;118.715776,35.364106;118.714585,35.363735;118.712507,35.363549;118.712472,35.364503;118.712324,35.366036;118.712264,35.366246;118.712151,35.366368;118.711777,35.366893;118.711603,35.367427;118.711481,35.36762;118.711273,35.367831;118.71069,35.368373;118.710446,35.368915;118.710098,35.369388;118.709585,35.369824;118.70882,35.370103;118.707837,35.370575;118.706837,35.370889;118.706428,35.371257;118.706011,35.371537;118.704646,35.372008;118.70308,35.372653;118.700401,35.375155;118.698853,35.376622;118.697887,35.377776;118.697209,35.378653;118.696905,35.379807;118.696661,35.38;118.696261,35.380176;118.695713,35.380331;118.694886,35.380364;118.69386,35.380293;118.692503,35.379502;118.688579,35.375991;118.686342,35.373657;118.685133,35.372078;118.684132,35.370271;118.682923,35.368657;118.682557,35.368428;118.681417,35.367989;118.680939,35.367936;118.679642,35.367845;118.678851,35.367843;118.67785,35.367982;118.676554,35.368855;118.67524,35.369869;118.673944,35.370531;118.672534,35.37095;118.669507,35.371346;118.668202,35.371468;118.667062,35.371431;118.666183,35.371412;118.665061,35.371409;118.664191,35.371443;118.662294,35.371754;118.656944,35.3729;118.653839,35.373351;118.652308,35.373559;118.651134,35.373557;118.648716,35.373394;118.645751,35.372988;118.639368,35.371157;118.635847,35.370101;118.632074,35.368432;118.631414,35.368397;118.629084,35.368866;118.626608,35.369565;118.62573,35.370107;118.625435,35.3703;118.625191,35.371316;118.625244,35.373453;118.625313,35.376045;118.625436,35.381056;118.625453,35.382632;118.625401,35.383438;118.625123,35.385226;118.625054,35.386644;118.624915,35.387048;118.624594,35.387625;118.624089,35.388064;118.622882,35.388534;118.619146,35.388707;118.617322,35.388812;118.615646,35.389074;118.612997,35.389527;118.610566,35.389736;118.608186,35.390157;118.60612,35.390752;118.605027,35.398927;118.603578,35.406359;118.601713,35.409502;118.601044,35.413068;118.601409,35.414519;118.603654,35.415711;118.603683,35.415725;118.603904,35.415842;118.603923,35.415854;118.607329,35.417662;118.610768,35.418569;118.614815,35.420445;118.619045,35.423106;118.621408,35.423651;118.623824,35.423472;118.627569,35.422387;118.631801,35.421849;118.635668,35.421051;118.639006,35.421659;118.640753,35.423103;118.642244,35.425142;118.642111,35.427002;118.639314,35.429219;118.633854,35.430552;118.632584,35.430913;118.631924,35.432726;118.631803,35.435929;118.632107,35.440402;118.631682,35.442636;118.631438,35.443602;118.628475,35.446016;118.628779,35.447407;118.628901,35.449342;118.632891,35.452065;118.636159,35.452009;118.640515,35.451411;118.64208,35.451604;118.645715,35.452263;118.648011,35.453294;118.649403,35.455774;118.650977,35.458617;118.652734,35.459769;118.655762,35.460921;118.659328,35.461531;118.662051,35.461536;118.663808,35.460936;118.665679,35.459671;118.667801,35.456834;118.669071,35.456354;118.672821,35.456239;118.675066,35.456244;118.678268,35.456854;118.681844,35.458796;118.684385,35.459404;118.688439,35.459531;118.691406,35.459417;118.693581,35.459119;118.694912,35.458335;118.697034,35.456044;118.698243,35.45544;118.700783,35.455386;118.703932,35.455934;118.708046,35.45733;118.709133,35.457695;118.70962,35.458238;118.710099,35.459629;118.710829,35.46084;118.713186,35.462173;118.715299,35.463687;118.721838,35.467442;118.72389,35.468773;118.727524,35.473974;118.732296,35.482377;118.733321,35.484736;118.734356,35.486066;118.733182,35.487141;118.731088,35.48842;118.72909,35.490594;118.727648,35.493129;118.726431,35.495182;118.72504,35.496571;118.722928,35.497172;118.71972,35.498679;118.717317,35.500544;118.717289,35.500542;118.717245,35.5006;118.715912,35.501634;118.714399,35.502842;118.712286,35.504107;118.709078,35.505794;118.705808,35.507663;118.703146,35.509592;118.700789,35.511703;118.698849,35.513574;118.699641,35.516958;118.699398,35.520463;118.698729,35.523724;118.697398,35.526623;118.696554,35.528614;118.697399,35.530067;118.699521,35.531942;118.702905,35.534063;118.706054,35.536424;118.709264,35.538968;118.713256,35.543022;118.720273,35.547563;118.723669,35.550727;118.725107,35.553189;118.724925,35.55488;118.723716,35.557174;118.723178,35.559349;118.723422,35.561282;118.724021,35.562974;118.726839,35.563676;118.726925,35.565275;118.728741,35.565941;118.732488,35.56806;118.734842,35.569754;118.736537,35.572291;118.738171,35.574346;118.739683,35.577188;118.740464,35.579846;118.740586,35.581479;118.738771,35.587141;118.738233,35.588365;118.737442,35.589755;118.735818,35.593438;118.735575,35.595312;118.735576,35.599479;118.736844,35.601293;118.737331,35.603228;118.739688,35.624978;118.74272,35.630486;118.747402,35.635892;118.749121,35.637478;118.751431,35.640429;118.75401,35.642688;118.757144,35.644937;118.758594,35.646982;118.762596,35.650139;118.764609,35.652175;118.766605,35.653522;118.768054,35.655795;118.770084,35.658749;118.77267,35.661462;118.775255,35.663948;118.776762,35.664055;118.777492,35.663845;118.780068,35.663741;118.782298,35.664788;118.785046,35.667576;118.785429,35.668857;118.786247,35.671585;118.785583,35.674117;118.785725,35.674338;118.787326,35.676844;118.793086,35.677225;118.795439,35.678532;118.796412,35.679072;118.795972,35.682907;118.791185,35.686193;118.791506,35.688021;118.792353,35.690812;118.792407,35.69099;118.793578,35.693038;118.794185,35.694865;118.795078,35.697146;118.796248,35.699422;118.796403,35.699782;118.796426,35.699835;118.796456,35.699905;118.79653,35.700077;118.796737,35.700557;118.797132,35.701474;118.798026,35.703523;118.800036,35.705787;118.80235,35.708962;118.80352,35.711236;118.804431,35.713974;118.80586,35.715789;118.806476,35.718074;118.806822,35.72082;118.806892,35.724033;118.806372,35.726103;118.80419,35.728664;118.801399,35.729626;118.798887,35.730127;118.796356,35.730167;118.793279,35.730217;118.790453,35.729343;118.786509,35.728944;118.783414,35.728535;118.780596,35.728118;118.776927,35.727483;118.773267,35.727082;118.770456,35.726892;118.767923,35.726929;118.764261,35.726524;118.761163,35.726338;118.757222,35.725939;118.754141,35.726438;118.751901,35.726931;118.749383,35.727425;118.746309,35.728612;118.743512,35.72934;118.738161,35.729413;118.735633,35.729216;118.732548,35.729713;118.728889,35.729989;118.726082,35.730256;118.722153,35.730996;118.717111,35.732433;118.714319,35.733387;118.712111,35.735479;118.709868,35.735964;118.707093,35.738061;118.705163,35.740383;118.704084,35.742229;118.703302,35.745224;118.70365,35.748201;118.704833,35.751169;118.70546,35.754146;118.7064,35.758494;118.706452,35.761017;118.706496,35.763081;118.706539,35.765146;118.704913,35.768146;118.703826,35.769996;118.702183,35.772309;118.701948,35.774376;118.701148,35.776908;118.700357,35.779212;118.699853,35.781971;118.699348,35.784734;118.699114,35.787488;118.700619,35.791372;118.702054,35.792962;118.704655,35.795679;118.706656,35.797261;118.708387,35.798616;118.711257,35.801336;118.713275,35.803373;118.715293,35.805647;118.716736,35.807234;118.71878,35.810419;118.720232,35.812236;118.722267,35.815193;118.723631,35.817496;118.723429,35.818001;118.721005,35.817872;118.720391,35.818454;118.720294,35.819811;118.721102,35.820425;118.720811,35.821977;118.720326,35.822785;118.720779,35.823172;118.720068,35.827891;118.716771,35.832772;118.716803,35.834032;118.72273,35.836982;118.723338,35.839036;118.725903,35.840611;118.727954,35.844254;118.729971,35.846064;118.732831,35.848092;118.736515,35.848961;118.740746,35.849133;118.743282,35.849099;118.74554,35.849298;118.749769,35.849471;118.752895,35.850804;118.754372,35.853538;118.755275,35.856735;118.755891,35.859249;118.75623,35.861539;118.756847,35.864283;118.757186,35.866801;118.757238,35.869093;118.756726,35.871394;118.756483,35.873233;118.756015,35.877371;118.756345,35.879889;118.757239,35.881942;118.758125,35.883991;118.759861,35.886032;118.760413,35.886874;118.760469,35.887859;118.761936,35.89105;118.763403,35.893322;118.765156,35.896281;118.765208,35.898345;118.768558,35.897606;118.770822,35.89757;118.775029,35.897053;118.777275,35.896788;118.778169,35.899065;118.77627,35.902307;118.774961,35.906689;118.774735,35.909444;118.774536,35.913119;118.774866,35.915402;118.775187,35.917234;118.777208,35.919499;118.77948,35.920154;118.783148,35.920327;118.786807,35.920269;118.790465,35.92044;118.792997,35.920403;118.796099,35.920811;118.798639,35.921231;118.802893,35.922308;118.805744,35.923873;118.806056,35.9257;118.805849,35.928683;118.804766,35.930764;118.803969,35.932612;118.803735,35.934681;118.804065,35.937661;118.804108,35.939721;118.80501,35.942229;118.806483,35.94496;118.808199,35.946307;118.810269,35.946827;118.813882,35.948744;118.817563,35.949367;118.819807,35.949337;118.823445,35.948586;118.830486,35.948929;118.837216,35.948873;118.846363,35.950473;118.859288,35.952447;118.872209,35.954419;118.883549,35.957299;118.893038,35.96327;118.895355,35.965991;118.896535,35.968493;118.897429,35.970542;118.897516,35.974213;118.897273,35.976051;118.89592,35.978136;118.894549,35.97999;118.892624,35.981858;118.890698,35.983724;118.888461,35.984904;118.88624,35.985856;118.883743,35.987962;118.881809,35.989601;118.879824,35.992314;118.886025,35.999879;118.889641,36.001618;118.896036,36.006404;118.904801,36.006844;118.923448,36.007252;118.933052,36.007219;118.941261,36.007458;118.956862,36.008424;118.966874,36.011141;118.974938,36.014142;118.981872,36.017404;118.988041,36.022288;118.997584,36.037129;118.997775,36.037292;118.997974,36.037049;118.999006,36.037311;118.998993,36.0384;119.00449,36.034229;119.009549,36.034495;119.012554,36.035313;119.014394,36.034456;119.022838,36.030114;119.023891,36.028287;119.024121,36.02629;119.023256,36.026563;119.019586,36.025331;119.018753,36.02478;119.017624,36.024034;119.014512,36.018844;119.01351,36.016516;119.014067,36.013416;119.015958,36.012534;119.0194,36.012544;119.021962,36.01233;119.023739,36.011228;119.024957,36.003589;119.015625,35.995917;119.015956,35.993591;119.018508,35.988061;119.020285,35.978761;119.021069,35.977432;119.023177,35.976774;119.025294,35.976448;119.027873,35.976569;119.040085,35.978701;119.044631,35.979322;119.052014,35.980283;119.055121,35.980068;119.058063,35.979464;119.060508,35.978195;119.062952,35.974655;119.064231,35.971112;119.064561,35.96851;119.064726,35.965795;119.066614,35.96397;119.070328,35.96237;119.074215,35.96149;119.078814,35.959279;119.082917,35.959837;119.088904,35.963165;119.091789,35.963278;119.095003,35.962394;119.099103,35.962174;119.105197,35.962618;119.109849,35.962728;119.116157,35.962615;119.121805,35.962722;119.125231,35.963718;119.134412,35.968581;119.140826,35.969237;119.153256,35.971211;119.155096,35.96578;119.158224,35.966868;119.16304,35.968381;119.165326,35.969484;119.170419,35.970532;119.172966,35.97094;119.175503,35.971122;119.178595,35.971062;119.180526,35.969647;119.181894,35.968014;119.18237,35.965026;119.182586,35.962267;119.182526,35.960435;119.182456,35.957915;119.182412,35.956079;119.18236,35.954245;119.182005,35.951272;119.181649,35.948754;119.18158,35.946232;119.181519,35.94394;119.182038,35.942096;119.181692,35.939811;119.180479,35.93639;119.180141,35.934563;119.180383,35.932724;119.180305,35.929972;119.179672,35.927233;119.179369,35.926237;119.179423,35.926157;119.180261,35.924955;119.180847,35.924406;119.182943,35.920118;119.183448,35.918769;119.183053,35.917879;119.181845,35.917361;119.178482,35.917302;119.17359,35.917968;119.169665,35.9172;119.163202,35.913096;119.15178,35.905489;119.144686,35.904439;119.135959,35.896901;119.134514,35.895058;119.135606,35.892966;119.139754,35.891624;119.148762,35.887837;119.156234,35.882916;119.158235,35.882472;119.159948,35.883942;119.160507,35.886306;119.160411,35.893028;119.161875,35.894464;119.165371,35.894901;119.169133,35.894826;119.17145,35.894047;119.173694,35.892297;119.175984,35.889789;119.181653,35.886142;119.190599,35.879451;119.192424,35.878815;119.196045,35.877828;119.207878,35.878748;119.217081,35.879512;119.22424,35.88121;119.230256,35.882015;119.236283,35.883126;119.240438,35.884272;119.242745,35.886366;119.244437,35.888147;119.247283,35.88924;119.250989,35.890776;119.254417,35.892547;119.257863,35.894783;119.260442,35.89634;119.263889,35.898803;119.267059,35.90127;119.268796,35.902842;119.272227,35.90439;119.275694,35.907312;119.276335,35.907296;119.27883,35.908634;119.281976,35.910183;119.285391,35.911269;119.288798,35.912357;119.291058,35.912318;119.294414,35.911346;119.296891,35.909009;119.297952,35.906694;119.298186,35.904628;119.297795,35.900968;119.297168,35.898909;119.297107,35.896621;119.298116,35.893034;119.301111,35.890891;119.301971,35.891098;119.303258,35.892176;119.302743,35.892766;119.306906,35.893462;119.308323,35.894818;119.311241,35.894957;119.311584,35.896069;119.312485,35.89673;119.311929,35.897115;119.313731,35.897359;119.314503,35.895481;119.315472,35.890731;119.313884,35.890644;119.314936,35.890262;119.315106,35.889271;119.312614,35.888282;119.316012,35.887547;119.32318,35.888346;119.329248,35.89068;119.331617,35.890495;119.334986,35.893648;119.34178,35.894451;119.34552,35.893776;119.350687,35.890332;119.353652,35.888753;119.356974,35.886562;119.359174,35.884688;119.360661,35.884052;119.361366,35.882918;119.362678,35.879679;119.364269,35.876213;119.366164,35.873426;119.367216,35.870884;119.368302,35.869259;119.369085,35.867181;119.370432,35.865097;119.370927,35.862792;119.371423,35.860487;119.369275,35.856718;119.368858,35.8552;119.367675,35.853084;119.366075,35.850947;119.362918,35.849393;119.359483,35.847622;119.358283,35.845115;119.362308,35.842222;119.364209,35.838001;119.369377,35.833807;119.372357,35.830013;119.371905,35.826386;119.372063,35.823562;119.373696,35.822366;119.373617,35.819844;119.374077,35.816164;119.373443,35.813882;119.372825,35.81183;119.372199,35.809775;119.372112,35.806794;119.372581,35.803341;119.372485,35.800365;119.371833,35.797162;119.371485,35.794875;119.371711,35.792809;119.370772,35.79007;119.370397,35.786865;119.369771,35.784581;119.368832,35.781386;119.368206,35.779103;119.367293,35.777053;119.36724,35.775218;119.367475,35.773382;119.368805,35.770831;119.373316,35.770752;119.375846,35.77071;119.378132,35.771816;119.381556,35.773359;119.38557,35.775583;119.387577,35.776921;119.390444,35.778705;119.392511,35.781878;119.396533,35.78505;119.397722,35.786827;119.399728,35.788167;119.402307,35.789492;119.405189,35.791961;119.407471,35.793064;119.411177,35.794598;119.416053,35.797715;119.419184,35.799027;119.421465,35.800128;119.42515,35.801201;119.427716,35.802069;119.431651,35.802447;119.436452,35.803264;119.438964,35.802755;119.441796,35.803609;119.444334,35.804013;119.448898,35.806211;119.451461,35.807531;119.45572,35.809046;119.459373,35.809195;119.461614,35.809146;119.464686,35.808621;119.469954,35.806437;119.47299,35.804762;119.475178,35.803109;119.479597,35.800716;119.482373,35.799733;119.484578,35.798305;119.487033,35.796411;119.488952,35.794762;119.49139,35.792183;119.493283,35.789846;119.494623,35.787751;119.495946,35.785426;119.496741,35.78357;119.497242,35.781725;119.496602,35.779216;119.492599,35.776553;119.49061,35.775451;119.488025,35.773449;119.486563,35.771646;119.485327,35.767773;119.485249,35.76525;119.486519,35.760864;119.488092,35.754598;119.489579,35.753065;119.49206,35.751996;119.493815,35.751724;119.496098,35.751452;119.499175,35.752073;119.503178,35.752295;119.504068,35.752325;119.506247,35.751719;119.506912,35.75132;119.507707,35.750653;119.509989,35.748354;119.510914,35.746723;119.511346,35.744362;119.512401,35.74313;119.513922,35.741432;119.515608,35.739998;119.5168,35.739063;119.518356,35.737963;119.518456,35.737847;119.524356,35.733781;119.529448,35.732003;119.530754,35.73116;119.530728,35.730402;119.529439,35.729681;119.527537,35.729492;119.527252,35.729435;119.525453,35.730589;119.525246,35.730808;119.524719,35.731468;119.523673,35.731859;119.522479,35.731622;119.520482,35.728896;119.521139,35.727705;119.520525,35.726382;119.519003,35.724952;119.517836,35.72421;119.517767,35.723731;119.51838,35.722023;119.519841,35.718779;119.521077,35.71686;119.521172,35.714502;119.519651,35.712809;119.519365,35.711602;119.52086,35.71;119.520843,35.709329;119.519935,35.707648;119.519866,35.705411;119.519459,35.702579;119.518491,35.700643;119.517721,35.700031;119.515499,35.698776;119.514842,35.698008;119.514825,35.697623;119.515058,35.697321;119.515603,35.697119;119.51594,35.696276;119.515637,35.694798;119.515438,35.693831;119.515568,35.693342;119.515844,35.693119;119.517435,35.693082;119.517971,35.692753;119.518429,35.692206;119.518481,35.69187;119.518343,35.691436;119.518144,35.691076;119.518446,35.688965;119.519111,35.685537;119.519855,35.684414;119.523927,35.681512;119.527384,35.677221;119.528266,35.67432;119.527557,35.6708;119.526778,35.663262;119.527425,35.653846;119.526534,35.651568;119.52522,35.64992;119.524485,35.648534;119.524433,35.647095;119.526294,35.64663;119.526369,35.644951;119.523681,35.642639;119.523351,35.637164;119.523144,35.636803;119.520178,35.637543;119.519374,35.636551;119.51988,35.635141;119.522288,35.634492;119.524207,35.633506;119.524466,35.632287;119.518578,35.62784;119.517774,35.625786;119.517696,35.623313;119.517981,35.619041;119.518144,35.615429;119.518724,35.614203;119.522562,35.610876;119.530524,35.607375;119.536872,35.606025;119.537529,35.605124;119.538756,35.598184;119.538419,35.595449;119.536447,35.593424;119.536248,35.592217;119.537588,35.591314;119.538193,35.589276;119.540174,35.588889;119.543669,35.589779;119.547146,35.591099;119.550486,35.591122;119.556517,35.592523;119.558837,35.592469;119.559971,35.592076;119.563113,35.589627;119.564672,35.589555;119.565962,35.590524;119.567624,35.590358;119.569833,35.58832;119.570733,35.586812;119.573418,35.586309;119.576467,35.585508;119.577584,35.586254;119.576275,35.589339;119.575333,35.592124;119.5771,35.592747;119.578451,35.593158;119.582741,35.592986;119.58411,35.594761;119.586745,35.597118;119.592346,35.600695;119.594505,35.600623;119.597731,35.599149;119.598268,35.598026;119.599343,35.593631;119.600592,35.590254;119.602778,35.59007;119.609277,35.59204;119.611178,35.594048;119.61413,35.600187;119.614252,35.60524;119.615007,35.606335;119.617281,35.606855;119.619001,35.606819;119.623498,35.601974;119.626042,35.601657;119.632305,35.602096;119.633339,35.601799;119.63412,35.60078;119.634702,35.598744;119.635215,35.598254;119.63637,35.597243;119.637595,35.596292;119.638664,35.595016;119.639715,35.59441;119.641757,35.593915;119.642444,35.593888;119.644799,35.592317;119.651447,35.588762;119.653516,35.588423;119.656272,35.588427;119.659028,35.588639;119.662149,35.589281',
      bounds1: '118.798026,35.703523;118.800036,35.705787;118.80235,35.708962;118.80352,35.711236;118.804431,35.713974;118.80586,35.715789;118.806476,35.718074;118.806822,35.72082;118.806892,35.724033;118.806372,35.726103;118.80419,35.728664;118.801399,35.729626;118.798887,35.730127;118.796356,35.730167;118.793279,35.730217;118.790453,35.729343;118.786509,35.728944;118.783414,35.728535;118.780596,35.728118;118.776927,35.727483;118.773267,35.727082;118.770456,35.726892;118.767923,35.726929;118.764261,35.726524;118.761163,35.726338;118.757222,35.725939;118.754141,35.726438;118.751901,35.726931;118.749383,35.727425;118.746309,35.728612;118.743512,35.72934;118.738161,35.729413;118.735633,35.729216;118.732548,35.729713;118.728889,35.729989;118.726082,35.730256;118.722153,35.730996;118.717111,35.732433;118.714319,35.733387;118.712111,35.735479;118.709868,35.735964;118.707093,35.738061;118.705163,35.740383;118.704084,35.742229;118.703302,35.745224;118.70365,35.748201;118.704833,35.751169;118.70546,35.754146;118.7064,35.758494;118.706452,35.761017;118.706496,35.763081;118.706539,35.765146;118.704913,35.768146;118.703826,35.769996;118.702183,35.772309;118.701948,35.774376;118.701148,35.776908;118.700357,35.779212;118.699853,35.781971;118.699348,35.784734;118.699114,35.787488;118.700619,35.791372;118.702054,35.792962;118.704655,35.795679;118.706656,35.797261;118.708387,35.798616;118.711257,35.801336;118.713275,35.803373;118.715293,35.805647;118.716736,35.807234;118.71878,35.810419;118.720232,35.812236;118.722267,35.815193;118.723631,35.817496;118.723429,35.818001;118.721005,35.817872;118.720391,35.818454;118.720294,35.819811;118.721102,35.820425;118.720811,35.821977;118.720326,35.822785;118.720779,35.823172;118.720068,35.827891;118.716771,35.832772;118.716803,35.834032;118.72273,35.836982;118.723338,35.839036;118.725903,35.840611;118.727954,35.844254;118.729971,35.846064;118.732831,35.848092;118.736515,35.848961;118.740746,35.849133;118.743282,35.849099;118.74554,35.849298;118.749769,35.849471;118.752895,35.850804;118.754372,35.853538;118.755275,35.856735;118.755891,35.859249;118.75623,35.861539;118.756847,35.864283;118.757186,35.866801;118.757238,35.869093;118.756726,35.871394;118.756483,35.873233;118.756015,35.877371;118.756345,35.879889;118.757239,35.881942;118.758125,35.883991;118.759861,35.886032;118.760413,35.886874;118.760469,35.887859;118.761936,35.89105;118.763403,35.893322;118.765156,35.896281;118.765208,35.898345;118.768558,35.897606;118.770822,35.89757;118.775029,35.897053;118.777275,35.896788;118.778169,35.899065;118.77627,35.902307;118.774961,35.906689;118.774735,35.909444;118.774536,35.913119;118.774866,35.915402;118.775187,35.917234;118.777208,35.919499;118.77948,35.920154;118.783148,35.920327;118.786807,35.920269;118.790465,35.92044;118.792997,35.920403;118.796099,35.920811;118.798639,35.921231;118.802893,35.922308;118.805744,35.923873;118.806056,35.9257;118.805849,35.928683;118.804766,35.930764;118.803969,35.932612;118.803735,35.934681;118.804065,35.937661;118.804108,35.939721;118.80501,35.942229;118.806483,35.94496;118.808199,35.946307;118.810269,35.946827;118.813882,35.948744;118.817563,35.949367;118.819807,35.949337;118.823445,35.948586;118.830486,35.948929;118.837216,35.948873;118.846363,35.950473;118.859288,35.952447;118.872209,35.954419;118.883549,35.957299;118.893038,35.96327;118.895355,35.965991;118.896535,35.968493;118.897429,35.970542;118.897516,35.974213;118.897273,35.976051;118.89592,35.978136;118.894549,35.97999;118.892624,35.981858;118.890698,35.983724;118.888461,35.984904;118.88624,35.985856;118.883743,35.987962;118.881809,35.989601;118.879824,35.992314;118.886025,35.999879;118.889641,36.001618;118.896036,36.006404;118.904801,36.006844;118.923448,36.007252;118.933052,36.007219;118.941261,36.007458;118.956862,36.008424;118.966874,36.011141;118.974938,36.014142;118.981872,36.017404;118.988041,36.022288;118.997584,36.037129;118.997775,36.037292;118.997974,36.037049;118.999006,36.037311;118.998993,36.0384;119.00449,36.034229;119.009549,36.034495;119.012554,36.035313;119.014394,36.034456;119.022838,36.030114;119.023891,36.028287;119.024121,36.02629;119.023256,36.026563;119.019586,36.025331;119.018753,36.02478;119.017624,36.024034;119.014512,36.018844;119.01351,36.016516;119.014067,36.013416;119.015958,36.012534;119.0194,36.012544;119.021962,36.01233;119.023739,36.011228;119.024957,36.003589;119.015625,35.995917;119.015956,35.993591;119.018508,35.988061;119.020285,35.978761;119.021069,35.977432;119.023177,35.976774;119.025294,35.976448;119.027873,35.976569;119.040085,35.978701;119.044631,35.979322;119.052014,35.980283;119.055121,35.980068;119.058063,35.979464;119.060508,35.978195;119.062952,35.974655;119.064231,35.971112;119.064561,35.96851;119.064726,35.965795;119.066614,35.96397;119.070328,35.96237;119.074215,35.96149;119.078814,35.959279;119.07371,35.956392;119.069944,35.956166;119.0665,35.955939;119.063838,35.955934;119.062062,35.955488;119.0608,35.954499;119.060507,35.954849;119.05797,35.957263;119.05687,35.957519;119.055739,35.957132;119.054528,35.956076;119.053524,35.95402;119.053515,35.951847;119.056323,35.944845;119.056237,35.934361;119.053916,35.9277;119.047353,35.923199;119.046526,35.922529;119.046147,35.921145;119.05321,35.913689;119.05773,35.910336;119.063085,35.906844;119.063852,35.904028;119.060472,35.897902;119.058558,35.897287;119.056814,35.899625;119.055528,35.899846;119.054409,35.899294;119.054034,35.895662;119.053056,35.894564;119.051394,35.894097;119.047827,35.894579;119.046909,35.894592;119.046479,35.893626;119.04604,35.893113;119.045235,35.892463;119.044675,35.892483;119.04243,35.894758;119.041509,35.895908;119.039031,35.897043;119.034842,35.900678;119.032703,35.901049;119.030352,35.901082;119.029314,35.900692;119.028958,35.89956;119.028907,35.89759;119.029972,35.890551;119.029654,35.885402;119.03002,35.882668;119.03281,35.876084;119.035873,35.872289;119.036447,35.870411;119.037723,35.865542;119.03845,35.863561;119.038641,35.862814;119.037781,35.859993;119.036335,35.857108;119.033722,35.854442;119.031004,35.852551;119.02833,35.851989;119.025551,35.851925;119.021717,35.851803;119.018162,35.851517;119.015879,35.850457;119.011217,35.846178;119.008324,35.844563;119.001431,35.8436;118.998765,35.844369;118.994095,35.846515;118.990871,35.847669;118.987699,35.847493;118.983866,35.847592;118.980233,35.846277;118.977097,35.845403;118.97485,35.845659;118.971489,35.847077;118.969573,35.849625;118.968206,35.851252;118.96683,35.852879;118.964053,35.854748;118.960397,35.855256;118.956976,35.853924;118.950378,35.849656;118.94722,35.847406;118.937946,35.837214;118.934659,35.829691;118.93405,35.827632;118.933719,35.825576;118.932241,35.823069;118.931085,35.821481;118.929641,35.819901;118.928468,35.818306;118.92699,35.81512;118.926373,35.813292;118.925755,35.811006;118.92539,35.807341;118.925042,35.804822;118.925815,35.801599;118.926041,35.799072;118.925989,35.797007;118.925928,35.794489;118.926431,35.792184;118.927326,35.78719;118.929759,35.78366;118.93374,35.779691;118.936262,35.778965;118.938505,35.778247;118.940444,35.777072;118.942949,35.775429;118.947142,35.773997;118.951623,35.772788;118.954443,35.772524;118.957289,35.773628;118.959578,35.775435;118.963026,35.777681;118.96475,35.779033;118.967589,35.779915;118.971577,35.781469;118.974991,35.782342;118.978371,35.782069;118.982639,35.781779;118.985967,35.780735;118.989304,35.778861;118.991857,35.777151;118.99447,35.775331;118.996753,35.773344;118.999088,35.770803;119.001362,35.767983;119.003531,35.765165;119.009152,35.762579;119.015321,35.761045;119.019651,35.760448;119.023711,35.760074;119.028049,35.759864;119.03338,35.759434;119.038824,35.758841;119.042995,35.758241;119.044658,35.757692;119.045268,35.757194;119.046269,35.755978;119.046878,35.754373;119.045598,35.748387;119.045937,35.747335;119.048549,35.745567;119.053711,35.741204;119.056983,35.738827;119.061203,35.734458;119.063534,35.731417;119.066805,35.727766;119.068309,35.725662;119.069362,35.724058;119.071362,35.722454;119.072301,35.720849;119.072579,35.718965;119.072631,35.715641;119.073187,35.713924;119.074743,35.711545;119.07696,35.709331;119.07929,35.707894;119.081393,35.706733;119.082836,35.706013;119.085052,35.704076;119.087103,35.701972;119.087936,35.699758;119.089822,35.698539;119.092151,35.698155;119.095252,35.698378;119.096746,35.697879;119.097414,35.696883;119.097527,35.695995;119.096415,35.693559;119.096745,35.692506;119.098412,35.691731;119.105115,35.690401;119.10843,35.689458;119.110869,35.687686;119.111589,35.685358;119.111424,35.682588;119.111198,35.680593;119.111198,35.678932;119.110147,35.676937;119.101232,35.670732;119.100624,35.669457;119.104886,35.665191;119.110588,35.662976;119.111638,35.662087;119.110979,35.659873;119.108818,35.657214;119.099155,35.652563;119.097018,35.649844;119.09621,35.647334;119.095576,35.64397;119.094143,35.640756;119.091475,35.63743;119.089371,35.635433;119.088424,35.634268;119.087373,35.632995;119.086808,35.631648;119.087259,35.629503;119.088484,35.62679;119.090256,35.624518;119.090699,35.623189;119.09003,35.622746;119.082905,35.622076;119.078124,35.622147;119.074951,35.622621;119.071568,35.623556;119.069515,35.623666;119.067297,35.622942;119.063966,35.620886;119.061355,35.619828;119.059414,35.617664;119.055672,35.613301;119.054505,35.611714;119.052747,35.609215;119.05158,35.607395;119.050806,35.605346;119.050048,35.602369;119.049682,35.599159;119.049917,35.597318;119.050116,35.594105;119.050325,35.590888;119.05083,35.588817;119.054546,35.580042;119.067124,35.551905;119.065123,35.550627;119.064236,35.549572;119.063627,35.548132;119.063514,35.546579;119.0634,35.544472;119.062791,35.542754;119.061346,35.540922;119.05569,35.539471;119.050075,35.537852;119.047246,35.53646;119.044747,35.535013;119.042909,35.534011;119.041525,35.532789;119.040079,35.530401;119.038799,35.529512;119.038241,35.528292;119.037692,35.526573;119.037797,35.525132;119.039852,35.522477;119.041689,35.520931;119.043134,35.518884;119.043517,35.516114;119.043516,35.508355;119.044299,35.505643;119.044186,35.503203;119.043245,35.49777;119.043297,35.495887;119.043959,35.495389;119.044516,35.493894;119.044742,35.491401;119.043688,35.487742;119.042294,35.48336;119.041371,35.480945;119.036418,35.482686;119.034053,35.482884;119.033343,35.482401;119.033262,35.481086;119.033071,35.481244;119.032706,35.481253;119.032513,35.481297;119.031987,35.481331;119.031794,35.481366;119.031719,35.481332;119.031849,35.481236;119.031977,35.480938;119.032148,35.480887;119.032427,35.480825;119.033007,35.480843;119.033136,35.480686;119.03335,35.480432;119.033243,35.479968;119.03276,35.479977;119.032728,35.480108;119.03261,35.480162;119.032278,35.480144;119.032256,35.480319;119.032105,35.480336;119.032084,35.480415;119.031966,35.480467;119.03188,35.480467;119.03173,35.480475;119.031462,35.480502;119.031365,35.480702;119.031151,35.480711;119.030979,35.480694;119.030957,35.480632;119.031022,35.48059;119.031,35.480301;119.030937,35.480301;119.030947,35.480031;119.030947,35.479872;119.03099,35.479821;119.031022,35.479742;119.031161,35.479751;119.031151,35.479812;119.031204,35.479821;119.031215,35.479759;119.031247,35.47976;119.031269,35.479882;119.031494,35.479856;119.031472,35.479524;119.031451,35.479498;119.031451,35.479402;119.031505,35.479323;119.031612,35.479157;119.031837,35.479086;119.031762,35.478615;119.031376,35.478614;119.031043,35.478711;119.030711,35.478641;119.030582,35.478991;119.03099,35.479086;119.030807,35.479724;119.030636,35.479952;119.030658,35.480162;119.030571,35.480187;119.030346,35.480258;119.030153,35.480099;119.03011,35.480004;119.029939,35.479908;119.029563,35.479952;119.029359,35.479872;119.02908,35.479707;119.029026,35.479636;119.028747,35.479594;119.028426,35.479524;119.028307,35.479393;119.028232,35.479349;119.028179,35.479427;119.027449,35.479244;119.02731,35.479183;119.027074,35.479209;119.027106,35.480258;119.026977,35.48066;119.026666,35.48058;119.026484,35.479872;119.026387,35.479872;119.026119,35.479856;119.025829,35.479856;119.025669,35.479768;119.025475,35.479821;119.025303,35.479498;119.025218,35.47927;119.024939,35.47886;119.024874,35.478825;119.024821,35.478729;119.024789,35.478807;119.024627,35.478772;119.024585,35.478439;119.024499,35.478282;119.024499,35.478212;119.024402,35.478221;119.024381,35.478458;119.024413,35.479734;119.024263,35.479716;119.024188,35.478519;119.02422,35.478379;119.024273,35.478205;119.024177,35.478161;119.024059,35.478283;119.024102,35.479724;119.023855,35.479742;119.023716,35.478921;119.023726,35.478572;119.023823,35.478256;119.023855,35.477925;119.023726,35.477846;119.02349,35.477793;119.023254,35.477959;119.023072,35.478108;119.023147,35.478143;119.023169,35.478309;119.023179,35.478449;119.023201,35.478588;119.023147,35.478598;119.023072,35.478423;119.023019,35.478388;119.022932,35.478309;119.022858,35.478318;119.022771,35.478414;119.022604,35.478451;119.02254,35.478241;119.022475,35.477874;119.022368,35.477612;119.022219,35.477245;119.022196,35.477052;119.022196,35.476651;119.022218,35.476424;119.022176,35.476144;119.021982,35.475916;119.021939,35.475741;119.021897,35.475637;119.021831,35.475409;119.02166,35.475428;119.021402,35.475322;119.021209,35.475236;119.020995,35.475306;119.020415,35.475096;119.021059,35.474729;119.021295,35.475026;119.021402,35.474921;119.021359,35.474554;119.02151,35.474379;119.021696,35.472592;119.021459,35.472561;119.021266,35.472596;119.020692,35.472466;119.020579,35.472408;119.020596,35.472291;119.020504,35.472195;119.020418,35.472147;119.020424,35.472099;119.020456,35.472081;119.020504,35.471958;119.020585,35.471946;119.020719,35.471793;119.020939,35.471365;119.02089,35.471365;119.020799,35.471347;119.020751,35.471247;119.020783,35.471215;119.021057,35.471215;119.021111,35.471173;119.021368,35.470941;119.021551,35.470727;119.02169,35.470582;119.021793,35.470482;119.021754,35.470417;119.02169,35.470394;119.02169,35.470334;119.021566,35.470254;119.021411,35.470378;119.021357,35.470474;119.021357,35.470604;119.021411,35.470717;119.021314,35.470902;119.0211,35.471111;119.020971,35.471186;119.020901,35.471181;119.020799,35.471067;119.020729,35.471064;119.020634,35.471089;119.020521,35.471046;119.020414,35.471016;119.020434,35.470779;119.020392,35.470701;119.020182,35.47067;119.019919,35.470701;119.019651,35.470771;119.019464,35.470728;119.019291,35.470483;119.019505,35.469959;119.018948,35.469539;119.018561,35.469468;119.018132,35.469469;119.016802,35.469608;119.016244,35.469329;119.016201,35.468875;119.015815,35.468734;119.015343,35.468631;119.015471,35.468281;119.015214,35.46793;119.014613,35.467966;119.013669,35.468106;119.013241,35.467897;119.012553,35.467897;119.011867,35.46793;119.011353,35.468071;119.010407,35.468036;119.009764,35.467827;119.008904,35.468211;119.008549,35.468036;119.007713,35.467914;119.006661,35.467984;119.006575,35.467774;119.006683,35.467599;119.00649,35.467354;119.006189,35.467302;119.005481,35.467214;119.005266,35.467214;119.00501,35.467284;119.004751,35.467284;119.004816,35.467774;119.004537,35.468071;119.004623,35.468141;119.004666,35.468664;119.004987,35.469015;119.004903,35.469155;119.004644,35.46905;119.004451,35.468787;119.004431,35.468542;119.004258,35.468472;119.004344,35.46912;119.004323,35.469277;119.004194,35.469452;119.004172,35.469399;119.004022,35.469207;119.003292,35.469417;119.003314,35.468998;119.003657,35.468542;119.003272,35.468194;119.003249,35.468036;119.002928,35.467897;119.002563,35.467425;119.002499,35.467495;119.001856,35.468001;119.001704,35.468001;119.001426,35.467862;119.000803,35.467914;119.000374,35.467756;119.000139,35.467599;118.999559,35.467494;118.999323,35.468071;118.999022,35.468542;118.998744,35.468857;118.998464,35.468753;118.998336,35.469032;118.998185,35.469015;118.997736,35.469242;118.997789,35.469609;118.997359,35.470168;118.997316,35.471042;118.997574,35.471741;118.996716,35.472196;118.996416,35.472126;118.996286,35.471741;118.996286,35.471566;118.996243,35.471217;118.995514,35.470622;118.995601,35.471112;118.9953,35.471252;118.994741,35.471042;118.994398,35.470937;118.994355,35.470552;118.994141,35.470378;118.993926,35.470797;118.993068,35.471251;118.992811,35.471846;118.992811,35.47237;118.992982,35.472825;118.992982,35.473419;118.991653,35.473663;118.989365,35.474485;118.988571,35.474537;118.988206,35.474781;118.987519,35.474886;118.986662,35.474799;118.986167,35.474922;118.985911,35.475044;118.985695,35.475079;118.984901,35.474834;118.984451,35.474485;118.984365,35.474223;118.984408,35.473891;118.985867,35.473174;118.986511,35.473174;118.987477,35.473192;118.987863,35.473034;118.988099,35.472737;118.987776,35.472196;118.987583,35.472073;118.987283,35.472196;118.987154,35.471933;118.987176,35.471636;118.987091,35.471182;118.986811,35.4705;118.986296,35.470431;118.986167,35.470116;118.985417,35.469295;118.985309,35.469137;118.985031,35.468998;118.984644,35.468875;118.98428,35.4687;118.984001,35.468631;118.983485,35.468526;118.983442,35.46884;118.983184,35.469085;118.982627,35.46919;118.982434,35.46912;118.982519,35.468665;118.982391,35.468578;118.982154,35.46884;118.981361,35.469085;118.981296,35.469172;118.981017,35.468464;118.981103,35.468009;118.981447,35.467625;118.981403,35.467101;118.981274,35.466646;118.980888,35.466192;118.980556,35.465633;118.980362,35.465091;118.980272,35.464829;118.980035,35.464706;118.979939,35.464636;118.979853,35.464636;118.979811,35.464523;118.979811,35.46419;118.979661,35.464077;118.979542,35.463937;118.980239,35.464147;118.98082,35.464409;118.980809,35.464479;118.980926,35.464497;118.981001,35.464593;118.980991,35.464663;118.981238,35.464663;118.981344,35.464724;118.981473,35.464715;118.981516,35.464749;118.981548,35.464654;118.981698,35.464706;118.981634,35.464261;118.981044,35.464138;118.981001,35.463981;118.981023,35.463859;118.981044,35.463727;118.981088,35.463579;118.981088,35.463403;118.981002,35.463256;118.980959,35.463238;118.980959,35.463142;118.980894,35.46309;118.980873,35.462915;118.980851,35.462574;118.980809,35.462461;118.980819,35.462356;118.980798,35.462286;118.980841,35.462295;118.980981,35.462251;118.981034,35.462321;118.981387,35.462496;118.981571,35.462452;118.981623,35.462513;118.981741,35.462548;118.981784,35.462477;118.981849,35.462478;118.98202,35.462417;118.98216,35.462399;118.98231,35.462382;118.982568,35.462181;118.982675,35.462181;118.982771,35.462321;118.983222,35.462565;118.983544,35.46267;118.983953,35.462705;118.984273,35.462487;118.984424,35.462295;118.984456,35.462076;118.984424,35.461893;118.984402,35.461639;118.984263,35.461342;118.984338,35.461167;118.984488,35.460948;118.984574,35.46066;118.984585,35.460459;118.984511,35.4601;118.984039,35.459777;118.984006,35.459663;118.983587,35.459541;118.983469,35.459506;118.983362,35.45934;118.983421,35.459025;118.984236,35.458816;118.985137,35.458676;118.985439,35.458466;118.985223,35.457802;118.984794,35.457417;118.983336,35.457313;118.982529,35.457364;118.981521,35.457049;118.980964,35.4567;118.980728,35.456386;118.980577,35.456333;118.980449,35.456071;118.980405,35.455861;118.980341,35.455722;118.980019,35.455617;118.979718,35.455687;118.979439,35.455722;118.979439,35.455599;118.979332,35.455599;118.978732,35.455599;118.978646,35.455511;118.979869,35.455336;118.979869,35.455197;118.979676,35.454969;118.979419,35.454759;118.979332,35.454759;118.978646,35.454988;118.978539,35.454848;118.978474,35.454689;118.978453,35.454533;118.978624,35.454358;118.978796,35.454253;118.978989,35.454287;118.979033,35.454446;118.979075,35.454568;118.979419,35.454446;118.979569,35.454341;118.979525,35.454323;118.979419,35.453834;118.979417,35.453793;118.979282,35.453793;118.979213,35.453715;118.97904,35.453689;118.978976,35.453566;118.978719,35.45353;118.978751,35.453347;118.978869,35.452994;118.978913,35.452915;118.978901,35.452465;118.979008,35.452442;118.979149,35.452442;118.979546,35.452434;118.979529,35.452255;118.979385,35.452247;118.979319,35.452203;118.979239,35.452198;118.979132,35.452137;118.978896,35.452146;118.978756,35.452107;118.978842,35.451957;118.978736,35.451901;118.978869,35.451718;118.97911,35.451845;118.979239,35.451879;118.97926,35.451569;118.979233,35.451416;118.979256,35.451281;118.979158,35.451184;118.979036,35.451102;118.978896,35.451071;118.978509,35.450686;118.978166,35.450691;118.977721,35.450769;118.977656,35.450764;118.977034,35.450992;118.977002,35.450896;118.976691,35.451001;118.976653,35.450887;118.977141,35.450673;118.977453,35.450567;118.977834,35.450442;118.978069,35.450437;118.978096,35.450437;118.978204,35.450564;118.978355,35.450551;118.978146,35.450332;118.977919,35.45007;118.9783,35.449978;118.978526,35.449943;118.978509,35.449887;118.978359,35.449869;118.977656,35.449974;118.977388,35.449996;118.977356,35.450031;118.977116,35.45007;118.976493,35.450104;118.976456,35.450083;118.976621,35.449939;118.976761,35.449886;118.976814,35.449834;118.976921,35.449812;118.977141,35.449807;118.977324,35.449777;118.97727,35.449632;118.977318,35.449619;118.977302,35.449524;118.978403,35.449384;118.978408,35.449467;118.978837,35.44934;118.978869,35.449357;118.978896,35.449423;118.979213,35.449485;118.979358,35.449489;118.979748,35.449292;118.979872,35.449218;118.979748,35.449096;118.979636,35.449083;118.979534,35.449096;118.979502,35.449052;118.979444,35.449039;118.979384,35.448965;118.979019,35.449109;118.978784,35.449209;118.97859,35.449257;118.978482,35.449257;118.978381,35.449292;118.977957,35.449362;118.977706,35.449362;118.977485,35.449397;118.977276,35.449414;118.97712,35.449463;118.977056,35.449532;118.977056,35.449562;118.976997,35.449611;118.976761,35.449664;118.976574,35.449708;118.975994,35.449804;118.975929,35.449677;118.975747,35.449651;118.97565,35.449594;118.975387,35.449533;118.975358,35.449096;118.975207,35.449078;118.975229,35.448886;118.975143,35.448798;118.974992,35.448781;118.975019,35.448659;118.974933,35.44865;118.974891,35.449017;118.974731,35.449008;118.974473,35.449061;118.974461,35.449507;118.974259,35.449489;118.974269,35.449987;118.974108,35.44997;118.974108,35.449847;118.974141,35.449716;118.974119,35.449479;118.974216,35.449454;118.974182,35.448869;118.974129,35.448763;118.974043,35.448729;118.973968,35.448624;118.974064,35.44844;118.973861,35.448414;118.973829,35.448545;118.973721,35.448684;118.973453,35.448711;118.973529,35.448606;118.973346,35.448292;118.973292,35.448264;118.973121,35.448274;118.973174,35.448431;118.973003,35.448475;118.972874,35.448414;118.972831,35.448335;118.972648,35.448318;118.972605,35.448362;118.972423,35.448257;118.972412,35.448056;118.972466,35.44789;118.972509,35.447811;118.972487,35.447776;118.972649,35.447689;118.972841,35.447566;118.972927,35.447539;118.973024,35.447374;118.973089,35.447338;118.973089,35.44719;118.973239,35.447182;118.973142,35.446954;118.973099,35.446911;118.972982,35.446832;118.972971,35.446893;118.972874,35.446937;118.972863,35.447007;118.972702,35.447059;118.972649,35.446972;118.972671,35.446902;118.97253,35.446876;118.97238,35.446787;118.972273,35.446727;118.972165,35.446648;118.972199,35.446544;118.972337,35.44643;118.972531,35.446203;118.972596,35.446063;118.972573,35.445966;118.972519,35.445678;118.972434,35.445565;118.972305,35.445425;118.972081,35.445329;118.972015,35.445285;118.971876,35.445267;118.971683,35.445259;118.971641,35.44525;118.971597,35.445241;118.971532,35.445233;118.971414,35.445442;118.971479,35.445486;118.9715,35.445642;118.971479,35.445993;118.971296,35.446281;118.971146,35.446377;118.971007,35.446254;118.970879,35.446037;118.970761,35.445879;118.970706,35.445661;118.970686,35.445572;118.971051,35.44546;118.970985,35.445197;118.97089,35.444831;118.970835,35.444629;118.970696,35.444471;118.970546,35.444297;118.970471,35.444;118.970417,35.443939;118.970406,35.443729;118.97047,35.443563;118.970481,35.443441;118.970493,35.443317;118.970567,35.443249;118.970793,35.44289;118.970889,35.442698;118.970899,35.442584;118.970985,35.442506;118.971103,35.442182;118.971169,35.441745;118.971264,35.441326;118.971361,35.441055;118.971361,35.440854;118.97134,35.440635;118.970722,35.440162;118.970315,35.439639;118.969843,35.439184;118.969606,35.438677;118.969134,35.438223;118.968921,35.438153;118.968814,35.438083;118.968984,35.438012;118.968877,35.437872;118.969027,35.437697;118.968963,35.437244;118.968834,35.437244;118.968684,35.437104;118.968534,35.437104;118.968603,35.437166;118.968689,35.437367;118.96854,35.437821;118.968314,35.437952;118.968045,35.438014;118.967766,35.438014;118.967778,35.437708;118.967917,35.437489;118.967659,35.437087;118.967659,35.436806;118.968217,35.436134;118.968272,35.435452;118.968239,35.435076;118.968217,35.434194;118.968099,35.43359;118.967632,35.43256;118.967589,35.432245;118.967225,35.432035;118.967118,35.431877;118.966861,35.431807;118.966602,35.431755;118.965336,35.431598;118.964714,35.431685;118.964349,35.431965;118.964071,35.431703;118.964178,35.431178;118.963899,35.430864;118.963577,35.430549;118.963233,35.429919;118.962891,35.429605;118.962118,35.429308;118.961216,35.42908;118.959993,35.42894;118.959693,35.428924;118.959629,35.428714;118.959821,35.42805;118.960079,35.427017;118.960122,35.426581;118.960079,35.426074;118.960014,35.425112;118.960036,35.424797;118.960359,35.424186;118.960422,35.423574;118.960808,35.422892;118.960938,35.422245;118.960831,35.421353;118.960594,35.420898;118.960443,35.420566;118.960273,35.420321;118.960101,35.419919;118.960036,35.419551;118.960036,35.419377;118.960122,35.419132;118.959993,35.418835;118.959971,35.418624;118.959713,35.418466;118.959328,35.418448;118.958383,35.418361;118.958555,35.417889;118.958512,35.417731;118.95862,35.417731;118.958598,35.417399;118.958599,35.417032;118.95804,35.41691;118.957804,35.416944;118.957439,35.417172;118.956409,35.417522;118.956131,35.417487;118.956001,35.417364;118.955981,35.41691;118.956151,35.416541;118.956123,35.416333;118.955981,35.416193;118.955636,35.41628;118.955765,35.416612;118.954843,35.41684;118.954435,35.416752;118.954285,35.41635;118.953984,35.416525;118.952848,35.417959;118.952547,35.417819;118.952311,35.417731;118.952289,35.417487;118.952439,35.417277;118.952525,35.416927;118.952268,35.416892;118.952315,35.41669;118.952433,35.416559;118.952476,35.416402;118.952584,35.416322;118.952724,35.416105;118.952734,35.415598;118.952551,35.415484;118.952498,35.415492;118.952488,35.415423;118.952466,35.415396;118.952412,35.415545;118.952369,35.415598;118.952263,35.415545;118.952026,35.415449;118.952079,35.415283;118.951607,35.415134;118.951361,35.415283;118.950716,35.415388;118.95077,35.415038;118.950502,35.414994;118.950534,35.414706;118.950641,35.414687;118.950663,35.414574;118.95077,35.414539;118.950942,35.413691;118.951072,35.413691;118.951093,35.413377;118.951264,35.413359;118.951103,35.414653;118.95121,35.414687;118.951736,35.414942;118.951714,35.415081;118.951982,35.415073;118.952154,35.415055;118.952283,35.41509;118.952348,35.414898;118.952251,35.414862;118.952025,35.414872;118.951929,35.414784;118.951639,35.414767;118.951714,35.414487;118.951629,35.414478;118.951607,35.414522;118.951371,35.414504;118.951414,35.414417;118.951543,35.413613;118.951575,35.413289;118.951553,35.413211;118.951018,35.413176;118.950931,35.413176;118.951124,35.413036;118.951135,35.412931;118.951243,35.41287;118.951209,35.412634;118.951039,35.412529;118.950812,35.412511;118.950706,35.41259;118.950609,35.412616;118.950331,35.412757;118.950266,35.412852;118.950169,35.412844;118.949471,35.413238;118.949493,35.413342;118.949589,35.413377;118.949258,35.413675;118.949021,35.413832;118.948689,35.413876;118.948678,35.413622;118.948646,35.413124;118.94857,35.412905;118.948356,35.412923;118.948453,35.413194;118.948463,35.413919;118.948516,35.414024;118.948334,35.414086;118.948099,35.414051;118.947949,35.413631;118.947873,35.413307;118.947873,35.413124;118.947777,35.413097;118.947594,35.413149;118.947572,35.413273;118.947616,35.413273;118.947529,35.413657;118.947529,35.414007;118.947304,35.414032;118.947315,35.414102;118.947208,35.414138;118.947154,35.414068;118.947111,35.413841;118.947143,35.413605;118.947229,35.413307;118.947143,35.413299;118.946994,35.41364;118.947025,35.414208;118.946983,35.414226;118.946821,35.414182;118.946769,35.413955;118.946758,35.413657;118.946821,35.413456;118.946897,35.413412;118.947004,35.41322;118.947004,35.413168;118.947069,35.413054;118.947069,35.41294;118.947069,35.412835;118.946982,35.4128;118.946811,35.412774;118.946725,35.412827;118.946628,35.412826;118.94577,35.413289;118.945706,35.413325;118.945041,35.413246;118.944923,35.413359;118.944858,35.413587;118.945212,35.414199;118.945106,35.414278;118.94518,35.414558;118.945233,35.414584;118.94546,35.414959;118.945631,35.415144;118.945491,35.41517;118.945405,35.415091;118.945116,35.414907;118.945127,35.414846;118.944997,35.414864;118.944933,35.414811;118.944977,35.414602;118.944901,35.414628;118.944225,35.414434;118.944171,35.414339;118.944053,35.414348;118.944075,35.414261;118.944171,35.413946;118.944182,35.413604;118.944042,35.413561;118.943753,35.413561;118.943646,35.413683;118.943464,35.413666;118.943399,35.413587;118.943495,35.413474;118.943259,35.413394;118.943045,35.413168;118.943056,35.413019;118.942583,35.412984;118.941671,35.412669;118.941521,35.412564;118.941413,35.412634;118.941274,35.41266;118.941113,35.41259;118.941146,35.412486;118.941296,35.412354;118.94121,35.412302;118.941168,35.412241;118.941081,35.412293;118.940824,35.412197;118.940739,35.412118;118.940147,35.411961;118.940083,35.411978;118.940029,35.411935;118.939804,35.411847;118.939676,35.411777;118.939558,35.411908;118.939525,35.412031;118.939514,35.412092;118.939632,35.412258;118.939526,35.412363;118.939451,35.412328;118.939408,35.412241;118.939343,35.412057;118.939269,35.411996;118.939183,35.411969;118.938989,35.411961;118.938892,35.411943;118.938818,35.411908;118.938774,35.411899;118.938774,35.411838;118.938796,35.411777;118.938817,35.411759;118.938946,35.411786;118.939108,35.411777;118.939183,35.411707;118.939311,35.411699;118.939396,35.411541;118.939472,35.411428;118.939719,35.411629;118.940169,35.411829;118.940426,35.411672;118.940771,35.411454;118.940641,35.411358;118.940619,35.411305;118.940556,35.411288;118.940512,35.411253;118.940426,35.411244;118.940383,35.411199;118.940298,35.411235;118.940266,35.411183;118.940233,35.411087;118.940147,35.411052;118.940041,35.411043;118.940019,35.411007;118.939847,35.410964;118.939793,35.410955;118.93974,35.410955;118.939633,35.410912;118.939548,35.410894;118.939472,35.410877;118.939462,35.410868;118.939344,35.410798;118.939247,35.410773;118.939236,35.410754;118.93901,35.41106;118.938763,35.410982;118.938613,35.41106;118.938507,35.411034;118.938463,35.41099;118.93842,35.410929;118.938388,35.410868;118.938082,35.410843;118.937482,35.410756;118.937031,35.410615;118.937288,35.409968;118.937031,35.409846;118.936752,35.409828;118.936473,35.40995;118.936022,35.409846;118.935722,35.409986;118.935486,35.410021;118.935229,35.409968;118.935014,35.410056;118.934799,35.409968;118.934499,35.409985;118.933941,35.409968;118.933405,35.409776;118.932804,35.409495;118.932654,35.409549;118.932482,35.409549;118.932332,35.409495;118.932203,35.409356;118.931753,35.408988;118.932439,35.408429;118.932847,35.407834;118.932954,35.407362;118.932911,35.407222;118.93319,35.407292;118.933319,35.406995;118.932933,35.40647;118.932224,35.406085;118.931988,35.4057;118.932139,35.40535;118.932396,35.405018;118.932182,35.404617;118.931774,35.404143;118.931795,35.403829;118.931323,35.403234;118.930916,35.402657;118.93083,35.402203;118.929982,35.402289;118.929381,35.402534;118.927836,35.403024;118.927107,35.403409;118.926463,35.404108;118.926463,35.404388;118.926077,35.404738;118.925433,35.405577;118.92539,35.405962;118.925261,35.406662;118.925476,35.406663;118.925347,35.407641;118.925605,35.408096;118.925304,35.408727;118.925391,35.40904;118.925091,35.40953;118.923888,35.409705;118.922558,35.410334;118.921656,35.410929;118.921656,35.411454;118.921142,35.411699;118.920369,35.412783;118.920626,35.413972;118.919767,35.414358;118.919509,35.414847;118.919466,35.415862;118.918994,35.416526;118.918307,35.416526;118.917964,35.416281;118.917836,35.416141;118.917063,35.416001;118.917191,35.417156;118.917234,35.417855;118.917278,35.418589;118.917106,35.419184;118.914918,35.417785;118.912772,35.416491;118.912429,35.416246;118.911999,35.415757;118.911442,35.415477;118.910842,35.415613;118.911099,35.415193;118.911099,35.413969;118.911528,35.413375;118.909854,35.41201;118.909383,35.411766;118.908995,35.411136;118.908439,35.410681;118.908095,35.410576;118.907924,35.410472;118.907666,35.410472;118.907451,35.410297;118.907194,35.410018;118.907108,35.409632;118.906979,35.409457;118.906636,35.409073;118.906593,35.409037;118.906551,35.408864;118.906551,35.408758;118.906379,35.408302;118.905521,35.407953;118.905306,35.407569;118.905134,35.407393;118.904962,35.407113;118.905005,35.406799;118.905005,35.406414;118.904919,35.406204;118.905091,35.405924;118.905134,35.405749;118.905264,35.405539;118.904404,35.405469;118.901508,35.404314;118.899878,35.404106;118.899362,35.404035;118.899032,35.403979;118.897731,35.403756;118.896186,35.404314;118.895414,35.403896;118.894641,35.404874;118.893956,35.404454;118.894298,35.402705;118.894126,35.402495;118.893869,35.403125;118.892066,35.403966;118.892754,35.402916;118.892925,35.402286;118.889406,35.402426;118.888634,35.402426;118.888032,35.402427;118.887604,35.401656;118.887518,35.400957;118.887346,35.400746;118.886316,35.400746;118.885629,35.400257;118.885286,35.399698;118.884599,35.399068;118.884084,35.397948;118.884009,35.397248;118.884073,35.397004;118.883966,35.396864;118.883536,35.397318;118.882529,35.397966;118.882292,35.397948;118.882206,35.397949;118.882014,35.397721;118.881863,35.397494;118.88167,35.397283;118.881563,35.396969;118.881541,35.396706;118.881112,35.395989;118.879266,35.394712;118.878214,35.394818;118.877593,35.395011;118.877356,35.394887;118.877057,35.394556;118.876756,35.394224;118.876584,35.393979;118.876519,35.393785;118.876433,35.393681;118.876648,35.393278;118.876626,35.392946;118.874308,35.393174;118.873128,35.393121;118.872227,35.393051;118.871855,35.39297;118.871336,35.39355;118.870391,35.393848;118.869672,35.393956;118.86903,35.393939;118.868051,35.393782;118.866863,35.393048;118.865746,35.391701;118.863856,35.388376;118.862651,35.385871;118.860624,35.382792;118.859679,35.381708;118.857669,35.380221;118.855069,35.378842;118.851483,35.376939;118.849109,35.375418;118.847134,35.373109;118.845332,35.371659;118.844284,35.37117;118.843149,35.370803;118.842317,35.370752;118.841287,35.370754;118.838178,35.371268;118.836428,35.37171;118.834661,35.372467;118.8337,35.372695;118.832851,35.372733;118.831447,35.372682;118.829005,35.37225;118.827645,35.372076;118.826173,35.372062;118.823592,35.372188;118.822596,35.372349;118.820984,35.372738;118.819036,35.373196;118.817875,35.373287;118.816775,35.373306;118.814878,35.373012;118.812184,35.372682;118.808779,35.372442;118.806171,35.371956;118.804169,35.371329;118.800989,35.369898;118.799464,35.369479;118.79754,35.36943;118.79071,35.370314;118.787139,35.370722;118.78485,35.370953;118.784122,35.371057;118.783402,35.371286;118.782162,35.371813;118.780168,35.373129;118.778538,35.374355;118.776422,35.376251;118.774956,35.376758;118.773611,35.375971;118.773256,35.374622;118.773099,35.37098;118.772926,35.370489;118.77224,35.369507;118.771668,35.369211;118.768952,35.368019;118.765872,35.367287;118.764388,35.367042;118.761976,35.366936;118.760804,35.366814;118.759702,35.3665;118.758634,35.365992;118.756533,35.364871;118.754363,35.364152;118.753234,35.363854;118.751472,35.36373;118.749874,35.363608;118.74825,35.363345;118.746635,35.362695;118.743994,35.36103;118.742309,35.360206;118.74098,35.359697;118.739469,35.35952;118.73509,35.361551;118.733674,35.362424;118.732674,35.363319;118.729624,35.365014;118.727261,35.366817;118.723897,35.368469;118.722889,35.36754;118.72155,35.366487;118.720228,35.365749;118.718706,35.365126;118.715776,35.364106;118.714585,35.363735;118.712507,35.363549;118.712472,35.364503;118.712324,35.366036;118.712264,35.366246;118.712151,35.366368;118.711777,35.366893;118.711603,35.367427;118.711481,35.36762;118.711273,35.367831;118.71069,35.368373;118.710446,35.368915;118.710098,35.369388;118.709585,35.369824;118.70882,35.370103;118.707837,35.370575;118.706837,35.370889;118.706428,35.371257;118.706011,35.371537;118.704646,35.372008;118.70308,35.372653;118.700401,35.375155;118.698853,35.376622;118.697887,35.377776;118.697209,35.378653;118.696905,35.379807;118.696661,35.38;118.696261,35.380176;118.695713,35.380331;118.694886,35.380364;118.69386,35.380293;118.692503,35.379502;118.688579,35.375991;118.686342,35.373657;118.685133,35.372078;118.684132,35.370271;118.682923,35.368657;118.682557,35.368428;118.681417,35.367989;118.680939,35.367936;118.679642,35.367845;118.678851,35.367843;118.67785,35.367982;118.676554,35.368855;118.67524,35.369869;118.673944,35.370531;118.672534,35.37095;118.669507,35.371346;118.668202,35.371468;118.667062,35.371431;118.666183,35.371412;118.665061,35.371409;118.664191,35.371443;118.662294,35.371754;118.656944,35.3729;118.653839,35.373351;118.652308,35.373559;118.651134,35.373557;118.648716,35.373394;118.645751,35.372988;118.639368,35.371157;118.635847,35.370101;118.632074,35.368432;118.631414,35.368397;118.629084,35.368866;118.626608,35.369565;118.62573,35.370107;118.625435,35.3703;118.625191,35.371316;118.625244,35.373453;118.625313,35.376045;118.625436,35.381056;118.625453,35.382632;118.625401,35.383438;118.625123,35.385226;118.625054,35.386644;118.624915,35.387048;118.624594,35.387625;118.624089,35.388064;118.622882,35.388534;118.619146,35.388707;118.617322,35.388812;118.615646,35.389074;118.612997,35.389527;118.610566,35.389736;118.608186,35.390157;118.60612,35.390752;118.605027,35.398927;118.603578,35.406359;118.601713,35.409502;118.601044,35.413068;118.601409,35.414519;118.603654,35.415711;118.603683,35.415725;118.603904,35.415842;118.603923,35.415854;118.607329,35.417662;118.610768,35.418569;118.614815,35.420445;118.619045,35.423106;118.621408,35.423651;118.623824,35.423472;118.627569,35.422387;118.631801,35.421849;118.635668,35.421051;118.639006,35.421659;118.640753,35.423103;118.642244,35.425142;118.642111,35.427002;118.639314,35.429219;118.633854,35.430552;118.632584,35.430913;118.631924,35.432726;118.631803,35.435929;118.632107,35.440402;118.631682,35.442636;118.631438,35.443602;118.628475,35.446016;118.628779,35.447407;118.628901,35.449342;118.632891,35.452065;118.636159,35.452009;118.640515,35.451411;118.64208,35.451604;118.645715,35.452263;118.648011,35.453294;118.649403,35.455774;118.650977,35.458617;118.652734,35.459769;118.655762,35.460921;118.659328,35.461531;118.662051,35.461536;118.663808,35.460936;118.665679,35.459671;118.667801,35.456834;118.669071,35.456354;118.672821,35.456239;118.675066,35.456244;118.678268,35.456854;118.681844,35.458796;118.684385,35.459404;118.688439,35.459531;118.691406,35.459417;118.693581,35.459119;118.694912,35.458335;118.697034,35.456044;118.698243,35.45544;118.700783,35.455386;118.703932,35.455934;118.708046,35.45733;118.709133,35.457695;118.70962,35.458238;118.710099,35.459629;118.710829,35.46084;118.713186,35.462173;118.715299,35.463687;118.721838,35.467442;118.72389,35.468773;118.727524,35.473974;118.732296,35.482377;118.733321,35.484736;118.734356,35.486066;118.733182,35.487141;118.731088,35.48842;118.72909,35.490594;118.727648,35.493129;118.726431,35.495182;118.72504,35.496571;118.722928,35.497172;118.71972,35.498679;118.717317,35.500544;118.717289,35.500542;118.717245,35.5006;118.715912,35.501634;118.714399,35.502842;118.712286,35.504107;118.709078,35.505794;118.705808,35.507663;118.703146,35.509592;118.700789,35.511703;118.698849,35.513574;118.699641,35.516958;118.699398,35.520463;118.698729,35.523724;118.697398,35.526623;118.696554,35.528614;118.697399,35.530067;118.699521,35.531942;118.702905,35.534063;118.706054,35.536424;118.709264,35.538968;118.713256,35.543022;118.720273,35.547563;118.723669,35.550727;118.725107,35.553189;118.724925,35.55488;118.723716,35.557174;118.723178,35.559349;118.723422,35.561282;118.724021,35.562974;118.726839,35.563676;118.726925,35.565275;118.728741,35.565941;118.732488,35.56806;118.734842,35.569754;118.736537,35.572291;118.738171,35.574346;118.739683,35.577188;118.740464,35.579846;118.740586,35.581479;118.738771,35.587141;118.738233,35.588365;118.737442,35.589755;118.735818,35.593438;118.735575,35.595312;118.735576,35.599479;118.736844,35.601293;118.737331,35.603228;118.739688,35.624978;118.74272,35.630486;118.747402,35.635892;118.749121,35.637478;118.751431,35.640429;118.75401,35.642688;118.757144,35.644937;118.758594,35.646982;118.762596,35.650139;118.764609,35.652175;118.766605,35.653522;118.768054,35.655795;118.770084,35.658749;118.77267,35.661462;118.775255,35.663948;118.776762,35.664055;118.777492,35.663845;118.780068,35.663741;118.782298,35.664788;118.785046,35.667576;118.785429,35.668857;118.786247,35.671585;118.785583,35.674117;118.785725,35.674338;118.787326,35.676844;118.793086,35.677225;118.795439,35.678532;118.796412,35.679072;118.795972,35.682907;118.791185,35.686193;118.791506,35.688021;118.792353,35.690812;118.792407,35.69099;118.793578,35.693038;118.794185,35.694865;118.795078,35.697146;118.796248,35.699422;118.796403,35.699782;118.796426,35.699835;118.796456,35.699905;118.79653,35.700077;118.796737,35.700557;118.797132,35.701474;118.798026,35.703523',
      bounds2: '119.405197,35.203444;119.39073,35.205357;119.390714,35.205369;119.390687,35.205363;119.389071,35.205576;119.362895,35.205663;119.362824,35.206713;119.358154,35.206654;119.358111,35.207645;119.357011,35.206821;119.355775,35.206116;119.355523,35.206632;119.355977,35.206846;119.355497,35.207699;119.355124,35.207562;119.355026,35.207768;119.355044,35.208036;119.355493,35.208155;119.355413,35.20843;119.355706,35.208412;119.355576,35.20894;119.355389,35.211184;119.354904,35.211184;119.355092,35.212477;119.355416,35.213259;119.357139,35.213178;119.356656,35.210036;119.359052,35.209811;119.359483,35.213124;119.35881,35.213232;119.359074,35.215029;119.356677,35.215411;119.35679,35.217106;119.353951,35.217148;119.353923,35.220136;119.352058,35.220213;119.352026,35.221559;119.351733,35.222427;119.350533,35.222247;119.350233,35.223358;119.349784,35.223433;119.349682,35.223876;119.34863,35.223738;119.348464,35.224916;119.346748,35.224711;119.347078,35.223358;119.346302,35.223289;119.346734,35.221634;119.345268,35.221289;119.345303,35.220617;119.344659,35.22004;119.343406,35.220014;119.343061,35.222221;119.34213,35.222307;119.341854,35.22291;119.341509,35.22341;119.340975,35.223893;119.340406,35.224203;119.339647,35.224462;119.338785,35.224427;119.336906,35.2241;119.336789,35.225081;119.337865,35.225508;119.337106,35.22977;119.336748,35.230419;119.336099,35.230777;119.335009,35.23097;119.334361,35.230915;119.333313,35.230488;119.332541,35.230419;119.331403,35.230631;119.325426,35.232957;119.321769,35.233476;119.314039,35.231738;119.310077,35.232338;119.302971,35.240628;119.302587,35.242304;119.303097,35.245051;119.305672,35.249937;119.305249,35.252422;119.304418,35.254662;119.300472,35.25693;119.301009,35.258463;119.304014,35.260004;119.310749,35.264641;119.31158,35.267837;119.310832,35.270809;119.310576,35.272684;119.312946,35.2822;119.311301,35.287311;119.312147,35.290987;119.319124,35.297491;119.323437,35.300426;119.325182,35.300977;119.335453,35.299535;119.348251,35.295823;119.366326,35.295401;119.372713,35.296449;119.374151,35.30555;119.373292,35.309914;119.373826,35.311295;119.374842,35.312288;119.389031,35.31751;119.392901,35.319105;119.395005,35.326675;119.395061,35.345281;119.392359,35.372839;119.393377,35.373882;119.393116,35.376117;119.386679,35.375838;119.386181,35.37576;119.384447,35.375487;119.384576,35.373844;119.382918,35.373609;119.382602,35.373564;119.382401,35.3735;119.38211,35.373406;119.381227,35.373126;119.381034,35.373285;119.380113,35.373355;119.380027,35.373582;119.378589,35.373687;119.378675,35.375734;119.377708,35.374894;119.377408,35.375069;119.377216,35.375069;119.376722,35.376136;119.376486,35.376801;119.375396,35.376455;119.374834,35.376276;119.374756,35.376261;119.374546,35.376221;119.374122,35.376139;119.373567,35.376031;119.37331,35.376993;119.371057,35.376626;119.371136,35.376456;119.371228,35.376259;119.369919,35.375822;119.370391,35.37535;119.370648,35.375035;119.370241,35.374596;119.368846,35.375717;119.368503,35.375315;119.368847,35.374615;119.368975,35.37465;119.369146,35.37353;119.369383,35.373547;119.369404,35.373355;119.368782,35.373214;119.368782,35.373634;119.368181,35.373581;119.367731,35.374666;119.367086,35.374701;119.367752,35.375227;119.367709,35.375349;119.368353,35.375787;119.367602,35.37556;119.366894,35.375139;119.366443,35.374596;119.366186,35.37472;119.365884,35.375016;119.365306,35.374685;119.365091,35.37493;119.364598,35.374597;119.365263,35.374072;119.364791,35.373827;119.364039,35.374282;119.364104,35.374457;119.363933,35.37451;119.364104,35.374736;119.363718,35.374771;119.363332,35.374702;119.363225,35.374282;119.363246,35.373967;119.363224,35.373774;119.362881,35.373599;119.362602,35.373547;119.362517,35.373198;119.362538,35.37276;119.36228,35.372269;119.361679,35.372217;119.361401,35.371727;119.359962,35.371779;119.357838,35.371499;119.357516,35.370694;119.356099,35.370431;119.355177,35.370327;119.354919,35.370521;119.354618,35.370747;119.354511,35.370486;119.353631,35.370627;119.353524,35.370172;119.35273,35.370102;119.352591,35.369557;119.352501,35.369206;119.352385,35.368755;119.351484,35.36879;119.351936,35.369524;119.350626,35.369489;119.350541,35.369174;119.350347,35.368895;119.349982,35.368807;119.350046,35.368536;119.350121,35.368247;119.349681,35.368221;119.349294,35.36802;119.349016,35.367862;119.348694,35.3676;119.348587,35.367355;119.347824,35.366314;119.348136,35.366025;119.349263,35.366016;119.349617,35.365824;119.349704,35.365714;119.349896,35.365474;119.349707,35.365286;119.349542,35.365122;119.349293,35.364987;119.349028,35.364843;119.347847,35.364899;119.347569,35.364913;119.347264,35.365096;119.346989,35.365263;119.346288,35.365263;119.345573,35.365263;119.344779,35.365123;119.343921,35.364826;119.34302,35.364564;119.342547,35.364056;119.342033,35.363671;119.341818,35.363111;119.340917,35.362708;119.340552,35.362394;119.339521,35.362446;119.338341,35.362306;119.337632,35.362831;119.336517,35.363234;119.335865,35.363234;119.335487,35.363234;119.335242,35.363183;119.334649,35.363059;119.334144,35.362836;119.333704,35.362639;119.333254,35.362395;119.332802,35.36341;119.329734,35.36341;119.329778,35.364354;119.328576,35.363847;119.326903,35.363462;119.326323,35.36341;119.324814,35.363062;119.324499,35.362989;119.324293,35.362996;119.324098,35.363001;119.323651,35.363016;119.323304,35.362993;119.322997,35.362973;119.322782,35.362868;119.322846,35.361538;119.322632,35.361239;119.322331,35.361091;119.321902,35.361389;119.321902,35.361826;119.321924,35.361949;119.321923,35.363191;119.321623,35.363191;119.31995,35.362639;119.319338,35.362482;119.318736,35.362019;119.318414,35.362009;119.317771,35.361764;119.316794,35.361695;119.316483,35.361694;119.316215,35.361669;119.315775,35.361476;119.315109,35.361511;119.314863,35.361607;119.314327,35.361013;119.314649,35.360943;119.314413,35.36068;119.314788,35.360627;119.314155,35.359823;119.313812,35.359779;119.313318,35.35984;119.313222,35.360514;119.313361,35.361004;119.312535,35.361083;119.312149,35.36117;119.31208,35.360834;119.311998,35.360436;119.311569,35.360436;119.311204,35.360646;119.311181,35.360453;119.310946,35.360436;119.310818,35.360173;119.30968,35.360138;119.309273,35.360261;119.308822,35.359946;119.308499,35.359911;119.308286,35.359596;119.307728,35.359333;119.306698,35.358861;119.306397,35.358458;119.305797,35.357933;119.305089,35.357863;119.304724,35.357601;119.304702,35.357233;119.304574,35.356936;119.304294,35.356166;119.303628,35.355938;119.30367,35.356131;119.303198,35.356288;119.302577,35.357216;119.301933,35.357058;119.300925,35.356971;119.299809,35.357216;119.299186,35.356481;119.298871,35.356366;119.298607,35.356271;119.298268,35.356226;119.298001,35.35619;119.297554,35.356131;119.296889,35.355956;119.296354,35.355938;119.295967,35.356147;119.296097,35.356262;119.296097,35.356351;119.295591,35.356561;119.295464,35.356682;119.295892,35.356927;119.295979,35.357602;119.295281,35.357401;119.294723,35.357759;119.293788,35.357392;119.293575,35.357637;119.293446,35.357847;119.292985,35.357951;119.292587,35.357908;119.292266,35.357672;119.292137,35.357497;119.292211,35.357383;119.291794,35.357401;119.291365,35.357471;119.291031,35.357443;119.290785,35.357514;119.290581,35.357497;119.290259,35.357593;119.290217,35.357497;119.290174,35.357558;119.289916,35.357366;119.289916,35.357269;119.290024,35.354977;119.288917,35.354478;119.288768,35.354408;119.288628,35.354233;119.288499,35.353962;119.288252,35.353682;119.287951,35.35342;119.287544,35.352195;119.287566,35.351828;119.287758,35.351442;119.287779,35.350988;119.287265,35.350339;119.287051,35.350445;119.287115,35.350147;119.286771,35.350358;119.286836,35.349989;119.286364,35.349954;119.286306,35.349888;119.286298,35.349799;119.286218,35.349668;119.286142,35.349611;119.285927,35.349353;119.285762,35.349178;119.285622,35.349105;119.28557,35.349044;119.285488,35.349029;119.285417,35.349011;119.285292,35.348936;119.285207,35.348932;119.284998,35.348871;119.284847,35.348849;119.284966,35.348604;119.284977,35.348525;119.284998,35.34846;119.284966,35.348433;119.284869,35.348397;119.284757,35.348394;119.284421,35.348323;119.284086,35.348254;119.284203,35.348174;119.284257,35.348161;119.284317,35.348104;119.284596,35.348034;119.284724,35.348026;119.284886,35.348066;119.28502,35.34811;119.285131,35.348161;119.285181,35.34814;119.285261,35.348031;119.285309,35.347961;119.285304,35.347789;119.285363,35.347694;119.285277,35.347711;119.285201,35.347676;119.285213,35.347602;119.28525,35.347549;119.285261,35.347505;119.285292,35.347448;119.285304,35.347391;119.285411,35.34708;119.285427,35.346953;119.285282,35.34691;119.285116,35.346904;119.284939,35.346882;119.284804,35.346848;119.284826,35.346818;119.285095,35.346809;119.285143,35.346757;119.2851,35.346735;119.284987,35.346729;119.284687,35.346656;119.284381,35.346637;119.284286,35.346615;119.284274,35.346527;119.28428,35.346466;119.284312,35.34644;119.284441,35.346461;119.284532,35.346265;119.284602,35.346238;119.284644,35.346168;119.284757,35.346146;119.284644,35.345976;119.284634,35.345783;119.284586,35.345683;119.284591,35.345604;119.284554,35.345451;119.284532,35.345315;119.284468,35.345231;119.284387,35.345114;119.284377,35.345039;119.284291,35.344961;119.284114,35.344891;119.284091,35.344824;119.283958,35.344627;119.284016,35.344531;119.28406,35.344503;119.284103,35.344421;119.284151,35.344373;119.284216,35.344372;119.284291,35.344426;119.284329,35.344434;119.284393,35.344503;119.284463,35.344618;119.284456,35.344687;119.284736,35.345056;119.284827,35.345129;119.284896,35.345213;119.28494,35.345226;119.285047,35.345226;119.285058,35.345143;119.285074,35.345037;119.285074,35.344989;119.285037,35.344911;119.284987,35.344884;119.285025,35.344627;119.285014,35.344544;119.284972,35.344474;119.284977,35.344363;119.285014,35.344242;119.285046,35.344207;119.285057,35.344172;119.285062,35.343918;119.285004,35.343822;119.284903,35.343638;119.284747,35.343457;119.284624,35.343241;119.284499,35.342839;119.284441,35.342717;119.284361,35.342682;119.284307,35.342682;119.284248,35.342744;119.284167,35.342892;119.284076,35.343014;119.284044,35.343142;119.283947,35.343229;119.283792,35.343151;119.283701,35.343081;119.283561,35.343014;119.283299,35.342814;119.28324,35.342787;119.283261,35.342489;119.283309,35.342051;119.283324,35.341868;119.283368,35.341674;119.283459,35.341342;119.283835,35.340891;119.283814,35.340856;119.283631,35.340672;119.283594,35.340614;119.283534,35.340458;119.283492,35.340256;119.283486,35.340147;119.283513,35.34008;119.283513,35.339997;119.283534,35.339896;119.283582,35.339708;119.283802,35.339476;119.283789,35.339455;119.283687,35.339478;119.282357,35.339163;119.281799,35.338568;119.281026,35.338462;119.280211,35.338392;119.277807,35.338428;119.276219,35.337798;119.273173,35.337412;119.273302,35.337973;119.271285,35.338358;119.270898,35.338462;119.270683,35.337903;119.269954,35.337517;119.26901,35.337832;119.267208,35.338777;119.266991,35.339197;119.266606,35.339478;119.266262,35.339337;119.265791,35.339549;119.265447,35.339653;119.266134,35.340179;119.265748,35.340354;119.264459,35.339478;119.264975,35.338988;119.264287,35.338988;119.263816,35.339442;119.264975,35.340214;119.26519,35.340984;119.265276,35.341369;119.26536,35.341544;119.266648,35.342139;119.267378,35.341824;119.268237,35.342488;119.268065,35.342838;119.267849,35.343049;119.268451,35.343504;119.268966,35.343609;119.269119,35.343819;119.268865,35.343921;119.268579,35.343929;119.2682,35.343939;119.267943,35.343956;119.267512,35.344044;119.266783,35.344026;119.266526,35.344026;119.26629,35.343991;119.26584,35.343973;119.26569,35.343727;119.265239,35.343816;119.265152,35.344008;119.265002,35.344201;119.264724,35.344166;119.264595,35.344166;119.264338,35.343886;119.263587,35.343991;119.263179,35.344884;119.262128,35.344691;119.262149,35.344814;119.26069,35.344761;119.259596,35.345269;119.25951,35.344831;119.259124,35.345199;119.258629,35.344831;119.257792,35.344289;119.257471,35.345058;119.257792,35.345146;119.257729,35.345689;119.255754,35.345076;119.25554,35.345444;119.252429,35.343921;119.252493,35.343781;119.252279,35.343711;119.25215,35.343798;119.251849,35.343762;119.251699,35.344166;119.251528,35.343657;119.250133,35.343238;119.250776,35.341558;119.250519,35.341487;119.25039,35.341417;119.250068,35.341453;119.25054,35.340804;119.250282,35.340665;119.248601,35.339786;119.248309,35.339633;119.248027,35.339929;119.248069,35.339561;119.247919,35.339491;119.24809,35.338021;119.247897,35.338004;119.247984,35.337583;119.246267,35.337006;119.246225,35.336796;119.245238,35.336358;119.245474,35.335571;119.24601,35.335676;119.246138,35.335412;119.245709,35.335255;119.245881,35.334713;119.246009,35.333978;119.246933,35.334169;119.247126,35.333978;119.245967,35.33361;119.245924,35.333733;119.245624,35.333733;119.244637,35.334519;119.243799,35.333872;119.24294,35.333382;119.242963,35.332874;119.242662,35.332699;119.242791,35.332122;119.242662,35.331947;119.242898,35.33151;119.241654,35.331282;119.241589,35.331387;119.241396,35.331334;119.241481,35.330949;119.240903,35.330914;119.240752,35.331527;119.240538,35.331562;119.240538,35.330879;119.240109,35.330879;119.240023,35.330477;119.240044,35.329882;119.239979,35.329567;119.240152,35.329042;119.239401,35.329006;119.239271,35.329672;119.239486,35.33018;119.239486,35.330581;119.239229,35.330705;119.239186,35.331212;119.239594,35.331597;119.239443,35.332194;119.239229,35.333594;119.239121,35.335292;119.238864,35.33538;119.237704,35.335064;119.23734,35.335029;119.236889,35.334767;119.236352,35.333996;119.236074,35.334171;119.236718,35.335256;119.236824,35.335485;119.236289,35.335501;119.234937,35.334609;119.233971,35.334837;119.23307,35.334504;119.232791,35.334557;119.232742,35.334564;119.232683,35.334573;119.232747,35.334837;119.232983,35.335327;119.233198,35.335555;119.233413,35.335501;119.233649,35.33566;119.233519,35.335921;119.233327,35.335887;119.232983,35.335869;119.232855,35.336062;119.232576,35.335991;119.232533,35.33643;119.232876,35.336675;119.232447,35.337113;119.232426,35.337393;119.232317,35.339317;119.232726,35.339352;119.232854,35.339703;119.232682,35.339983;119.232746,35.340403;119.231782,35.341243;119.231589,35.341523;119.231396,35.341996;119.230845,35.341964;119.229893,35.341908;119.229615,35.341732;119.229572,35.341732;119.229248,35.341714;119.228927,35.341679;119.228713,35.341679;119.228541,35.341348;119.227983,35.341155;119.227554,35.340998;119.227297,35.341032;119.226782,35.340787;119.226524,35.340769;119.225408,35.339965;119.225794,35.339895;119.225794,35.339684;119.225752,35.339457;119.226331,35.339666;119.228434,35.340139;119.229292,35.340209;119.229314,35.339666;119.229571,35.339526;119.229829,35.339247;119.229786,35.338389;119.229485,35.338266;119.229356,35.337969;119.229035,35.337898;119.229098,35.337688;119.228906,35.337373;119.228604,35.337042;119.229206,35.336989;119.229377,35.336481;119.229206,35.336307;119.229485,35.335361;119.229571,35.335764;119.229677,35.335781;119.229786,35.335274;119.229956,35.334661;119.229142,35.334539;119.228713,35.334328;119.227597,35.334416;119.227511,35.334818;119.227425,35.334976;119.227103,35.334766;119.226739,35.334363;119.226631,35.334276;119.226587,35.334504;119.226481,35.334609;119.226566,35.335239;119.226481,35.335344;119.226566,35.335956;119.226309,35.336184;119.226244,35.336412;119.225966,35.336429;119.225879,35.337042;119.225644,35.337408;119.225365,35.337392;119.225429,35.337181;119.225537,35.336954;119.225686,35.336936;119.225709,35.336604;119.225473,35.336551;119.225365,35.336674;119.225365,35.336814;119.225257,35.337164;119.225194,35.336674;119.225065,35.336447;119.224915,35.336079;119.224722,35.336358;119.224164,35.336237;119.224271,35.335833;119.224227,35.33515;119.224014,35.334399;119.22382,35.334241;119.223304,35.334469;119.222984,35.334994;119.222747,35.335465;119.223305,35.335868;119.222231,35.336253;119.221931,35.337234;119.221586,35.338004;119.220901,35.338494;119.219914,35.338529;119.219184,35.338389;119.219484,35.338809;119.219269,35.339194;119.219527,35.339685;119.218841,35.340244;119.218024,35.33972;119.21751,35.339825;119.21721,35.33951;119.215578,35.339475;119.214205,35.33986;119.212446,35.340244;119.211844,35.340875;119.210386,35.342065;119.209484,35.341889;119.207124,35.341085;119.207037,35.34273;119.205921,35.34245;119.205406,35.342835;119.204891,35.342519;119.203002,35.343254;119.203732,35.344444;119.20266,35.34434;119.203561,35.345006;119.20296,35.345566;119.202016,35.345601;119.2012,35.346406;119.199354,35.346896;119.197124,35.349626;119.196694,35.350466;119.196136,35.351097;119.195765,35.351741;119.196452,35.352022;119.197224,35.352512;119.19774,35.352967;119.199585,35.354893;119.200787,35.354473;119.201259,35.354858;119.201309,35.35515;119.201344,35.355348;119.20143,35.356013;119.201559,35.357307;119.201472,35.358252;119.201001,35.359023;119.200142,35.359513;119.199199,35.359898;119.199328,35.360808;119.198684,35.361438;119.198211,35.362837;119.198212,35.363573;119.197654,35.364692;119.197783,35.365358;119.197333,35.368237;119.197182,35.369206;119.197568,35.369452;119.197611,35.370011;119.198254,35.370607;119.198554,35.371027;119.198856,35.372392;119.198641,35.372986;119.199027,35.37428;119.200744,35.376379;119.202074,35.378339;119.20319,35.379459;119.204649,35.381733;119.204992,35.382607;119.204349,35.382573;119.203276,35.382607;119.202502,35.385022;119.20246,35.385547;119.201774,35.385512;119.201944,35.384882;119.201345,35.384358;119.199821,35.385499;119.195127,35.386666;119.193376,35.387352;119.190564,35.389494;119.190551,35.38988;119.193046,35.393376;119.192928,35.394099;119.189526,35.397801;119.18903,35.400516;119.186941,35.401796;119.181809,35.403302;119.181073,35.403968;119.181196,35.410835;119.181766,35.415437;119.181276,35.416686;119.177291,35.419894;119.176897,35.42042;119.177986,35.423109;119.178944,35.428399;119.182623,35.431814;119.182848,35.432745;119.182513,35.434016;119.178693,35.437404;119.175407,35.437747;119.165738,35.435462;119.16249,35.43612;119.153719,35.437531;119.149315,35.438754;119.143006,35.443666;119.139674,35.444121;119.134396,35.443261;119.131362,35.444544;119.130476,35.446608;119.129136,35.448403;119.128179,35.448951;119.125943,35.449498;119.124064,35.449027;119.116481,35.446258;119.112697,35.443722;119.107546,35.441172;119.106383,35.440958;119.105378,35.440887;119.101244,35.442166;119.100971,35.442658;119.102107,35.447751;119.10198,35.449396;119.100325,35.453444;119.097253,35.457642;119.095029,35.460006;119.087272,35.463585;119.084052,35.463979;119.082209,35.463807;119.081189,35.462648;119.080223,35.459958;119.078924,35.459941;119.074586,35.461982;119.067871,35.466106;119.065775,35.465798;119.064397,35.465123;119.059612,35.457132;119.057496,35.453779;119.055859,35.454279;119.053031,35.455143;119.045879,35.458851;119.043952,35.461646;119.043211,35.462959;119.041787,35.463585;119.039071,35.464586;119.037453,35.468551;119.037154,35.468972;119.036323,35.470141;119.03626,35.470229;119.035718,35.470991;119.036653,35.474251;119.036469,35.474987;119.035477,35.476177;119.035491,35.478553;119.034384,35.480109;119.033262,35.481086;119.033343,35.482401;119.034053,35.482884;119.036418,35.482686;119.041371,35.480945;119.042294,35.48336;119.043688,35.487742;119.044742,35.491401;119.044516,35.493894;119.043959,35.495389;119.043297,35.495887;119.043245,35.49777;119.044186,35.503203;119.044299,35.505643;119.043516,35.508355;119.043517,35.516114;119.043134,35.518884;119.041689,35.520931;119.039852,35.522477;119.037797,35.525132;119.037692,35.526573;119.038241,35.528292;119.038799,35.529512;119.040079,35.530401;119.041525,35.532789;119.042909,35.534011;119.044747,35.535013;119.047246,35.53646;119.050075,35.537852;119.05569,35.539471;119.061346,35.540922;119.062791,35.542754;119.0634,35.544472;119.063514,35.546579;119.063627,35.548132;119.064236,35.549572;119.065123,35.550627;119.067124,35.551905;119.070342,35.551964;119.073004,35.552746;119.075726,35.554467;119.078221,35.555632;119.081046,35.556302;119.083489,35.558076;119.085427,35.560238;119.086869,35.561127;119.088972,35.561961;119.092249,35.563126;119.094577,35.56418;119.096453,35.565512;119.097348,35.56734;119.099006,35.568726;119.099944,35.570056;119.101334,35.570666;119.104485,35.570223;119.105761,35.571359;119.110196,35.569217;119.111845,35.567811;119.113727,35.564797;119.117336,35.563355;119.122332,35.561433;119.124856,35.561155;119.126781,35.559974;119.129278,35.559009;119.132052,35.557812;119.134817,35.556615;119.137028,35.555198;119.140096,35.55468;119.145157,35.555276;119.148813,35.555896;119.152487,35.557432;119.156186,35.559426;119.15765,35.561925;119.158399,35.563643;119.158468,35.564647;119.159455,35.565234;119.166278,35.567172;119.168465,35.567622;119.170725,35.571355;119.170947,35.57216;119.17033,35.57331;119.166033,35.575834;119.165323,35.576985;119.165353,35.578084;119.165672,35.579051;119.168048,35.582517;119.169908,35.583415;119.171124,35.583328;119.172191,35.581701;119.173275,35.581276;119.174997,35.581646;119.178766,35.585248;119.184622,35.587305;119.185136,35.588053;119.185326,35.589363;119.18585,35.590939;119.186616,35.591435;119.188696,35.591331;119.191577,35.587798;119.191804,35.584785;119.190803,35.580863;119.186612,35.579367;119.185591,35.578123;119.185615,35.577276;119.191204,35.57125;119.191609,35.57109;119.192348,35.571328;119.19311,35.572122;119.194381,35.577429;119.195651,35.582156;119.195724,35.584833;119.194619,35.587332;119.195215,35.58823;119.195885,35.588482;119.197762,35.588837;119.198506,35.588802;119.200084,35.588417;119.203142,35.58744;119.205646,35.586702;119.207881,35.586199;119.210931,35.585454;119.214804,35.583772;119.218409,35.582326;119.222292,35.580874;119.2251,35.580822;119.227892,35.580538;119.230674,35.579795;119.234854,35.578799;119.237638,35.577829;119.239563,35.576649;119.240899,35.574097;119.241679,35.572016;119.242711,35.568784;119.243492,35.566473;119.243994,35.564171;119.246414,35.560457;119.248341,35.559041;119.250831,35.557848;119.253322,35.556886;119.256064,35.554311;119.258547,35.552661;119.260144,35.549647;119.261498,35.547788;119.263121,35.545693;119.264754,35.543826;119.265813,35.541514;119.267428,35.539184;119.268496,35.537102;119.270137,35.535466;119.272595,35.532898;119.276217,35.532145;119.279571,35.531629;119.282708,35.533413;119.284236,35.534601;119.284181,35.535186;119.285002,35.536127;119.285619,35.536495;119.285821,35.536987;119.286783,35.538196;119.287041,35.53876;119.287164,35.539984;119.287306,35.540132;119.287552,35.540162;119.287887,35.540409;119.29106,35.540194;119.293061,35.541952;119.29593,35.543971;119.298217,35.545313;119.302756,35.547072;119.304999,35.546571;119.308409,35.547893;119.310705,35.549462;119.312166,35.551732;119.315046,35.553748;119.317072,35.556012;119.319404,35.558726;119.3203,35.561006;119.321788,35.563506;119.323841,35.566456;119.325921,35.570551;119.327687,35.573048;119.328574,35.574871;119.330036,35.576683;119.331515,35.579181;119.333246,35.580758;119.335552,35.582784;119.338414,35.584344;119.340141,35.584616;119.340168,35.584617;119.340182,35.584622;119.342372,35.584966;119.345686,35.582847;119.346164,35.579856;119.346103,35.577786;119.345459,35.575044;119.344841,35.572989;119.344771,35.570696;119.34471,35.568631;119.345214,35.566558;119.346841,35.564461;119.348746,35.562365;119.350685,35.561411;119.352929,35.560915;119.354869,35.559965;119.359912,35.55942;119.362739,35.560057;119.366991,35.561134;119.369555,35.562464;119.371842,35.564033;119.374962,35.564893;119.379552,35.568023;119.382967,35.569571;119.385539,35.57113;119.388675,35.572911;119.391255,35.5747;119.393826,35.576029;119.397543,35.578252;119.400096,35.579124;119.402353,35.579541;119.406849,35.579683;119.40993,35.579392;119.412697,35.578193;119.416323,35.577662;119.41883,35.577153;119.422454,35.576163;119.425255,35.575875;119.427171,35.574462;119.429892,35.571654;119.432041,35.568852;119.434502,35.566507;119.43698,35.565079;119.440852,35.563391;119.443927,35.563326;119.445936,35.56512;119.447659,35.566457;119.4494,35.568259;119.450846,35.569832;119.452864,35.572085;119.455175,35.574558;119.456932,35.576817;119.458949,35.578836;119.459858,35.581112;119.463389,35.586103;119.463917,35.588395;119.463459,35.591086;119.464281,35.592681;119.465908,35.593973;119.467889,35.595097;119.470242,35.596453;119.472422,35.597079;119.47481,35.598104;119.479687,35.598571;119.482455,35.598316;119.487945,35.597436;119.490064,35.597927;119.491352,35.599088;119.492909,35.601841;119.494491,35.604097;119.495589,35.604957;119.497007,35.605385;119.500577,35.604343;119.504251,35.602604;119.507259,35.601998;119.511098,35.602151;119.516855,35.601537;119.521419,35.601358;119.522768,35.600623;119.525189,35.598987;119.526067,35.598468;119.528647,35.594215;119.530981,35.592948;119.534786,35.592355;119.536248,35.592217;119.537588,35.591314;119.538193,35.589276;119.540174,35.588889;119.543669,35.589779;119.547146,35.591099;119.550486,35.591122;119.556517,35.592523;119.558837,35.592469;119.559971,35.592076;119.563113,35.589627;119.564672,35.589555;119.565962,35.590524;119.567624,35.590358;119.569833,35.58832;119.570733,35.586812;119.573418,35.586309;119.576467,35.585508;119.577584,35.586254;119.576275,35.589339;119.575333,35.592124;119.5771,35.592747;119.578451,35.593158;119.582741,35.592986;119.58411,35.594761;119.586745,35.597118;119.592346,35.600695;119.594505,35.600623;119.597731,35.599149;119.598268,35.598026;119.599343,35.593631;119.600592,35.590254;119.602778,35.59007;119.609277,35.59204;119.611178,35.594048;119.61413,35.600187;119.614252,35.60524;119.615007,35.606335;119.617281,35.606855;119.619001,35.606819;119.623498,35.601974;119.626042,35.601657;119.632305,35.602096;119.633339,35.601799;119.63412,35.60078;119.634702,35.598744;119.635215,35.598254;119.63637,35.597243;119.637595,35.596292;119.638664,35.595016;119.639715,35.59441;119.641757,35.593915;119.642444,35.593888;119.644799,35.592317;119.651447,35.588762;119.653516,35.588423;119.656272,35.588427;119.659028,35.588639;119.662149,35.589281;119.665756,35.581552;119.666538,35.575902;119.665755,35.570248;119.663024,35.563031;119.649869,35.537642;119.639246,35.509444;119.635214,35.50448;119.632998,35.502901;119.631131,35.502141;119.629263,35.501672;119.628681,35.500855;119.627282,35.493793;119.625527,35.486178;119.618976,35.459462;119.617109,35.454792;119.61513,35.451641;119.613029,35.449831;119.600204,35.443526;119.597411,35.44061;119.592519,35.433375;119.586926,35.421941;119.579706,35.406542;119.577374,35.395924;119.577495,35.390787;119.578785,35.385577;119.583091,35.381839;119.586705,35.378802;119.589028,35.376116;119.58973,35.372614;119.588802,35.368062;119.586938,35.363863;119.584025,35.360537;119.579138,35.357625;119.5718,35.355181;119.56308,35.352627;119.548608,35.349621;119.543764,35.34794;119.540407,35.341252;119.542161,35.329829;119.55273,35.330005;119.554277,35.329266;119.554929,35.328201;119.554684,35.326239;119.553544,35.324933;119.552078,35.324445;119.542714,35.32414;119.540597,35.323818;119.539132,35.322595;119.538643,35.32047;119.538478,35.296755;119.536912,35.291378;119.531309,35.291954;119.533106,35.297015;119.532943,35.300205;119.532536,35.301351;119.531234,35.302417;119.529688,35.302994;119.528467,35.303733;119.523535,35.303218;119.520441,35.303792;119.518239,35.308216;119.51601,35.318086;119.509319,35.321692;119.502406,35.321713;119.493484,35.318601;119.486122,35.314812;119.476529,35.308338;119.451118,35.285394;119.424578,35.255313;119.417119,35.24411;119.411297,35.231623;119.405197,35.203444',
      bounds3: '119.033262,35.481086;119.034384,35.480109;119.035491,35.478553;119.035477,35.476177;119.036469,35.474987;119.036653,35.474251;119.035718,35.470991;119.03626,35.470229;119.036323,35.470141;119.037154,35.468972;119.037453,35.468551;119.039071,35.464586;119.041787,35.463585;119.043211,35.462959;119.043952,35.461646;119.045879,35.458851;119.053031,35.455143;119.055859,35.454279;119.057496,35.453779;119.059612,35.457132;119.064397,35.465123;119.065775,35.465798;119.067871,35.466106;119.074586,35.461982;119.078924,35.459941;119.080223,35.459958;119.081189,35.462648;119.082209,35.463807;119.084052,35.463979;119.087272,35.463585;119.095029,35.460006;119.097253,35.457642;119.100325,35.453444;119.10198,35.449396;119.102107,35.447751;119.100971,35.442658;119.101244,35.442166;119.105378,35.440887;119.106383,35.440958;119.107546,35.441172;119.112697,35.443722;119.116481,35.446258;119.124064,35.449027;119.125943,35.449498;119.128179,35.448951;119.129136,35.448403;119.130476,35.446608;119.131362,35.444544;119.134396,35.443261;119.139674,35.444121;119.143006,35.443666;119.149315,35.438754;119.153719,35.437531;119.16249,35.43612;119.165738,35.435462;119.175407,35.437747;119.178693,35.437404;119.182513,35.434016;119.182848,35.432745;119.182623,35.431814;119.178944,35.428399;119.177986,35.423109;119.176897,35.42042;119.177291,35.419894;119.181276,35.416686;119.181766,35.415437;119.181196,35.410835;119.181073,35.403968;119.181809,35.403302;119.186941,35.401796;119.18903,35.400516;119.189526,35.397801;119.192928,35.394099;119.193046,35.393376;119.190551,35.38988;119.190564,35.389494;119.193376,35.387352;119.195127,35.386666;119.199821,35.385499;119.201345,35.384358;119.201944,35.384882;119.201774,35.385512;119.20246,35.385547;119.202502,35.385022;119.203276,35.382607;119.204349,35.382573;119.204992,35.382607;119.204649,35.381733;119.20319,35.379459;119.202074,35.378339;119.200744,35.376379;119.199027,35.37428;119.198641,35.372986;119.198856,35.372392;119.198554,35.371027;119.198254,35.370607;119.197611,35.370011;119.197568,35.369452;119.197182,35.369206;119.197333,35.368237;119.197783,35.365358;119.197654,35.364692;119.198212,35.363573;119.198211,35.362837;119.198684,35.361438;119.199328,35.360808;119.199199,35.359898;119.200142,35.359513;119.201001,35.359023;119.201472,35.358252;119.201559,35.357307;119.20143,35.356013;119.201344,35.355348;119.201309,35.35515;119.201259,35.354858;119.200787,35.354473;119.199585,35.354893;119.19774,35.352967;119.197224,35.352512;119.196452,35.352022;119.195765,35.351741;119.196136,35.351097;119.196694,35.350466;119.197124,35.349626;119.199354,35.346896;119.2012,35.346406;119.202016,35.345601;119.20296,35.345566;119.203561,35.345006;119.20266,35.34434;119.203732,35.344444;119.203002,35.343254;119.204891,35.342519;119.205406,35.342835;119.205921,35.34245;119.207037,35.34273;119.207124,35.341085;119.209484,35.341889;119.210386,35.342065;119.211844,35.340875;119.212446,35.340244;119.214205,35.33986;119.215578,35.339475;119.21721,35.33951;119.21751,35.339825;119.218024,35.33972;119.218841,35.340244;119.219527,35.339685;119.219269,35.339194;119.219484,35.338809;119.219184,35.338389;119.219914,35.338529;119.220901,35.338494;119.221586,35.338004;119.221931,35.337234;119.222231,35.336253;119.223305,35.335868;119.222747,35.335465;119.222984,35.334994;119.223304,35.334469;119.22382,35.334241;119.224014,35.334399;119.224227,35.33515;119.224271,35.335833;119.224164,35.336237;119.224722,35.336358;119.224915,35.336079;119.225065,35.336447;119.225194,35.336674;119.225257,35.337164;119.225365,35.336814;119.225365,35.336674;119.225473,35.336551;119.225709,35.336604;119.225686,35.336936;119.225537,35.336954;119.225429,35.337181;119.225365,35.337392;119.225644,35.337408;119.225879,35.337042;119.225966,35.336429;119.226244,35.336412;119.226309,35.336184;119.226566,35.335956;119.226481,35.335344;119.226566,35.335239;119.226481,35.334609;119.226587,35.334504;119.226631,35.334276;119.226739,35.334363;119.227103,35.334766;119.227425,35.334976;119.227511,35.334818;119.227597,35.334416;119.228713,35.334328;119.229142,35.334539;119.229956,35.334661;119.229786,35.335274;119.229677,35.335781;119.229571,35.335764;119.229485,35.335361;119.229206,35.336307;119.229377,35.336481;119.229206,35.336989;119.228604,35.337042;119.228906,35.337373;119.229098,35.337688;119.229035,35.337898;119.229356,35.337969;119.229485,35.338266;119.229786,35.338389;119.229829,35.339247;119.229571,35.339526;119.229314,35.339666;119.229292,35.340209;119.228434,35.340139;119.226331,35.339666;119.225752,35.339457;119.225794,35.339684;119.225794,35.339895;119.225408,35.339965;119.226524,35.340769;119.226782,35.340787;119.227297,35.341032;119.227554,35.340998;119.227983,35.341155;119.228541,35.341348;119.228713,35.341679;119.228927,35.341679;119.229248,35.341714;119.229572,35.341732;119.229615,35.341732;119.229893,35.341908;119.230845,35.341964;119.231396,35.341996;119.231589,35.341523;119.231782,35.341243;119.232746,35.340403;119.232682,35.339983;119.232854,35.339703;119.232726,35.339352;119.232317,35.339317;119.232426,35.337393;119.232447,35.337113;119.232876,35.336675;119.232533,35.33643;119.232576,35.335991;119.232855,35.336062;119.232983,35.335869;119.233327,35.335887;119.233519,35.335921;119.233649,35.33566;119.233413,35.335501;119.233198,35.335555;119.232983,35.335327;119.232747,35.334837;119.232683,35.334573;119.232742,35.334564;119.232791,35.334557;119.23307,35.334504;119.233971,35.334837;119.234937,35.334609;119.236289,35.335501;119.236824,35.335485;119.236718,35.335256;119.236074,35.334171;119.236352,35.333996;119.236889,35.334767;119.23734,35.335029;119.237704,35.335064;119.238864,35.33538;119.239121,35.335292;119.239229,35.333594;119.239443,35.332194;119.239594,35.331597;119.239186,35.331212;119.239229,35.330705;119.239486,35.330581;119.239486,35.33018;119.239271,35.329672;119.239401,35.329006;119.240152,35.329042;119.239979,35.329567;119.240044,35.329882;119.240023,35.330477;119.240109,35.330879;119.240538,35.330879;119.240538,35.331562;119.240752,35.331527;119.240903,35.330914;119.241481,35.330949;119.241396,35.331334;119.241589,35.331387;119.241654,35.331282;119.242898,35.33151;119.242662,35.331947;119.242791,35.332122;119.242662,35.332699;119.242963,35.332874;119.24294,35.333382;119.243799,35.333872;119.244637,35.334519;119.245624,35.333733;119.245924,35.333733;119.245967,35.33361;119.247126,35.333978;119.246933,35.334169;119.246009,35.333978;119.245881,35.334713;119.245709,35.335255;119.246138,35.335412;119.24601,35.335676;119.245474,35.335571;119.245238,35.336358;119.246225,35.336796;119.246267,35.337006;119.247984,35.337583;119.247897,35.338004;119.24809,35.338021;119.247919,35.339491;119.248069,35.339561;119.248027,35.339929;119.248309,35.339633;119.248601,35.339786;119.250282,35.340665;119.25054,35.340804;119.250068,35.341453;119.25039,35.341417;119.250519,35.341487;119.250776,35.341558;119.250133,35.343238;119.251528,35.343657;119.251699,35.344166;119.251849,35.343762;119.25215,35.343798;119.252279,35.343711;119.252493,35.343781;119.252429,35.343921;119.25554,35.345444;119.255754,35.345076;119.257729,35.345689;119.257792,35.345146;119.257471,35.345058;119.257792,35.344289;119.258629,35.344831;119.259124,35.345199;119.25951,35.344831;119.259596,35.345269;119.26069,35.344761;119.262149,35.344814;119.262128,35.344691;119.263179,35.344884;119.263587,35.343991;119.264338,35.343886;119.264595,35.344166;119.264724,35.344166;119.265002,35.344201;119.265152,35.344008;119.265239,35.343816;119.26569,35.343727;119.26584,35.343973;119.26629,35.343991;119.266526,35.344026;119.266783,35.344026;119.267512,35.344044;119.267943,35.343956;119.2682,35.343939;119.268579,35.343929;119.268865,35.343921;119.269119,35.343819;119.268966,35.343609;119.268451,35.343504;119.267849,35.343049;119.268065,35.342838;119.268237,35.342488;119.267378,35.341824;119.266648,35.342139;119.26536,35.341544;119.265276,35.341369;119.26519,35.340984;119.264975,35.340214;119.263816,35.339442;119.264287,35.338988;119.264975,35.338988;119.264459,35.339478;119.265748,35.340354;119.266134,35.340179;119.265447,35.339653;119.265791,35.339549;119.266262,35.339337;119.266606,35.339478;119.266991,35.339197;119.267208,35.338777;119.26901,35.337832;119.269954,35.337517;119.270683,35.337903;119.270898,35.338462;119.271285,35.338358;119.273302,35.337973;119.273173,35.337412;119.276219,35.337798;119.277807,35.338428;119.280211,35.338392;119.281026,35.338462;119.281799,35.338568;119.282357,35.339163;119.283687,35.339478;119.283789,35.339455;119.283802,35.339476;119.283582,35.339708;119.283534,35.339896;119.283513,35.339997;119.283513,35.34008;119.283486,35.340147;119.283492,35.340256;119.283534,35.340458;119.283594,35.340614;119.283631,35.340672;119.283814,35.340856;119.283835,35.340891;119.283459,35.341342;119.283368,35.341674;119.283324,35.341868;119.283309,35.342051;119.283261,35.342489;119.28324,35.342787;119.283299,35.342814;119.283561,35.343014;119.283701,35.343081;119.283792,35.343151;119.283947,35.343229;119.284044,35.343142;119.284076,35.343014;119.284167,35.342892;119.284248,35.342744;119.284307,35.342682;119.284361,35.342682;119.284441,35.342717;119.284499,35.342839;119.284624,35.343241;119.284747,35.343457;119.284903,35.343638;119.285004,35.343822;119.285062,35.343918;119.285057,35.344172;119.285046,35.344207;119.285014,35.344242;119.284977,35.344363;119.284972,35.344474;119.285014,35.344544;119.285025,35.344627;119.284987,35.344884;119.285037,35.344911;119.285074,35.344989;119.285074,35.345037;119.285058,35.345143;119.285047,35.345226;119.28494,35.345226;119.284896,35.345213;119.284827,35.345129;119.284736,35.345056;119.284456,35.344687;119.284463,35.344618;119.284393,35.344503;119.284329,35.344434;119.284291,35.344426;119.284216,35.344372;119.284151,35.344373;119.284103,35.344421;119.28406,35.344503;119.284016,35.344531;119.283958,35.344627;119.284091,35.344824;119.284114,35.344891;119.284291,35.344961;119.284377,35.345039;119.284387,35.345114;119.284468,35.345231;119.284532,35.345315;119.284554,35.345451;119.284591,35.345604;119.284586,35.345683;119.284634,35.345783;119.284644,35.345976;119.284757,35.346146;119.284644,35.346168;119.284602,35.346238;119.284532,35.346265;119.284441,35.346461;119.284312,35.34644;119.28428,35.346466;119.284274,35.346527;119.284286,35.346615;119.284381,35.346637;119.284687,35.346656;119.284987,35.346729;119.2851,35.346735;119.285143,35.346757;119.285095,35.346809;119.284826,35.346818;119.284804,35.346848;119.284939,35.346882;119.285116,35.346904;119.285282,35.34691;119.285427,35.346953;119.285411,35.34708;119.285304,35.347391;119.285292,35.347448;119.285261,35.347505;119.28525,35.347549;119.285213,35.347602;119.285201,35.347676;119.285277,35.347711;119.285363,35.347694;119.285304,35.347789;119.285309,35.347961;119.285261,35.348031;119.285181,35.34814;119.285131,35.348161;119.28502,35.34811;119.284886,35.348066;119.284724,35.348026;119.284596,35.348034;119.284317,35.348104;119.284257,35.348161;119.284203,35.348174;119.284086,35.348254;119.284421,35.348323;119.284757,35.348394;119.284869,35.348397;119.284966,35.348433;119.284998,35.34846;119.284977,35.348525;119.284966,35.348604;119.284847,35.348849;119.284998,35.348871;119.285207,35.348932;119.285292,35.348936;119.285417,35.349011;119.285488,35.349029;119.28557,35.349044;119.285622,35.349105;119.285762,35.349178;119.285927,35.349353;119.286142,35.349611;119.286218,35.349668;119.286298,35.349799;119.286306,35.349888;119.286364,35.349954;119.286836,35.349989;119.286771,35.350358;119.287115,35.350147;119.287051,35.350445;119.287265,35.350339;119.287779,35.350988;119.287758,35.351442;119.287566,35.351828;119.287544,35.352195;119.287951,35.35342;119.288252,35.353682;119.288499,35.353962;119.288628,35.354233;119.288768,35.354408;119.288917,35.354478;119.290024,35.354977;119.289916,35.357269;119.289916,35.357366;119.290174,35.357558;119.290217,35.357497;119.290259,35.357593;119.290581,35.357497;119.290785,35.357514;119.291031,35.357443;119.291365,35.357471;119.291794,35.357401;119.292211,35.357383;119.292137,35.357497;119.292266,35.357672;119.292587,35.357908;119.292985,35.357951;119.293446,35.357847;119.293575,35.357637;119.293788,35.357392;119.294723,35.357759;119.295281,35.357401;119.295979,35.357602;119.295892,35.356927;119.295464,35.356682;119.295591,35.356561;119.296097,35.356351;119.296097,35.356262;119.295967,35.356147;119.296354,35.355938;119.296889,35.355956;119.297554,35.356131;119.298001,35.35619;119.298268,35.356226;119.298607,35.356271;119.298871,35.356366;119.299186,35.356481;119.299809,35.357216;119.300925,35.356971;119.301933,35.357058;119.302577,35.357216;119.303198,35.356288;119.30367,35.356131;119.303628,35.355938;119.304294,35.356166;119.304574,35.356936;119.304702,35.357233;119.304724,35.357601;119.305089,35.357863;119.305797,35.357933;119.306397,35.358458;119.306698,35.358861;119.307728,35.359333;119.308286,35.359596;119.308499,35.359911;119.308822,35.359946;119.309273,35.360261;119.30968,35.360138;119.310818,35.360173;119.310946,35.360436;119.311181,35.360453;119.311204,35.360646;119.311569,35.360436;119.311998,35.360436;119.31208,35.360834;119.312149,35.36117;119.312535,35.361083;119.313361,35.361004;119.313222,35.360514;119.313318,35.35984;119.313812,35.359779;119.314155,35.359823;119.314788,35.360627;119.314413,35.36068;119.314649,35.360943;119.314327,35.361013;119.314863,35.361607;119.315109,35.361511;119.315775,35.361476;119.316215,35.361669;119.316483,35.361694;119.316794,35.361695;119.317771,35.361764;119.318414,35.362009;119.318736,35.362019;119.319338,35.362482;119.31995,35.362639;119.321623,35.363191;119.321923,35.363191;119.321924,35.361949;119.321902,35.361826;119.321902,35.361389;119.322331,35.361091;119.322632,35.361239;119.322846,35.361538;119.322782,35.362868;119.322997,35.362973;119.323304,35.362993;119.323651,35.363016;119.324098,35.363001;119.324293,35.362996;119.324499,35.362989;119.324814,35.363062;119.326323,35.36341;119.326903,35.363462;119.328576,35.363847;119.329778,35.364354;119.329734,35.36341;119.332802,35.36341;119.333254,35.362395;119.333704,35.362639;119.334144,35.362836;119.334649,35.363059;119.335242,35.363183;119.335487,35.363234;119.335865,35.363234;119.336517,35.363234;119.337632,35.362831;119.338341,35.362306;119.339521,35.362446;119.340552,35.362394;119.340917,35.362708;119.341818,35.363111;119.342033,35.363671;119.342547,35.364056;119.34302,35.364564;119.343921,35.364826;119.344779,35.365123;119.345573,35.365263;119.346288,35.365263;119.346989,35.365263;119.347264,35.365096;119.347569,35.364913;119.347847,35.364899;119.349028,35.364843;119.349293,35.364987;119.349542,35.365122;119.349707,35.365286;119.349896,35.365474;119.349704,35.365714;119.349617,35.365824;119.349263,35.366016;119.348136,35.366025;119.347824,35.366314;119.348587,35.367355;119.348694,35.3676;119.349016,35.367862;119.349294,35.36802;119.349681,35.368221;119.350121,35.368247;119.350046,35.368536;119.349982,35.368807;119.350347,35.368895;119.350541,35.369174;119.350626,35.369489;119.351936,35.369524;119.351484,35.36879;119.352385,35.368755;119.352501,35.369206;119.352591,35.369557;119.35273,35.370102;119.353524,35.370172;119.353631,35.370627;119.354511,35.370486;119.354618,35.370747;119.354919,35.370521;119.355177,35.370327;119.356099,35.370431;119.357516,35.370694;119.357838,35.371499;119.359962,35.371779;119.361401,35.371727;119.361679,35.372217;119.36228,35.372269;119.362538,35.37276;119.362517,35.373198;119.362602,35.373547;119.362881,35.373599;119.363224,35.373774;119.363246,35.373967;119.363225,35.374282;119.363332,35.374702;119.363718,35.374771;119.364104,35.374736;119.363933,35.37451;119.364104,35.374457;119.364039,35.374282;119.364791,35.373827;119.365263,35.374072;119.364598,35.374597;119.365091,35.37493;119.365306,35.374685;119.365884,35.375016;119.366186,35.37472;119.366443,35.374596;119.366894,35.375139;119.367602,35.37556;119.368353,35.375787;119.367709,35.375349;119.367752,35.375227;119.367086,35.374701;119.367731,35.374666;119.368181,35.373581;119.368782,35.373634;119.368782,35.373214;119.369404,35.373355;119.369383,35.373547;119.369146,35.37353;119.368975,35.37465;119.368847,35.374615;119.368503,35.375315;119.368846,35.375717;119.370241,35.374596;119.370648,35.375035;119.370391,35.37535;119.369919,35.375822;119.371228,35.376259;119.371136,35.376456;119.371057,35.376626;119.37331,35.376993;119.373567,35.376031;119.374122,35.376139;119.374546,35.376221;119.374756,35.376261;119.374834,35.376276;119.375396,35.376455;119.376486,35.376801;119.376722,35.376136;119.377216,35.375069;119.377408,35.375069;119.377708,35.374894;119.378675,35.375734;119.378589,35.373687;119.380027,35.373582;119.380113,35.373355;119.381034,35.373285;119.381227,35.373126;119.38211,35.373406;119.382401,35.3735;119.382602,35.373564;119.382918,35.373609;119.384576,35.373844;119.384447,35.375487;119.386181,35.37576;119.386679,35.375838;119.393116,35.376117;119.393377,35.373882;119.392359,35.372839;119.395061,35.345281;119.395005,35.326675;119.392901,35.319105;119.389031,35.31751;119.374842,35.312288;119.373826,35.311295;119.373292,35.309914;119.374151,35.30555;119.372713,35.296449;119.366326,35.295401;119.348251,35.295823;119.335453,35.299535;119.325182,35.300977;119.323437,35.300426;119.319124,35.297491;119.312147,35.290987;119.311301,35.287311;119.312946,35.2822;119.310576,35.272684;119.310832,35.270809;119.31158,35.267837;119.310749,35.264641;119.304014,35.260004;119.301009,35.258463;119.300472,35.25693;119.304418,35.254662;119.305249,35.252422;119.305672,35.249937;119.303097,35.245051;119.302587,35.242304;119.302971,35.240628;119.310077,35.232338;119.314039,35.231738;119.321769,35.233476;119.325426,35.232957;119.331403,35.230631;119.332541,35.230419;119.333313,35.230488;119.334361,35.230915;119.335009,35.23097;119.336099,35.230777;119.336748,35.230419;119.337106,35.22977;119.337865,35.225508;119.336789,35.225081;119.336906,35.2241;119.338785,35.224427;119.339647,35.224462;119.340406,35.224203;119.340975,35.223893;119.341509,35.22341;119.341854,35.22291;119.34213,35.222307;119.343061,35.222221;119.343406,35.220014;119.344659,35.22004;119.345303,35.220617;119.345268,35.221289;119.346734,35.221634;119.346302,35.223289;119.347078,35.223358;119.346748,35.224711;119.348464,35.224916;119.34863,35.223738;119.349682,35.223876;119.349784,35.223433;119.350233,35.223358;119.350533,35.222247;119.351733,35.222427;119.352026,35.221559;119.352058,35.220213;119.353923,35.220136;119.353951,35.217148;119.35679,35.217106;119.356677,35.215411;119.359074,35.215029;119.35881,35.213232;119.359483,35.213124;119.359052,35.209811;119.356656,35.210036;119.357139,35.213178;119.355416,35.213259;119.355092,35.212477;119.354904,35.211184;119.355389,35.211184;119.355576,35.20894;119.355706,35.208412;119.355413,35.20843;119.355493,35.208155;119.355044,35.208036;119.355026,35.207768;119.355124,35.207562;119.355497,35.207699;119.355977,35.206846;119.355523,35.206632;119.355775,35.206116;119.357011,35.206821;119.358111,35.207645;119.358154,35.206654;119.362824,35.206713;119.362895,35.205663;119.389071,35.205576;119.390687,35.205363;119.390714,35.205369;119.39073,35.205357;119.405197,35.203444;119.399392,35.176638;119.397667,35.166887;119.416631,35.167464;119.416974,35.158164;119.396064,35.157827;119.3937,35.144465;119.393545,35.143591;119.395304,35.139825;119.397708,35.137687;119.413994,35.130204;119.41895,35.128284;119.428257,35.121193;119.432435,35.11138;119.431359,35.108974;119.42946,35.108151;119.426611,35.108214;119.412873,35.110747;119.415222,35.100607;119.408782,35.094887;119.398581,35.094504;119.400973,35.076345;119.395929,35.075757;119.394668,35.082399;119.381552,35.082651;119.374044,35.078695;119.37726,35.075166;119.38037,35.070279;119.357468,35.072823;119.356862,35.078034;119.354073,35.080057;119.350521,35.083887;119.343744,35.083642;119.305845,35.076683;119.301805,35.093155;119.301323,35.093472;119.300301,35.094861;119.300301,35.095904;119.300019,35.096729;119.299584,35.097402;119.298715,35.097814;119.297758,35.098356;119.29678,35.098941;119.295346,35.099982;119.294737,35.101328;119.293912,35.103456;119.293738,35.104195;119.293738,35.104825;119.293542,35.106715;119.293064,35.107931;119.292586,35.1083;119.292325,35.108691;119.292021,35.109038;119.291739,35.109776;119.291557,35.110243;119.291313,35.110434;119.291053,35.110694;119.290444,35.111372;119.290131,35.111684;119.289825,35.112101;119.289046,35.112809;119.28785,35.113934;119.287044,35.114935;119.286668,35.115157;119.285959,35.115128;119.285542,35.115169;119.28493,35.115377;119.284401,35.115446;119.2834,35.115459;119.280228,35.115134;119.277951,35.115341;119.276701,35.115566;119.274589,35.115399;119.273795,35.115492;119.273452,35.115606;119.273196,35.115727;119.273096,35.115777;119.272797,35.116176;119.272299,35.116382;119.271687,35.116381;119.271459,35.116353;119.270997,35.116388;119.269773,35.116579;119.26915,35.116754;119.267841,35.117081;119.267293,35.117173;119.26682,35.117432;119.266002,35.117795;119.265675,35.117937;119.265568,35.118016;119.265298,35.118251;119.265028,35.118528;119.264601,35.118528;119.264409,35.118571;119.264238,35.118706;119.264152,35.118976;119.263996,35.119254;119.263697,35.119553;119.263338,35.119606;119.26294,35.119606;119.262306,35.119542;119.261674,35.119862;119.260795,35.120336;119.260731,35.120378;119.259586,35.12067;119.259337,35.120741;119.259134,35.120894;119.257861,35.120979;119.256951,35.121328;119.256325,35.121855;119.255898,35.122424;119.255519,35.122634;119.254758,35.12279;119.254033,35.122933;119.253613,35.122926;119.253457,35.122869;119.253372,35.122762;119.253272,35.122691;119.25313,35.122641;119.252931,35.122627;119.252675,35.122698;119.251985,35.122954;119.250755,35.123659;119.249919,35.124353;119.249769,35.124513;119.248919,35.123137;119.246264,35.123138;119.243384,35.123029;119.240729,35.122919;119.238847,35.121921;119.237294,35.118596;119.235308,35.116379;119.232758,35.115605;119.22955,35.115165;119.227009,35.114059;119.226229,35.111066;119.223801,35.108629;119.220707,35.10719;119.217275,35.107084;119.213739,35.107199;119.210308,35.108093;119.206773,35.109871;119.203239,35.110876;119.197713,35.120864;119.197211,35.126463;119.196657,35.129901;119.196329,35.130409;119.196266,35.130435;119.196296,35.130461;119.195116,35.132289;119.193453,35.134786;119.192024,35.136507;119.18998,35.138118;119.187763,35.139065;119.184948,35.139514;119.178487,35.138915;119.174226,35.139034;119.169255,35.139986;119.166552,35.141545;119.164232,35.143157;119.163565,35.14482;119.162959,35.147593;119.163072,35.149922;119.163401,35.154133;119.16451,35.156904;119.165446,35.158121;119.169595,35.160277;119.173132,35.161702;119.172621,35.162008;119.171755,35.162368;119.171238,35.16226;119.170338,35.163009;119.169935,35.163513;119.169337,35.163678;119.168748,35.164186;119.1685,35.164406;119.16821,35.164954;119.167891,35.165312;119.167214,35.165777;119.166619,35.166059;119.16602,35.166189;119.165462,35.166199;119.164879,35.166505;119.163976,35.167572;119.163285,35.168197;119.162631,35.169805;119.161904,35.170469;119.161784,35.170895;119.161807,35.17177;119.161722,35.172268;119.160596,35.173589;119.160285,35.175931;119.160028,35.176577;119.159361,35.177551;119.158946,35.177897;119.158195,35.179328;119.157768,35.180564;119.157619,35.181974;119.157313,35.18244;119.155891,35.183343;119.154808,35.184202;119.153586,35.185679;119.153076,35.187105;119.152348,35.187733;119.149189,35.189282;119.148167,35.189184;119.147801,35.189417;119.147288,35.189472;119.146867,35.189327;119.144723,35.189062;119.144394,35.188608;119.144019,35.188497;119.143089,35.188561;119.142161,35.188308;119.140571,35.187842;119.140259,35.187652;119.140249,35.187642;119.14023,35.187635;119.140025,35.187511;119.139917,35.187488;119.135385,35.191652;119.135324,35.193813;119.135385,35.195866;119.136105,35.199856;119.136322,35.200964;119.137154,35.201962;119.139035,35.202346;119.143013,35.20273;119.14887,35.203275;119.153185,35.203322;119.156997,35.203429;119.16131,35.20414;119.164515,35.205909;119.167608,35.208897;119.170207,35.212329;119.171367,35.215542;119.17297,35.219476;119.173958,35.22341;119.174348,35.226346;119.174019,35.228897;119.174573,35.230336;119.177943,35.232826;119.179545,35.235704;119.180923,35.239029;119.182144,35.241853;119.182309,35.246454;119.181981,35.25233;119.182587,35.255266;119.183748,35.256539;119.187498,35.258196;119.188494,35.259802;119.188053,35.26141;119.187005,35.262687;119.185186,35.264685;119.18452,35.266182;119.183472,35.269732;119.182918,35.274002;119.182312,35.277828;119.18104,35.282709;119.179551,35.287589;119.178503,35.288811;119.177395,35.289754;119.174909,35.289983;119.172588,35.289931;119.16811,35.289385;119.164083,35.289558;119.16054,35.290617;119.158496,35.291841;119.156616,35.292896;119.155958,35.293897;119.156729,35.294949;119.158003,35.296554;119.159242,35.298631;119.158636,35.300154;119.157639,35.301709;119.152616,35.305847;119.148249,35.310648;119.145087,35.312968;119.143216,35.314038;119.141976,35.315341;119.141396,35.316727;119.14137,35.317781;119.141284,35.320831;119.142029,35.322131;119.142697,35.322436;119.143962,35.323238;119.14579,35.32476;119.147203,35.325783;119.148191,35.32675;119.148503,35.327832;119.148607,35.329661;119.148529,35.332044;119.147888,35.334151;119.147342,35.334624;119.146484,35.334875;119.145211,35.334987;119.143746,35.335044;119.140869,35.33538;119.137246,35.335413;119.133736,35.335585;119.118766,35.332816;119.105683,35.330641;119.101689,35.329088;119.096158,35.326869;119.094881,35.326814;119.093775,35.327694;119.092742,35.33003;119.092224,35.335128;119.09106,35.336235;119.089618,35.337785;119.088063,35.338948;119.087229,35.340555;119.087229,35.342607;119.087012,35.346208;119.086899,35.349977;119.086239,35.352748;119.08557,35.354244;119.084189,35.354964;119.082746,35.355738;119.080582,35.356179;119.078418,35.357508;119.077861,35.358893;119.078418,35.360666;119.078531,35.363106;119.077758,35.36499;119.075532,35.366095;119.073097,35.365649;119.069984,35.364091;119.065774,35.364567;119.048892,35.371479;119.048614,35.373342;119.044565,35.377012;119.042284,35.378003;119.038008,35.380264;119.031563,35.382632;119.028506,35.384563;119.024333,35.386877;119.019332,35.388636;119.013834,35.389341;119.01055,35.389111;119.002829,35.389252;119.001936,35.389173;118.999657,35.388967;118.998376,35.38846;118.996267,35.387625;118.990988,35.384895;118.990479,35.384671;118.986927,35.383108;118.984427,35.382215;118.983259,35.380272;118.982867,35.378553;118.982981,35.378296;118.984373,35.375176;118.986038,35.372519;118.987092,35.369307;118.988485,35.366986;118.988929,35.364436;118.989653,35.362388;118.989651,35.360667;118.989208,35.358395;118.988371,35.35551;118.986872,35.353123;118.983534,35.350842;118.980642,35.348838;118.978648,35.346393;118.975528,35.342782;118.973029,35.34017;118.970417,35.338556;118.96803,35.336776;118.966027,35.335719;118.963694,35.334938;118.961813,35.334156;118.961066,35.334106;118.960089,35.33404;118.958365,35.334369;118.956808,35.335088;118.954588,35.335914;118.951648,35.336241;118.949759,35.33668;118.94721,35.336954;118.944653,35.336618;118.943398,35.336251;118.943338,35.336233;118.941599,35.335724;118.935337,35.331171;118.934111,35.330781;118.932389,35.330778;118.930451,35.331277;118.925576,35.335151;118.924247,35.336869;118.923248,35.339196;118.923022,35.341857;118.923171,35.343551;118.92336,35.345683;118.921971,35.348396;118.921531,35.348604;118.918729,35.349933;118.917654,35.350444;118.915264,35.351442;118.910775,35.353603;118.907381,35.354788;118.904846,35.355508;118.900992,35.356121;118.896966,35.356419;118.892488,35.356929;118.889549,35.357267;118.888586,35.357458;118.886574,35.358319;118.883573,35.360055;118.877546,35.362384;118.87721,35.362514;118.873656,35.364376;118.872746,35.364921;118.871592,35.366218;118.871038,35.367219;118.870864,35.368166;118.870812,35.368761;118.871074,35.370389;118.871593,35.372194;118.872364,35.373856;118.873535,35.375782;118.874012,35.376921;118.874098,35.377411;118.874047,35.377991;118.873994,35.378672;118.874013,35.379513;118.874186,35.380511;118.874377,35.381458;118.874256,35.382264;118.87397,35.384157;118.873996,35.38491;118.874151,35.386906;118.874151,35.388483;118.873692,35.389676;118.873103,35.390638;118.872488,35.391918;118.871855,35.39297;118.872227,35.393051;118.873128,35.393121;118.874308,35.393174;118.876626,35.392946;118.876648,35.393278;118.876433,35.393681;118.876519,35.393785;118.876584,35.393979;118.876756,35.394224;118.877057,35.394556;118.877356,35.394887;118.877593,35.395011;118.878214,35.394818;118.879266,35.394712;118.881112,35.395989;118.881541,35.396706;118.881563,35.396969;118.88167,35.397283;118.881863,35.397494;118.882014,35.397721;118.882206,35.397949;118.882292,35.397948;118.882529,35.397966;118.883536,35.397318;118.883966,35.396864;118.884073,35.397004;118.884009,35.397248;118.884084,35.397948;118.884599,35.399068;118.885286,35.399698;118.885629,35.400257;118.886316,35.400746;118.887346,35.400746;118.887518,35.400957;118.887604,35.401656;118.888032,35.402427;118.888634,35.402426;118.889406,35.402426;118.892925,35.402286;118.892754,35.402916;118.892066,35.403966;118.893869,35.403125;118.894126,35.402495;118.894298,35.402705;118.893956,35.404454;118.894641,35.404874;118.895414,35.403896;118.896186,35.404314;118.897731,35.403756;118.899032,35.403979;118.899362,35.404035;118.899878,35.404106;118.901508,35.404314;118.904404,35.405469;118.905264,35.405539;118.905134,35.405749;118.905091,35.405924;118.904919,35.406204;118.905005,35.406414;118.905005,35.406799;118.904962,35.407113;118.905134,35.407393;118.905306,35.407569;118.905521,35.407953;118.906379,35.408302;118.906551,35.408758;118.906551,35.408864;118.906593,35.409037;118.906636,35.409073;118.906979,35.409457;118.907108,35.409632;118.907194,35.410018;118.907451,35.410297;118.907666,35.410472;118.907924,35.410472;118.908095,35.410576;118.908439,35.410681;118.908995,35.411136;118.909383,35.411766;118.909854,35.41201;118.911528,35.413375;118.911099,35.413969;118.911099,35.415193;118.910842,35.415613;118.911442,35.415477;118.911999,35.415757;118.912429,35.416246;118.912772,35.416491;118.914918,35.417785;118.917106,35.419184;118.917278,35.418589;118.917234,35.417855;118.917191,35.417156;118.917063,35.416001;118.917836,35.416141;118.917964,35.416281;118.918307,35.416526;118.918994,35.416526;118.919466,35.415862;118.919509,35.414847;118.919767,35.414358;118.920626,35.413972;118.920369,35.412783;118.921142,35.411699;118.921656,35.411454;118.921656,35.410929;118.922558,35.410334;118.923888,35.409705;118.925091,35.40953;118.925391,35.40904;118.925304,35.408727;118.925605,35.408096;118.925347,35.407641;118.925476,35.406663;118.925261,35.406662;118.92539,35.405962;118.925433,35.405577;118.926077,35.404738;118.926463,35.404388;118.926463,35.404108;118.927107,35.403409;118.927836,35.403024;118.929381,35.402534;118.929982,35.402289;118.93083,35.402203;118.930916,35.402657;118.931323,35.403234;118.931795,35.403829;118.931774,35.404143;118.932182,35.404617;118.932396,35.405018;118.932139,35.40535;118.931988,35.4057;118.932224,35.406085;118.932933,35.40647;118.933319,35.406995;118.93319,35.407292;118.932911,35.407222;118.932954,35.407362;118.932847,35.407834;118.932439,35.408429;118.931753,35.408988;118.932203,35.409356;118.932332,35.409495;118.932482,35.409549;118.932654,35.409549;118.932804,35.409495;118.933405,35.409776;118.933941,35.409968;118.934499,35.409985;118.934799,35.409968;118.935014,35.410056;118.935229,35.409968;118.935486,35.410021;118.935722,35.409986;118.936022,35.409846;118.936473,35.40995;118.936752,35.409828;118.937031,35.409846;118.937288,35.409968;118.937031,35.410615;118.937482,35.410756;118.938082,35.410843;118.938388,35.410868;118.93842,35.410929;118.938463,35.41099;118.938507,35.411034;118.938613,35.41106;118.938763,35.410982;118.93901,35.41106;118.939236,35.410754;118.939247,35.410773;118.939344,35.410798;118.939462,35.410868;118.939472,35.410877;118.939548,35.410894;118.939633,35.410912;118.93974,35.410955;118.939793,35.410955;118.939847,35.410964;118.940019,35.411007;118.940041,35.411043;118.940147,35.411052;118.940233,35.411087;118.940266,35.411183;118.940298,35.411235;118.940383,35.411199;118.940426,35.411244;118.940512,35.411253;118.940556,35.411288;118.940619,35.411305;118.940641,35.411358;118.940771,35.411454;118.940426,35.411672;118.940169,35.411829;118.939719,35.411629;118.939472,35.411428;118.939396,35.411541;118.939311,35.411699;118.939183,35.411707;118.939108,35.411777;118.938946,35.411786;118.938817,35.411759;118.938796,35.411777;118.938774,35.411838;118.938774,35.411899;118.938818,35.411908;118.938892,35.411943;118.938989,35.411961;118.939183,35.411969;118.939269,35.411996;118.939343,35.412057;118.939408,35.412241;118.939451,35.412328;118.939526,35.412363;118.939632,35.412258;118.939514,35.412092;118.939525,35.412031;118.939558,35.411908;118.939676,35.411777;118.939804,35.411847;118.940029,35.411935;118.940083,35.411978;118.940147,35.411961;118.940739,35.412118;118.940824,35.412197;118.941081,35.412293;118.941168,35.412241;118.94121,35.412302;118.941296,35.412354;118.941146,35.412486;118.941113,35.41259;118.941274,35.41266;118.941413,35.412634;118.941521,35.412564;118.941671,35.412669;118.942583,35.412984;118.943056,35.413019;118.943045,35.413168;118.943259,35.413394;118.943495,35.413474;118.943399,35.413587;118.943464,35.413666;118.943646,35.413683;118.943753,35.413561;118.944042,35.413561;118.944182,35.413604;118.944171,35.413946;118.944075,35.414261;118.944053,35.414348;118.944171,35.414339;118.944225,35.414434;118.944901,35.414628;118.944977,35.414602;118.944933,35.414811;118.944997,35.414864;118.945127,35.414846;118.945116,35.414907;118.945405,35.415091;118.945491,35.41517;118.945631,35.415144;118.94546,35.414959;118.945233,35.414584;118.94518,35.414558;118.945106,35.414278;118.945212,35.414199;118.944858,35.413587;118.944923,35.413359;118.945041,35.413246;118.945706,35.413325;118.94577,35.413289;118.946628,35.412826;118.946725,35.412827;118.946811,35.412774;118.946982,35.4128;118.947069,35.412835;118.947069,35.41294;118.947069,35.413054;118.947004,35.413168;118.947004,35.41322;118.946897,35.413412;118.946821,35.413456;118.946758,35.413657;118.946769,35.413955;118.946821,35.414182;118.946983,35.414226;118.947025,35.414208;118.946994,35.41364;118.947143,35.413299;118.947229,35.413307;118.947143,35.413605;118.947111,35.413841;118.947154,35.414068;118.947208,35.414138;118.947315,35.414102;118.947304,35.414032;118.947529,35.414007;118.947529,35.413657;118.947616,35.413273;118.947572,35.413273;118.947594,35.413149;118.947777,35.413097;118.947873,35.413124;118.947873,35.413307;118.947949,35.413631;118.948099,35.414051;118.948334,35.414086;118.948516,35.414024;118.948463,35.413919;118.948453,35.413194;118.948356,35.412923;118.94857,35.412905;118.948646,35.413124;118.948678,35.413622;118.948689,35.413876;118.949021,35.413832;118.949258,35.413675;118.949589,35.413377;118.949493,35.413342;118.949471,35.413238;118.950169,35.412844;118.950266,35.412852;118.950331,35.412757;118.950609,35.412616;118.950706,35.41259;118.950812,35.412511;118.951039,35.412529;118.951209,35.412634;118.951243,35.41287;118.951135,35.412931;118.951124,35.413036;118.950931,35.413176;118.951018,35.413176;118.951553,35.413211;118.951575,35.413289;118.951543,35.413613;118.951414,35.414417;118.951371,35.414504;118.951607,35.414522;118.951629,35.414478;118.951714,35.414487;118.951639,35.414767;118.951929,35.414784;118.952025,35.414872;118.952251,35.414862;118.952348,35.414898;118.952283,35.41509;118.952154,35.415055;118.951982,35.415073;118.951714,35.415081;118.951736,35.414942;118.95121,35.414687;118.951103,35.414653;118.951264,35.413359;118.951093,35.413377;118.951072,35.413691;118.950942,35.413691;118.95077,35.414539;118.950663,35.414574;118.950641,35.414687;118.950534,35.414706;118.950502,35.414994;118.95077,35.415038;118.950716,35.415388;118.951361,35.415283;118.951607,35.415134;118.952079,35.415283;118.952026,35.415449;118.952263,35.415545;118.952369,35.415598;118.952412,35.415545;118.952466,35.415396;118.952488,35.415423;118.952498,35.415492;118.952551,35.415484;118.952734,35.415598;118.952724,35.416105;118.952584,35.416322;118.952476,35.416402;118.952433,35.416559;118.952315,35.41669;118.952268,35.416892;118.952525,35.416927;118.952439,35.417277;118.952289,35.417487;118.952311,35.417731;118.952547,35.417819;118.952848,35.417959;118.953984,35.416525;118.954285,35.41635;118.954435,35.416752;118.954843,35.41684;118.955765,35.416612;118.955636,35.41628;118.955981,35.416193;118.956123,35.416333;118.956151,35.416541;118.955981,35.41691;118.956001,35.417364;118.956131,35.417487;118.956409,35.417522;118.957439,35.417172;118.957804,35.416944;118.95804,35.41691;118.958599,35.417032;118.958598,35.417399;118.95862,35.417731;118.958512,35.417731;118.958555,35.417889;118.958383,35.418361;118.959328,35.418448;118.959713,35.418466;118.959971,35.418624;118.959993,35.418835;118.960122,35.419132;118.960036,35.419377;118.960036,35.419551;118.960101,35.419919;118.960273,35.420321;118.960443,35.420566;118.960594,35.420898;118.960831,35.421353;118.960938,35.422245;118.960808,35.422892;118.960422,35.423574;118.960359,35.424186;118.960036,35.424797;118.960014,35.425112;118.960079,35.426074;118.960122,35.426581;118.960079,35.427017;118.959821,35.42805;118.959629,35.428714;118.959693,35.428924;118.959993,35.42894;118.961216,35.42908;118.962118,35.429308;118.962891,35.429605;118.963233,35.429919;118.963577,35.430549;118.963899,35.430864;118.964178,35.431178;118.964071,35.431703;118.964349,35.431965;118.964714,35.431685;118.965336,35.431598;118.966602,35.431755;118.966861,35.431807;118.967118,35.431877;118.967225,35.432035;118.967589,35.432245;118.967632,35.43256;118.968099,35.43359;118.968217,35.434194;118.968239,35.435076;118.968272,35.435452;118.968217,35.436134;118.967659,35.436806;118.967659,35.437087;118.967917,35.437489;118.967778,35.437708;118.967766,35.438014;118.968045,35.438014;118.968314,35.437952;118.96854,35.437821;118.968689,35.437367;118.968603,35.437166;118.968534,35.437104;118.968684,35.437104;118.968834,35.437244;118.968963,35.437244;118.969027,35.437697;118.968877,35.437872;118.968984,35.438012;118.968814,35.438083;118.968921,35.438153;118.969134,35.438223;118.969606,35.438677;118.969843,35.439184;118.970315,35.439639;118.970722,35.440162;118.97134,35.440635;118.971361,35.440854;118.971361,35.441055;118.971264,35.441326;118.971169,35.441745;118.971103,35.442182;118.970985,35.442506;118.970899,35.442584;118.970889,35.442698;118.970793,35.44289;118.970567,35.443249;118.970493,35.443317;118.970481,35.443441;118.97047,35.443563;118.970406,35.443729;118.970417,35.443939;118.970471,35.444;118.970546,35.444297;118.970696,35.444471;118.970835,35.444629;118.97089,35.444831;118.970985,35.445197;118.971051,35.44546;118.970686,35.445572;118.970706,35.445661;118.970761,35.445879;118.970879,35.446037;118.971007,35.446254;118.971146,35.446377;118.971296,35.446281;118.971479,35.445993;118.9715,35.445642;118.971479,35.445486;118.971414,35.445442;118.971532,35.445233;118.971597,35.445241;118.971641,35.44525;118.971683,35.445259;118.971876,35.445267;118.972015,35.445285;118.972081,35.445329;118.972305,35.445425;118.972434,35.445565;118.972519,35.445678;118.972573,35.445966;118.972596,35.446063;118.972531,35.446203;118.972337,35.44643;118.972199,35.446544;118.972165,35.446648;118.972273,35.446727;118.97238,35.446787;118.97253,35.446876;118.972671,35.446902;118.972649,35.446972;118.972702,35.447059;118.972863,35.447007;118.972874,35.446937;118.972971,35.446893;118.972982,35.446832;118.973099,35.446911;118.973142,35.446954;118.973239,35.447182;118.973089,35.44719;118.973089,35.447338;118.973024,35.447374;118.972927,35.447539;118.972841,35.447566;118.972649,35.447689;118.972487,35.447776;118.972509,35.447811;118.972466,35.44789;118.972412,35.448056;118.972423,35.448257;118.972605,35.448362;118.972648,35.448318;118.972831,35.448335;118.972874,35.448414;118.973003,35.448475;118.973174,35.448431;118.973121,35.448274;118.973292,35.448264;118.973346,35.448292;118.973529,35.448606;118.973453,35.448711;118.973721,35.448684;118.973829,35.448545;118.973861,35.448414;118.974064,35.44844;118.973968,35.448624;118.974043,35.448729;118.974129,35.448763;118.974182,35.448869;118.974216,35.449454;118.974119,35.449479;118.974141,35.449716;118.974108,35.449847;118.974108,35.44997;118.974269,35.449987;118.974259,35.449489;118.974461,35.449507;118.974473,35.449061;118.974731,35.449008;118.974891,35.449017;118.974933,35.44865;118.975019,35.448659;118.974992,35.448781;118.975143,35.448798;118.975229,35.448886;118.975207,35.449078;118.975358,35.449096;118.975387,35.449533;118.97565,35.449594;118.975747,35.449651;118.975929,35.449677;118.975994,35.449804;118.976574,35.449708;118.976761,35.449664;118.976997,35.449611;118.977056,35.449562;118.977056,35.449532;118.97712,35.449463;118.977276,35.449414;118.977485,35.449397;118.977706,35.449362;118.977957,35.449362;118.978381,35.449292;118.978482,35.449257;118.97859,35.449257;118.978784,35.449209;118.979019,35.449109;118.979384,35.448965;118.979444,35.449039;118.979502,35.449052;118.979534,35.449096;118.979636,35.449083;118.979748,35.449096;118.979872,35.449218;118.979748,35.449292;118.979358,35.449489;118.979213,35.449485;118.978896,35.449423;118.978869,35.449357;118.978837,35.44934;118.978408,35.449467;118.978403,35.449384;118.977302,35.449524;118.977318,35.449619;118.97727,35.449632;118.977324,35.449777;118.977141,35.449807;118.976921,35.449812;118.976814,35.449834;118.976761,35.449886;118.976621,35.449939;118.976456,35.450083;118.976493,35.450104;118.977116,35.45007;118.977356,35.450031;118.977388,35.449996;118.977656,35.449974;118.978359,35.449869;118.978509,35.449887;118.978526,35.449943;118.9783,35.449978;118.977919,35.45007;118.978146,35.450332;118.978355,35.450551;118.978204,35.450564;118.978096,35.450437;118.978069,35.450437;118.977834,35.450442;118.977453,35.450567;118.977141,35.450673;118.976653,35.450887;118.976691,35.451001;118.977002,35.450896;118.977034,35.450992;118.977656,35.450764;118.977721,35.450769;118.978166,35.450691;118.978509,35.450686;118.978896,35.451071;118.979036,35.451102;118.979158,35.451184;118.979256,35.451281;118.979233,35.451416;118.97926,35.451569;118.979239,35.451879;118.97911,35.451845;118.978869,35.451718;118.978736,35.451901;118.978842,35.451957;118.978756,35.452107;118.978896,35.452146;118.979132,35.452137;118.979239,35.452198;118.979319,35.452203;118.979385,35.452247;118.979529,35.452255;118.979546,35.452434;118.979149,35.452442;118.979008,35.452442;118.978901,35.452465;118.978913,35.452915;118.978869,35.452994;118.978751,35.453347;118.978719,35.45353;118.978976,35.453566;118.97904,35.453689;118.979213,35.453715;118.979282,35.453793;118.979417,35.453793;118.979419,35.453834;118.979525,35.454323;118.979569,35.454341;118.979419,35.454446;118.979075,35.454568;118.979033,35.454446;118.978989,35.454287;118.978796,35.454253;118.978624,35.454358;118.978453,35.454533;118.978474,35.454689;118.978539,35.454848;118.978646,35.454988;118.979332,35.454759;118.979419,35.454759;118.979676,35.454969;118.979869,35.455197;118.979869,35.455336;118.978646,35.455511;118.978732,35.455599;118.979332,35.455599;118.979439,35.455599;118.979439,35.455722;118.979718,35.455687;118.980019,35.455617;118.980341,35.455722;118.980405,35.455861;118.980449,35.456071;118.980577,35.456333;118.980728,35.456386;118.980964,35.4567;118.981521,35.457049;118.982529,35.457364;118.983336,35.457313;118.984794,35.457417;118.985223,35.457802;118.985439,35.458466;118.985137,35.458676;118.984236,35.458816;118.983421,35.459025;118.983362,35.45934;118.983469,35.459506;118.983587,35.459541;118.984006,35.459663;118.984039,35.459777;118.984511,35.4601;118.984585,35.460459;118.984574,35.46066;118.984488,35.460948;118.984338,35.461167;118.984263,35.461342;118.984402,35.461639;118.984424,35.461893;118.984456,35.462076;118.984424,35.462295;118.984273,35.462487;118.983953,35.462705;118.983544,35.46267;118.983222,35.462565;118.982771,35.462321;118.982675,35.462181;118.982568,35.462181;118.98231,35.462382;118.98216,35.462399;118.98202,35.462417;118.981849,35.462478;118.981784,35.462477;118.981741,35.462548;118.981623,35.462513;118.981571,35.462452;118.981387,35.462496;118.981034,35.462321;118.980981,35.462251;118.980841,35.462295;118.980798,35.462286;118.980819,35.462356;118.980809,35.462461;118.980851,35.462574;118.980873,35.462915;118.980894,35.46309;118.980959,35.463142;118.980959,35.463238;118.981002,35.463256;118.981088,35.463403;118.981088,35.463579;118.981044,35.463727;118.981023,35.463859;118.981001,35.463981;118.981044,35.464138;118.981634,35.464261;118.981698,35.464706;118.981548,35.464654;118.981516,35.464749;118.981473,35.464715;118.981344,35.464724;118.981238,35.464663;118.980991,35.464663;118.981001,35.464593;118.980926,35.464497;118.980809,35.464479;118.98082,35.464409;118.980239,35.464147;118.979542,35.463937;118.979661,35.464077;118.979811,35.46419;118.979811,35.464523;118.979853,35.464636;118.979939,35.464636;118.980035,35.464706;118.980272,35.464829;118.980362,35.465091;118.980556,35.465633;118.980888,35.466192;118.981274,35.466646;118.981403,35.467101;118.981447,35.467625;118.981103,35.468009;118.981017,35.468464;118.981296,35.469172;118.981361,35.469085;118.982154,35.46884;118.982391,35.468578;118.982519,35.468665;118.982434,35.46912;118.982627,35.46919;118.983184,35.469085;118.983442,35.46884;118.983485,35.468526;118.984001,35.468631;118.98428,35.4687;118.984644,35.468875;118.985031,35.468998;118.985309,35.469137;118.985417,35.469295;118.986167,35.470116;118.986296,35.470431;118.986811,35.4705;118.987091,35.471182;118.987176,35.471636;118.987154,35.471933;118.987283,35.472196;118.987583,35.472073;118.987776,35.472196;118.988099,35.472737;118.987863,35.473034;118.987477,35.473192;118.986511,35.473174;118.985867,35.473174;118.984408,35.473891;118.984365,35.474223;118.984451,35.474485;118.984901,35.474834;118.985695,35.475079;118.985911,35.475044;118.986167,35.474922;118.986662,35.474799;118.987519,35.474886;118.988206,35.474781;118.988571,35.474537;118.989365,35.474485;118.991653,35.473663;118.992982,35.473419;118.992982,35.472825;118.992811,35.47237;118.992811,35.471846;118.993068,35.471251;118.993926,35.470797;118.994141,35.470378;118.994355,35.470552;118.994398,35.470937;118.994741,35.471042;118.9953,35.471252;118.995601,35.471112;118.995514,35.470622;118.996243,35.471217;118.996286,35.471566;118.996286,35.471741;118.996416,35.472126;118.996716,35.472196;118.997574,35.471741;118.997316,35.471042;118.997359,35.470168;118.997789,35.469609;118.997736,35.469242;118.998185,35.469015;118.998336,35.469032;118.998464,35.468753;118.998744,35.468857;118.999022,35.468542;118.999323,35.468071;118.999559,35.467494;119.000139,35.467599;119.000374,35.467756;119.000803,35.467914;119.001426,35.467862;119.001704,35.468001;119.001856,35.468001;119.002499,35.467495;119.002563,35.467425;119.002928,35.467897;119.003249,35.468036;119.003272,35.468194;119.003657,35.468542;119.003314,35.468998;119.003292,35.469417;119.004022,35.469207;119.004172,35.469399;119.004194,35.469452;119.004323,35.469277;119.004344,35.46912;119.004258,35.468472;119.004431,35.468542;119.004451,35.468787;119.004644,35.46905;119.004903,35.469155;119.004987,35.469015;119.004666,35.468664;119.004623,35.468141;119.004537,35.468071;119.004816,35.467774;119.004751,35.467284;119.00501,35.467284;119.005266,35.467214;119.005481,35.467214;119.006189,35.467302;119.00649,35.467354;119.006683,35.467599;119.006575,35.467774;119.006661,35.467984;119.007713,35.467914;119.008549,35.468036;119.008904,35.468211;119.009764,35.467827;119.010407,35.468036;119.011353,35.468071;119.011867,35.46793;119.012553,35.467897;119.013241,35.467897;119.013669,35.468106;119.014613,35.467966;119.015214,35.46793;119.015471,35.468281;119.015343,35.468631;119.015815,35.468734;119.016201,35.468875;119.016244,35.469329;119.016802,35.469608;119.018132,35.469469;119.018561,35.469468;119.018948,35.469539;119.019505,35.469959;119.019291,35.470483;119.019464,35.470728;119.019651,35.470771;119.019919,35.470701;119.020182,35.47067;119.020392,35.470701;119.020434,35.470779;119.020414,35.471016;119.020521,35.471046;119.020634,35.471089;119.020729,35.471064;119.020799,35.471067;119.020901,35.471181;119.020971,35.471186;119.0211,35.471111;119.021314,35.470902;119.021411,35.470717;119.021357,35.470604;119.021357,35.470474;119.021411,35.470378;119.021566,35.470254;119.02169,35.470334;119.02169,35.470394;119.021754,35.470417;119.021793,35.470482;119.02169,35.470582;119.021551,35.470727;119.021368,35.470941;119.021111,35.471173;119.021057,35.471215;119.020783,35.471215;119.020751,35.471247;119.020799,35.471347;119.02089,35.471365;119.020939,35.471365;119.020719,35.471793;119.020585,35.471946;119.020504,35.471958;119.020456,35.472081;119.020424,35.472099;119.020418,35.472147;119.020504,35.472195;119.020596,35.472291;119.020579,35.472408;119.020692,35.472466;119.021266,35.472596;119.021459,35.472561;119.021696,35.472592;119.02151,35.474379;119.021359,35.474554;119.021402,35.474921;119.021295,35.475026;119.021059,35.474729;119.020415,35.475096;119.020995,35.475306;119.021209,35.475236;119.021402,35.475322;119.02166,35.475428;119.021831,35.475409;119.021897,35.475637;119.021939,35.475741;119.021982,35.475916;119.022176,35.476144;119.022218,35.476424;119.022196,35.476651;119.022196,35.477052;119.022219,35.477245;119.022368,35.477612;119.022475,35.477874;119.02254,35.478241;119.022604,35.478451;119.022771,35.478414;119.022858,35.478318;119.022932,35.478309;119.023019,35.478388;119.023072,35.478423;119.023147,35.478598;119.023201,35.478588;119.023179,35.478449;119.023169,35.478309;119.023147,35.478143;119.023072,35.478108;119.023254,35.477959;119.02349,35.477793;119.023726,35.477846;119.023855,35.477925;119.023823,35.478256;119.023726,35.478572;119.023716,35.478921;119.023855,35.479742;119.024102,35.479724;119.024059,35.478283;119.024177,35.478161;119.024273,35.478205;119.02422,35.478379;119.024188,35.478519;119.024263,35.479716;119.024413,35.479734;119.024381,35.478458;119.024402,35.478221;119.024499,35.478212;119.024499,35.478282;119.024585,35.478439;119.024627,35.478772;119.024789,35.478807;119.024821,35.478729;119.024874,35.478825;119.024939,35.47886;119.025218,35.47927;119.025303,35.479498;119.025475,35.479821;119.025669,35.479768;119.025829,35.479856;119.026119,35.479856;119.026387,35.479872;119.026484,35.479872;119.026666,35.48058;119.026977,35.48066;119.027106,35.480258;119.027074,35.479209;119.02731,35.479183;119.027449,35.479244;119.028179,35.479427;119.028232,35.479349;119.028307,35.479393;119.028426,35.479524;119.028747,35.479594;119.029026,35.479636;119.02908,35.479707;119.029359,35.479872;119.029563,35.479952;119.029939,35.479908;119.03011,35.480004;119.030153,35.480099;119.030346,35.480258;119.030571,35.480187;119.030658,35.480162;119.030636,35.479952;119.030807,35.479724;119.03099,35.479086;119.030582,35.478991;119.030711,35.478641;119.031043,35.478711;119.031376,35.478614;119.031762,35.478615;119.031837,35.479086;119.031612,35.479157;119.031505,35.479323;119.031451,35.479402;119.031451,35.479498;119.031472,35.479524;119.031494,35.479856;119.031269,35.479882;119.031247,35.47976;119.031215,35.479759;119.031204,35.479821;119.031151,35.479812;119.031161,35.479751;119.031022,35.479742;119.03099,35.479821;119.030947,35.479872;119.030947,35.480031;119.030937,35.480301;119.031,35.480301;119.031022,35.48059;119.030957,35.480632;119.030979,35.480694;119.031151,35.480711;119.031365,35.480702;119.031462,35.480502;119.03173,35.480475;119.03188,35.480467;119.031966,35.480467;119.032084,35.480415;119.032105,35.480336;119.032256,35.480319;119.032278,35.480144;119.03261,35.480162;119.032728,35.480108;119.03276,35.479977;119.033243,35.479968;119.03335,35.480432;119.033136,35.480686;119.033007,35.480843;119.032427,35.480825;119.032148,35.480887;119.031977,35.480938;119.031849,35.481236;119.031719,35.481332;119.031794,35.481366;119.031987,35.481331;119.032513,35.481297;119.032706,35.481253;119.033071,35.481244;119.033262,35.481086',
      bounds4: '119.525453,35.730589;119.525246,35.730808;119.524719,35.731468;119.523673,35.731859;119.522479,35.731622;119.520482,35.728896;119.521139,35.727705;119.520525,35.726382;119.519003,35.724952;119.517836,35.72421;119.517767,35.723731;119.51838,35.722023;119.519841,35.718779;119.521077,35.71686;119.521172,35.714502;119.519651,35.712809;119.519365,35.711602;119.52086,35.71;119.520843,35.709329;119.519935,35.707648;119.519866,35.705411;119.519459,35.702579;119.518491,35.700643;119.517721,35.700031;119.515499,35.698776;119.514842,35.698008;119.514825,35.697623;119.515058,35.697321;119.515603,35.697119;119.51594,35.696276;119.515637,35.694798;119.515438,35.693831;119.515568,35.693342;119.515844,35.693119;119.517435,35.693082;119.517971,35.692753;119.518429,35.692206;119.518481,35.69187;119.518343,35.691436;119.518144,35.691076;119.518446,35.688965;119.519111,35.685537;119.519855,35.684414;119.523927,35.681512;119.527384,35.677221;119.528266,35.67432;119.527557,35.6708;119.526778,35.663262;119.527425,35.653846;119.526534,35.651568;119.52522,35.64992;119.524485,35.648534;119.524433,35.647095;119.526294,35.64663;119.526369,35.644951;119.523681,35.642639;119.523351,35.637164;119.523144,35.636803;119.520178,35.637543;119.519374,35.636551;119.51988,35.635141;119.522288,35.634492;119.524207,35.633506;119.524466,35.632287;119.518578,35.62784;119.517774,35.625786;119.517696,35.623313;119.517981,35.619041;119.518144,35.615429;119.518724,35.614203;119.522562,35.610876;119.530524,35.607375;119.536872,35.606025;119.537529,35.605124;119.538756,35.598184;119.538419,35.595449;119.536447,35.593424;119.536248,35.592217;119.534786,35.592355;119.530981,35.592948;119.528647,35.594215;119.526067,35.598468;119.525189,35.598987;119.522768,35.600623;119.521419,35.601358;119.516855,35.601537;119.511098,35.602151;119.507259,35.601998;119.504251,35.602604;119.500577,35.604343;119.497007,35.605385;119.495589,35.604957;119.494491,35.604097;119.492909,35.601841;119.491352,35.599088;119.490064,35.597927;119.487945,35.597436;119.482455,35.598316;119.479687,35.598571;119.47481,35.598104;119.472422,35.597079;119.470242,35.596453;119.467889,35.595097;119.465908,35.593973;119.464281,35.592681;119.463459,35.591086;119.463917,35.588395;119.463389,35.586103;119.459858,35.581112;119.458949,35.578836;119.456932,35.576817;119.455175,35.574558;119.452864,35.572085;119.450846,35.569832;119.4494,35.568259;119.447659,35.566457;119.445936,35.56512;119.443927,35.563326;119.440852,35.563391;119.43698,35.565079;119.434502,35.566507;119.432041,35.568852;119.429892,35.571654;119.427171,35.574462;119.425255,35.575875;119.422454,35.576163;119.41883,35.577153;119.416323,35.577662;119.412697,35.578193;119.40993,35.579392;119.406849,35.579683;119.402353,35.579541;119.400096,35.579124;119.397543,35.578252;119.393826,35.576029;119.391255,35.5747;119.388675,35.572911;119.385539,35.57113;119.382967,35.569571;119.379552,35.568023;119.374962,35.564893;119.371842,35.564033;119.369555,35.562464;119.366991,35.561134;119.362739,35.560057;119.359912,35.55942;119.354869,35.559965;119.352929,35.560915;119.350685,35.561411;119.348746,35.562365;119.346841,35.564461;119.345214,35.566558;119.34471,35.568631;119.344771,35.570696;119.344841,35.572989;119.345459,35.575044;119.346103,35.577786;119.346164,35.579856;119.345686,35.582847;119.342372,35.584966;119.340182,35.584622;119.340168,35.584617;119.340141,35.584616;119.338414,35.584344;119.335552,35.582784;119.333246,35.580758;119.331515,35.579181;119.330036,35.576683;119.328574,35.574871;119.327687,35.573048;119.325921,35.570551;119.323841,35.566456;119.321788,35.563506;119.3203,35.561006;119.319404,35.558726;119.317072,35.556012;119.315046,35.553748;119.312166,35.551732;119.310705,35.549462;119.308409,35.547893;119.304999,35.546571;119.302756,35.547072;119.298217,35.545313;119.29593,35.543971;119.293061,35.541952;119.29106,35.540194;119.287887,35.540409;119.287552,35.540162;119.287306,35.540132;119.287164,35.539984;119.287041,35.53876;119.286783,35.538196;119.285821,35.536987;119.285619,35.536495;119.285002,35.536127;119.284181,35.535186;119.284236,35.534601;119.282708,35.533413;119.279571,35.531629;119.276217,35.532145;119.272595,35.532898;119.270137,35.535466;119.268496,35.537102;119.267428,35.539184;119.265813,35.541514;119.264754,35.543826;119.263121,35.545693;119.261498,35.547788;119.260144,35.549647;119.258547,35.552661;119.256064,35.554311;119.253322,35.556886;119.250831,35.557848;119.248341,35.559041;119.246414,35.560457;119.243994,35.564171;119.243492,35.566473;119.242711,35.568784;119.241679,35.572016;119.240899,35.574097;119.239563,35.576649;119.237638,35.577829;119.234854,35.578799;119.230674,35.579795;119.227892,35.580538;119.2251,35.580822;119.222292,35.580874;119.218409,35.582326;119.214804,35.583772;119.210931,35.585454;119.207881,35.586199;119.205646,35.586702;119.203142,35.58744;119.200084,35.588417;119.198506,35.588802;119.197762,35.588837;119.195885,35.588482;119.195215,35.58823;119.194619,35.587332;119.195724,35.584833;119.195651,35.582156;119.194381,35.577429;119.19311,35.572122;119.192348,35.571328;119.191609,35.57109;119.191204,35.57125;119.185615,35.577276;119.185591,35.578123;119.186612,35.579367;119.190803,35.580863;119.191804,35.584785;119.191577,35.587798;119.188696,35.591331;119.186616,35.591435;119.18585,35.590939;119.185326,35.589363;119.185136,35.588053;119.184622,35.587305;119.178766,35.585248;119.174997,35.581646;119.173275,35.581276;119.172191,35.581701;119.171124,35.583328;119.169908,35.583415;119.168048,35.582517;119.165672,35.579051;119.165353,35.578084;119.165323,35.576985;119.166033,35.575834;119.17033,35.57331;119.170947,35.57216;119.170725,35.571355;119.168465,35.567622;119.166278,35.567172;119.159455,35.565234;119.158468,35.564647;119.158399,35.563643;119.15765,35.561925;119.156186,35.559426;119.152487,35.557432;119.148813,35.555896;119.145157,35.555276;119.140096,35.55468;119.137028,35.555198;119.134817,35.556615;119.132052,35.557812;119.129278,35.559009;119.126781,35.559974;119.124856,35.561155;119.122332,35.561433;119.117336,35.563355;119.113727,35.564797;119.111845,35.567811;119.110196,35.569217;119.105761,35.571359;119.104485,35.570223;119.101334,35.570666;119.099944,35.570056;119.099006,35.568726;119.097348,35.56734;119.096453,35.565512;119.094577,35.56418;119.092249,35.563126;119.088972,35.561961;119.086869,35.561127;119.085427,35.560238;119.083489,35.558076;119.081046,35.556302;119.078221,35.555632;119.075726,35.554467;119.073004,35.552746;119.070342,35.551964;119.067124,35.551905;119.054546,35.580042;119.05083,35.588817;119.050325,35.590888;119.050116,35.594105;119.049917,35.597318;119.049682,35.599159;119.050048,35.602369;119.050806,35.605346;119.05158,35.607395;119.052747,35.609215;119.054505,35.611714;119.055672,35.613301;119.059414,35.617664;119.061355,35.619828;119.063966,35.620886;119.067297,35.622942;119.069515,35.623666;119.071568,35.623556;119.074951,35.622621;119.078124,35.622147;119.082905,35.622076;119.09003,35.622746;119.090699,35.623189;119.090256,35.624518;119.088484,35.62679;119.087259,35.629503;119.086808,35.631648;119.087373,35.632995;119.088424,35.634268;119.089371,35.635433;119.091475,35.63743;119.094143,35.640756;119.095576,35.64397;119.09621,35.647334;119.097018,35.649844;119.099155,35.652563;119.108818,35.657214;119.110979,35.659873;119.111638,35.662087;119.110588,35.662976;119.104886,35.665191;119.100624,35.669457;119.101232,35.670732;119.110147,35.676937;119.111198,35.678932;119.111198,35.680593;119.111424,35.682588;119.111589,35.685358;119.110869,35.687686;119.10843,35.689458;119.105115,35.690401;119.098412,35.691731;119.096745,35.692506;119.096415,35.693559;119.097527,35.695995;119.097414,35.696883;119.096746,35.697879;119.095252,35.698378;119.092151,35.698155;119.089822,35.698539;119.087936,35.699758;119.087103,35.701972;119.085052,35.704076;119.082836,35.706013;119.081393,35.706733;119.07929,35.707894;119.07696,35.709331;119.074743,35.711545;119.073187,35.713924;119.072631,35.715641;119.072579,35.718965;119.072301,35.720849;119.071362,35.722454;119.069362,35.724058;119.068309,35.725662;119.066805,35.727766;119.063534,35.731417;119.061203,35.734458;119.056983,35.738827;119.053711,35.741204;119.048549,35.745567;119.045937,35.747335;119.045598,35.748387;119.046878,35.754373;119.046269,35.755978;119.045268,35.757194;119.044658,35.757692;119.042995,35.758241;119.038824,35.758841;119.03338,35.759434;119.028049,35.759864;119.023711,35.760074;119.019651,35.760448;119.015321,35.761045;119.009152,35.762579;119.003531,35.765165;119.001362,35.767983;118.999088,35.770803;118.996753,35.773344;118.99447,35.775331;118.991857,35.777151;118.989304,35.778861;118.985967,35.780735;118.982639,35.781779;118.978371,35.782069;118.974991,35.782342;118.971577,35.781469;118.967589,35.779915;118.96475,35.779033;118.963026,35.777681;118.959578,35.775435;118.957289,35.773628;118.954443,35.772524;118.951623,35.772788;118.947142,35.773997;118.942949,35.775429;118.940444,35.777072;118.938505,35.778247;118.936262,35.778965;118.93374,35.779691;118.929759,35.78366;118.927326,35.78719;118.926431,35.792184;118.925928,35.794489;118.925989,35.797007;118.926041,35.799072;118.925815,35.801599;118.925042,35.804822;118.92539,35.807341;118.925755,35.811006;118.926373,35.813292;118.92699,35.81512;118.928468,35.818306;118.929641,35.819901;118.931085,35.821481;118.932241,35.823069;118.933719,35.825576;118.93405,35.827632;118.934659,35.829691;118.937946,35.837214;118.94722,35.847406;118.950378,35.849656;118.956976,35.853924;118.960397,35.855256;118.964053,35.854748;118.96683,35.852879;118.968206,35.851252;118.969573,35.849625;118.971489,35.847077;118.97485,35.845659;118.977097,35.845403;118.980233,35.846277;118.983866,35.847592;118.987699,35.847493;118.990871,35.847669;118.994095,35.846515;118.998765,35.844369;119.001431,35.8436;119.008324,35.844563;119.011217,35.846178;119.015879,35.850457;119.018162,35.851517;119.021717,35.851803;119.025551,35.851925;119.02833,35.851989;119.031004,35.852551;119.033722,35.854442;119.036335,35.857108;119.037781,35.859993;119.038641,35.862814;119.03845,35.863561;119.037723,35.865542;119.036447,35.870411;119.035873,35.872289;119.03281,35.876084;119.03002,35.882668;119.029654,35.885402;119.029972,35.890551;119.028907,35.89759;119.028958,35.89956;119.029314,35.900692;119.030352,35.901082;119.032703,35.901049;119.034842,35.900678;119.039031,35.897043;119.041509,35.895908;119.04243,35.894758;119.044675,35.892483;119.045235,35.892463;119.04604,35.893113;119.046479,35.893626;119.046909,35.894592;119.047827,35.894579;119.051394,35.894097;119.053056,35.894564;119.054034,35.895662;119.054409,35.899294;119.055528,35.899846;119.056814,35.899625;119.058558,35.897287;119.060472,35.897902;119.063852,35.904028;119.063085,35.906844;119.05773,35.910336;119.05321,35.913689;119.046147,35.921145;119.046526,35.922529;119.047353,35.923199;119.053916,35.9277;119.056237,35.934361;119.056323,35.944845;119.053515,35.951847;119.053524,35.95402;119.054528,35.956076;119.055739,35.957132;119.05687,35.957519;119.05797,35.957263;119.060507,35.954849;119.0608,35.954499;119.062062,35.955488;119.063838,35.955934;119.0665,35.955939;119.069944,35.956166;119.07371,35.956392;119.078814,35.959279;119.082917,35.959837;119.088904,35.963165;119.091789,35.963278;119.095003,35.962394;119.099103,35.962174;119.105197,35.962618;119.109849,35.962728;119.116157,35.962615;119.121805,35.962722;119.125231,35.963718;119.134412,35.968581;119.140826,35.969237;119.153256,35.971211;119.155096,35.96578;119.158224,35.966868;119.16304,35.968381;119.165326,35.969484;119.170419,35.970532;119.172966,35.97094;119.175503,35.971122;119.178595,35.971062;119.180526,35.969647;119.181894,35.968014;119.18237,35.965026;119.182586,35.962267;119.182526,35.960435;119.182456,35.957915;119.182412,35.956079;119.18236,35.954245;119.182005,35.951272;119.181649,35.948754;119.18158,35.946232;119.181519,35.94394;119.182038,35.942096;119.181692,35.939811;119.180479,35.93639;119.180141,35.934563;119.180383,35.932724;119.180305,35.929972;119.179672,35.927233;119.179369,35.926237;119.179423,35.926157;119.180261,35.924955;119.180847,35.924406;119.182943,35.920118;119.183448,35.918769;119.183053,35.917879;119.181845,35.917361;119.178482,35.917302;119.17359,35.917968;119.169665,35.9172;119.163202,35.913096;119.15178,35.905489;119.144686,35.904439;119.135959,35.896901;119.134514,35.895058;119.135606,35.892966;119.139754,35.891624;119.148762,35.887837;119.156234,35.882916;119.158235,35.882472;119.159948,35.883942;119.160507,35.886306;119.160411,35.893028;119.161875,35.894464;119.165371,35.894901;119.169133,35.894826;119.17145,35.894047;119.173694,35.892297;119.175984,35.889789;119.181653,35.886142;119.190599,35.879451;119.192424,35.878815;119.196045,35.877828;119.207878,35.878748;119.217081,35.879512;119.22424,35.88121;119.230256,35.882015;119.236283,35.883126;119.240438,35.884272;119.242745,35.886366;119.244437,35.888147;119.247283,35.88924;119.250989,35.890776;119.254417,35.892547;119.257863,35.894783;119.260442,35.89634;119.263889,35.898803;119.267059,35.90127;119.268796,35.902842;119.272227,35.90439;119.275694,35.907312;119.276335,35.907296;119.27883,35.908634;119.281976,35.910183;119.285391,35.911269;119.288798,35.912357;119.291058,35.912318;119.294414,35.911346;119.296891,35.909009;119.297952,35.906694;119.298186,35.904628;119.297795,35.900968;119.297168,35.898909;119.297107,35.896621;119.298116,35.893034;119.301111,35.890891;119.301971,35.891098;119.303258,35.892176;119.302743,35.892766;119.306906,35.893462;119.308323,35.894818;119.311241,35.894957;119.311584,35.896069;119.312485,35.89673;119.311929,35.897115;119.313731,35.897359;119.314503,35.895481;119.315472,35.890731;119.313884,35.890644;119.314936,35.890262;119.315106,35.889271;119.312614,35.888282;119.316012,35.887547;119.32318,35.888346;119.329248,35.89068;119.331617,35.890495;119.334986,35.893648;119.34178,35.894451;119.34552,35.893776;119.350687,35.890332;119.353652,35.888753;119.356974,35.886562;119.359174,35.884688;119.360661,35.884052;119.361366,35.882918;119.362678,35.879679;119.364269,35.876213;119.366164,35.873426;119.367216,35.870884;119.368302,35.869259;119.369085,35.867181;119.370432,35.865097;119.370927,35.862792;119.371423,35.860487;119.369275,35.856718;119.368858,35.8552;119.367675,35.853084;119.366075,35.850947;119.362918,35.849393;119.359483,35.847622;119.358283,35.845115;119.362308,35.842222;119.364209,35.838001;119.369377,35.833807;119.372357,35.830013;119.371905,35.826386;119.372063,35.823562;119.373696,35.822366;119.373617,35.819844;119.374077,35.816164;119.373443,35.813882;119.372825,35.81183;119.372199,35.809775;119.372112,35.806794;119.372581,35.803341;119.372485,35.800365;119.371833,35.797162;119.371485,35.794875;119.371711,35.792809;119.370772,35.79007;119.370397,35.786865;119.369771,35.784581;119.368832,35.781386;119.368206,35.779103;119.367293,35.777053;119.36724,35.775218;119.367475,35.773382;119.368805,35.770831;119.373316,35.770752;119.375846,35.77071;119.378132,35.771816;119.381556,35.773359;119.38557,35.775583;119.387577,35.776921;119.390444,35.778705;119.392511,35.781878;119.396533,35.78505;119.397722,35.786827;119.399728,35.788167;119.402307,35.789492;119.405189,35.791961;119.407471,35.793064;119.411177,35.794598;119.416053,35.797715;119.419184,35.799027;119.421465,35.800128;119.42515,35.801201;119.427716,35.802069;119.431651,35.802447;119.436452,35.803264;119.438964,35.802755;119.441796,35.803609;119.444334,35.804013;119.448898,35.806211;119.451461,35.807531;119.45572,35.809046;119.459373,35.809195;119.461614,35.809146;119.464686,35.808621;119.469954,35.806437;119.47299,35.804762;119.475178,35.803109;119.479597,35.800716;119.482373,35.799733;119.484578,35.798305;119.487033,35.796411;119.488952,35.794762;119.49139,35.792183;119.493283,35.789846;119.494623,35.787751;119.495946,35.785426;119.496741,35.78357;119.497242,35.781725;119.496602,35.779216;119.492599,35.776553;119.49061,35.775451;119.488025,35.773449;119.486563,35.771646;119.485327,35.767773;119.485249,35.76525;119.486519,35.760864;119.488092,35.754598;119.489579,35.753065;119.49206,35.751996;119.493815,35.751724;119.496098,35.751452;119.499175,35.752073;119.503178,35.752295;119.504068,35.752325;119.506247,35.751719;119.506912,35.75132;119.507707,35.750653;119.509989,35.748354;119.510914,35.746723;119.511346,35.744362;119.512401,35.74313;119.513922,35.741432;119.515608,35.739998;119.5168,35.739063;119.518356,35.737963;119.518456,35.737847;119.524356,35.733781;119.529448,35.732003;119.530754,35.73116;119.530728,35.730402;119.529439,35.729681;119.527537,35.729492;119.527252,35.729435;119.525453,35.730589',
      selectedTagType: 1,
      tagList: [{
        type: 1,
        title: '地表水',
        show: true,
        icon: 'icon-shuizhijiance',
        siteList: []
      }, {
        type: 2,
        title: '灌溉水',
        show: true,
        icon: 'icon-shuikushuiwenzhan',
        siteList: []
      }, {
        type: 3,
        title: '规模化养殖场',
        show: true,
        icon: 'icon-hangyefenbu',
        siteList: []
      }, {
        type: 4,
        title: '陆基渔业养殖',
        show: true,
        icon: 'icon-icon-test1',
        siteList: []
      }],
      cityData: cityData,
      rankingList: [{
        city: '东辛庄子村',
        score: '1.03',
        state: 'up'
      }, {
        city: '夏庄一村',
        score: '1.152',
        state: 'down'
      }, {
        city: '王家营子村',
        score: '2.129',
        state: ''
      }, {
        city: '唐家湖村',
        score: '3.323',
        state: 'down'
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.selectedTreeNode = this.handleTreeData(cityData[0]);
    this.$nextTick(function () {
      _this.initMap();
    }); // this.$refs.leftBar.initBarChart(
    //   this.leftBarValue,
    //   this.leftBarTitle
    // )
    // // 反馈工单统计
    // let histogramData = {
    //   date:['星期一','星期二','星期三','星期四','星期五','星期六','星期日'],
    //   label:['一般任务','较大任务','重大任务'],
    //   value:[[3,2,5,7,1,1,3],[8,6,2,1,8,2,1],[5,6,4,2,5,8,5]]
    // }
    // this.$refs.multiHistogram.initBarChart(histogramData)

    this.getDataList({
      'query': {
        'tenantId': 0,
        'size': 10,
        'current': 1,
        'column': 'data_time',
        'order': 'desc',
        'scope': 1,
        'scopeId': 126,
        'userId': 1,
        'stime': null,
        'etime': null,
        'areaId': null,
        'riverId': null,
        'siteIds': null,
        'siteMns': null,
        'cn': null,
        'st': '21',
        'status': null,
        'dateType': null,
        'msgDataType': null,
        'factorCategory': null,
        'factorCode': null,
        'factorGroup': null,
        'onlineData': 0,
        'scopeName': '后六河断面',
        'quantum': null,
        'factors': [{
          'id': 131,
          'code': 'wr1009',
          'title': '流速',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'm/s',
          'test': null,
          'stat': '1',
          'warning': '2',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 130,
          'code': 'wr1008',
          'title': '水位',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 6,
          'unit': null,
          'unitName': 'm',
          'test': null,
          'stat': '1',
          'warning': '2',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 132,
          'code': 'wr1002',
          'title': '瞬时流量',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'm³/s',
          'test': null,
          'stat': '1',
          'warning': '2',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 14,
          'code': 'w19002',
          'title': '阴离子表面活性剂',
          'alias': null,
          'past': '520',
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'mg/L',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 17,
          'code': 'w21001',
          'title': '总氮',
          'alias': null,
          'past': '065',
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'mg/L',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 8,
          'code': 'w01014',
          'title': '电导率',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'μs/cm',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 5,
          'code': 'w01003',
          'title': '浊度',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'NTU',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 7,
          'code': 'w01010',
          'title': '水温',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 1,
          'unit': null,
          'unitName': '℃',
          'test': null,
          'stat': '1',
          'warning': '2',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 20,
          'code': 'w21011',
          'title': '总磷',
          'alias': null,
          'past': '101',
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': 0.2,
          'intbits': null,
          'decimals': 3,
          'unit': null,
          'unitName': 'mg/L',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 18,
          'code': 'w21003',
          'title': '氨氮',
          'alias': null,
          'past': '060',
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': 1,
          'intbits': null,
          'decimals': 3,
          'unit': null,
          'unitName': 'mg/L',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 11,
          'code': 'w01019',
          'title': '高锰酸盐指数',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': 6,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'mg/L',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 6,
          'code': 'w01009',
          'title': '溶解氧',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': 5,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': 'mg/L',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 1,
          'code': 'w01001',
          'title': 'PH',
          'alias': null,
          'past': '001',
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '1',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': 6,
          'limitsUpper': 9,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': '无量纲',
          'test': null,
          'stat': '1',
          'warning': '1',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }, {
          'id': 133,
          'code': 'wr1013',
          'title': '累计流量',
          'alias': null,
          'past': null,
          'category': '1',
          'categoryName': '水质因子',
          'st': null,
          'restriction': '',
          'restrictionName': null,
          'lower': null,
          'upper': null,
          'limitsLower': null,
          'limitsUpper': null,
          'intbits': null,
          'decimals': 2,
          'unit': null,
          'unitName': ' m³',
          'test': null,
          'stat': '2',
          'warning': '2',
          'visible': null,
          'sort': 1,
          'tenantId': null
        }],
        'factorCodes': null,
        'deviceId': null,
        'cache': true,
        'attrs': {
          'areaName': '贵州省-贵安新区',
          'riverName': '红枫湖'
        },
        'searchCount': true
      },
      'records': [{
        'dataTime': '2023-03-20 16:00:00',
        'factor': {
          'wr1008': {
            'raw': 1.14,
            'check': {
              'code': 'CF',
              'remark': '数据连续3条及以上不变',
              'message': '恒值不变'
            },
            'value': 1.14,
            'status': null
          },
          'w01019': {
            'standard': {
              'id': 4,
              'grade': 2,
              'title': 'Ⅱ类',
              'alias': '优',
              'color': '#00ccff',
              'status': '1',
              'standardId': 3,
              'standardCode': 'GB 3838-2002',
              'standardName': '地表水环境质量标准（河流）',
              'standardAlias': '',
              'standardCategory': '1',
              'sort': 2,
              'factors': [{
                'id': 1,
                'code': 'w01001',
                'title': 'PH',
                'alias': null,
                'past': '001',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '1',
                'restrictionName': null,
                'lower': 6,
                'upper': 9,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 6,
                'code': 'w01009',
                'title': '溶解氧',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '2',
                'restrictionName': null,
                'lower': 6,
                'upper': null,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 11,
                'code': 'w01019',
                'title': '高锰酸盐指数',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 4,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 2,
                'code': 'w01018',
                'title': '化学需氧量',
                'alias': null,
                'past': '011',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 15,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 10,
                'code': 'w01017',
                'title': '生化需氧量',
                'alias': null,
                'past': '010',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 3,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 18,
                'code': 'w21003',
                'title': '氨氮',
                'alias': null,
                'past': '060',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.5,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 20,
                'code': 'w21011',
                'title': '总磷',
                'alias': null,
                'past': '101',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 103,
                'code': 'w20122',
                'title': '铜',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 104,
                'code': 'w20123',
                'title': '锌',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 3,
                'code': 'w20141',
                'title': '砷',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 107,
                'code': 'w20120',
                'title': '铅',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.01,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 99,
                'code': 'w22001',
                'title': '石油类',
                'alias': null,
                'past': '080',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }],
              'tenantId': null
            },
            'raw': 2.451,
            'value': 2.45,
            'status': 1
          },
          'wr1009': {
            'raw': 0.012,
            'value': 0.01,
            'status': null
          },
          'w01009': {
            'standard': {
              'id': 5,
              'grade': 3,
              'title': 'Ⅲ类',
              'alias': '良好',
              'color': '#00ff00',
              'status': '1',
              'standardId': 3,
              'standardCode': 'GB 3838-2002',
              'standardName': '地表水环境质量标准（河流）',
              'standardAlias': '',
              'standardCategory': '1',
              'sort': 3,
              'factors': [{
                'id': 1,
                'code': 'w01001',
                'title': 'PH',
                'alias': null,
                'past': '001',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '1',
                'restrictionName': null,
                'lower': 6,
                'upper': 9,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 6,
                'code': 'w01009',
                'title': '溶解氧',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '2',
                'restrictionName': null,
                'lower': 5,
                'upper': null,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 11,
                'code': 'w01019',
                'title': '高锰酸盐指数',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 6,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 2,
                'code': 'w01018',
                'title': '化学需氧量',
                'alias': null,
                'past': '011',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 20,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 10,
                'code': 'w01017',
                'title': '生化需氧量',
                'alias': null,
                'past': '010',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 4,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 18,
                'code': 'w21003',
                'title': '氨氮',
                'alias': null,
                'past': '060',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 20,
                'code': 'w21011',
                'title': '总磷',
                'alias': null,
                'past': '101',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.2,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 103,
                'code': 'w20122',
                'title': '铜',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 104,
                'code': 'w20123',
                'title': '锌',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 3,
                'code': 'w20141',
                'title': '砷',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 107,
                'code': 'w20120',
                'title': '铅',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 99,
                'code': 'w22001',
                'title': '石油类',
                'alias': null,
                'past': '080',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }],
              'tenantId': null
            },
            'raw': 5.73,
            'value': 5.73,
            'status': 1
          },
          'w19002': {
            'raw': 0.095,
            'value': 0.1,
            'status': null
          },
          'wr1002': {
            'raw': 6456.073,
            'check': {
              'code': 'CF',
              'remark': '数据连续3条及以上不变',
              'message': '恒值不变'
            },
            'value': 6456.07,
            'status': null
          },
          'w21011': {
            'standard': {
              'id': 4,
              'grade': 2,
              'title': 'Ⅱ类',
              'alias': '优',
              'color': '#00ccff',
              'status': '1',
              'standardId': 3,
              'standardCode': 'GB 3838-2002',
              'standardName': '地表水环境质量标准（河流）',
              'standardAlias': '',
              'standardCategory': '1',
              'sort': 2,
              'factors': [{
                'id': 1,
                'code': 'w01001',
                'title': 'PH',
                'alias': null,
                'past': '001',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '1',
                'restrictionName': null,
                'lower': 6,
                'upper': 9,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 6,
                'code': 'w01009',
                'title': '溶解氧',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '2',
                'restrictionName': null,
                'lower': 6,
                'upper': null,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 11,
                'code': 'w01019',
                'title': '高锰酸盐指数',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 4,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 2,
                'code': 'w01018',
                'title': '化学需氧量',
                'alias': null,
                'past': '011',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 15,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 10,
                'code': 'w01017',
                'title': '生化需氧量',
                'alias': null,
                'past': '010',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 3,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 18,
                'code': 'w21003',
                'title': '氨氮',
                'alias': null,
                'past': '060',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.5,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 20,
                'code': 'w21011',
                'title': '总磷',
                'alias': null,
                'past': '101',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 103,
                'code': 'w20122',
                'title': '铜',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 104,
                'code': 'w20123',
                'title': '锌',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 1,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 3,
                'code': 'w20141',
                'title': '砷',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 107,
                'code': 'w20120',
                'title': '铅',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.01,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 99,
                'code': 'w22001',
                'title': '石油类',
                'alias': null,
                'past': '080',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }],
              'tenantId': null
            },
            'raw': 0.073,
            'value': 0.073,
            'status': 1
          },
          'wr1013': {
            'raw': 2020,
            'value': 2020,
            'status': null
          },
          'w21001': {
            'raw': 1.715,
            'value': 1.72,
            'status': null
          },
          'w21003': {
            'standard': {
              'id': 3,
              'grade': 1,
              'title': 'Ⅰ类',
              'alias': '优',
              'color': '#ccffff',
              'status': '1',
              'standardId': 3,
              'standardCode': 'GB 3838-2002',
              'standardName': '地表水环境质量标准（河流）',
              'standardAlias': '',
              'standardCategory': '1',
              'sort': 1,
              'factors': [{
                'id': 1,
                'code': 'w01001',
                'title': 'PH',
                'alias': null,
                'past': '001',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '1',
                'restrictionName': null,
                'lower': 6,
                'upper': 9,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 6,
                'code': 'w01009',
                'title': '溶解氧',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '2',
                'restrictionName': null,
                'lower': 7.5,
                'upper': null,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 11,
                'code': 'w01019',
                'title': '高锰酸盐指数',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 2,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 2,
                'code': 'w01018',
                'title': '化学需氧量',
                'alias': null,
                'past': '011',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 15,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 10,
                'code': 'w01017',
                'title': '生化需氧量',
                'alias': null,
                'past': '010',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 3,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 18,
                'code': 'w21003',
                'title': '氨氮',
                'alias': null,
                'past': '060',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.15,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 20,
                'code': 'w21011',
                'title': '总磷',
                'alias': null,
                'past': '101',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.02,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 103,
                'code': 'w20122',
                'title': '铜',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.01,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 104,
                'code': 'w20123',
                'title': '锌',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 3,
                'code': 'w20141',
                'title': '砷',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 107,
                'code': 'w20120',
                'title': '铅',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.01,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 99,
                'code': 'w22001',
                'title': '石油类',
                'alias': null,
                'past': '080',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }],
              'tenantId': null
            },
            'raw': 0.073,
            'value': 0.073,
            'status': 1
          },
          'w01001': {
            'standard': {
              'id': 3,
              'grade': 1,
              'title': 'Ⅰ类',
              'alias': '优',
              'color': '#ccffff',
              'status': '1',
              'standardId': 3,
              'standardCode': 'GB 3838-2002',
              'standardName': '地表水环境质量标准（河流）',
              'standardAlias': '',
              'standardCategory': '1',
              'sort': 1,
              'factors': [{
                'id': 1,
                'code': 'w01001',
                'title': 'PH',
                'alias': null,
                'past': '001',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '1',
                'restrictionName': null,
                'lower': 6,
                'upper': 9,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 6,
                'code': 'w01009',
                'title': '溶解氧',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '2',
                'restrictionName': null,
                'lower': 7.5,
                'upper': null,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 11,
                'code': 'w01019',
                'title': '高锰酸盐指数',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 2,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 2,
                'code': 'w01018',
                'title': '化学需氧量',
                'alias': null,
                'past': '011',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 15,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 10,
                'code': 'w01017',
                'title': '生化需氧量',
                'alias': null,
                'past': '010',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 3,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 18,
                'code': 'w21003',
                'title': '氨氮',
                'alias': null,
                'past': '060',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.15,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 20,
                'code': 'w21011',
                'title': '总磷',
                'alias': null,
                'past': '101',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.02,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 103,
                'code': 'w20122',
                'title': '铜',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.01,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 104,
                'code': 'w20123',
                'title': '锌',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 3,
                'code': 'w20141',
                'title': '砷',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 107,
                'code': 'w20120',
                'title': '铅',
                'alias': null,
                'past': null,
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.01,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }, {
                'id': 99,
                'code': 'w22001',
                'title': '石油类',
                'alias': null,
                'past': '080',
                'category': null,
                'categoryName': null,
                'st': null,
                'restriction': '3',
                'restrictionName': null,
                'lower': null,
                'upper': 0.05,
                'limitsLower': null,
                'limitsUpper': null,
                'intbits': null,
                'decimals': null,
                'unit': null,
                'unitName': null,
                'test': null,
                'stat': null,
                'warning': null,
                'visible': null,
                'sort': 1,
                'standardOptionId': null,
                'tenantId': null
              }],
              'tenantId': null
            },
            'raw': 7.926,
            'value': 7.93,
            'status': 1
          },
          'w01014': {
            'raw': 329.915,
            'value': 329.92,
            'status': null
          },
          'w01003': {
            'raw': 7.389,
            'value': 7.39,
            'status': null
          },
          'w01010': {
            'raw': 14.03,
            'value': 14,
            'status': null
          }
        },
        'attrs': {
          'upStandard': true,
          'siteMode': {
            'id': 126,
            'mn': '581456A2100005',
            'name': '后六河断面',
            'st': '21',
            'pw': '123456',
            'commSum': 6,
            'category': null,
            'standardScope': null,
            'standardOptionId': 5,
            'riverId': 38,
            'areaId': 14,
            'longitude': '106.448471',
            'latitude': '26.409530',
            'checkStatus': '0',
            'userId': 1099,
            'sort': 0,
            'tenantId': null,
            'factors': [{
              'id': 131,
              'code': 'wr1009',
              'title': '流速',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'm/s',
              'test': null,
              'stat': '1',
              'warning': '2',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 130,
              'code': 'wr1008',
              'title': '水位',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'm',
              'test': null,
              'stat': '1',
              'warning': '2',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 132,
              'code': 'wr1002',
              'title': '瞬时流量',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'm³/s',
              'test': null,
              'stat': '1',
              'warning': '2',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 14,
              'code': 'w19002',
              'title': '阴离子表面活性剂',
              'alias': null,
              'past': '520',
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'mg/L',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 17,
              'code': 'w21001',
              'title': '总氮',
              'alias': null,
              'past': '065',
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'mg/L',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 8,
              'code': 'w01014',
              'title': '电导率',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'μs/cm',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 5,
              'code': 'w01003',
              'title': '浊度',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'NTU',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 7,
              'code': 'w01010',
              'title': '水温',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': '℃',
              'test': null,
              'stat': '1',
              'warning': '2',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 20,
              'code': 'w21011',
              'title': '总磷',
              'alias': null,
              'past': '101',
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': 0.2,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'mg/L',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 18,
              'code': 'w21003',
              'title': '氨氮',
              'alias': null,
              'past': '060',
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': 1,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'mg/L',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 11,
              'code': 'w01019',
              'title': '高锰酸盐指数',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': 6,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'mg/L',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 6,
              'code': 'w01009',
              'title': '溶解氧',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': 5,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': 'mg/L',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 1,
              'code': 'w01001',
              'title': 'PH',
              'alias': null,
              'past': '001',
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': 6,
              'limitsUpper': 9,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': '无量纲',
              'test': null,
              'stat': '1',
              'warning': '1',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }, {
              'id': 133,
              'code': 'wr1013',
              'title': '累计流量',
              'alias': null,
              'past': null,
              'category': '1',
              'categoryName': null,
              'st': null,
              'restriction': '',
              'restrictionName': null,
              'lower': null,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': ' m³',
              'test': null,
              'stat': '2',
              'warning': '2',
              'visible': null,
              'sort': 1,
              'tenantId': null
            }],
            'deviceFactors': [],
            'users': [{
              'id': 427,
              'siteId': 126,
              'userId': 1099,
              'siteRole': '2',
              'status': '1',
              'sort': 0,
              'tenantId': null
            }, {
              'id': 428,
              'siteId': 126,
              'userId': 1096,
              'siteRole': '1',
              'status': '1',
              'sort': 0,
              'tenantId': null
            }, {
              'id': 429,
              'siteId': 126,
              'userId': 1100,
              'siteRole': '1',
              'status': '1',
              'sort': 0,
              'tenantId': null
            }]
          },
          'siteOnline': false,
          'currentStandard': {
            'id': 5,
            'grade': 3,
            'title': 'Ⅲ类',
            'alias': '良好',
            'color': '#00ff00',
            'status': '1',
            'standardId': 3,
            'standardCode': 'GB 3838-2002',
            'standardName': '地表水环境质量标准（河流）',
            'standardAlias': '',
            'standardCategory': '1',
            'sort': 3,
            'factors': [{
              'id': 1,
              'code': 'w01001',
              'title': 'PH',
              'alias': null,
              'past': '001',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': 6,
              'upper': 9,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 6,
              'code': 'w01009',
              'title': '溶解氧',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '2',
              'restrictionName': null,
              'lower': 5,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 11,
              'code': 'w01019',
              'title': '高锰酸盐指数',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 6,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 2,
              'code': 'w01018',
              'title': '化学需氧量',
              'alias': null,
              'past': '011',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 20,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 10,
              'code': 'w01017',
              'title': '生化需氧量',
              'alias': null,
              'past': '010',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 4,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 18,
              'code': 'w21003',
              'title': '氨氮',
              'alias': null,
              'past': '060',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 1,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 20,
              'code': 'w21011',
              'title': '总磷',
              'alias': null,
              'past': '101',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.2,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 103,
              'code': 'w20122',
              'title': '铜',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 1,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 104,
              'code': 'w20123',
              'title': '锌',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 1,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 3,
              'code': 'w20141',
              'title': '砷',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.05,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 107,
              'code': 'w20120',
              'title': '铅',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.05,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 99,
              'code': 'w22001',
              'title': '石油类',
              'alias': null,
              'past': '080',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.05,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }],
            'tenantId': null
          },
          'siteId': 126,
          'msgId': '68355450',
          'targetStandard': {
            'id': 5,
            'grade': 3,
            'title': 'Ⅲ类',
            'alias': '良好',
            'color': '#00ff00',
            'status': '1',
            'standardId': 3,
            'standardCode': 'GB 3838-2002',
            'standardName': '地表水环境质量标准（河流）',
            'standardAlias': '',
            'standardCategory': '1',
            'sort': 3,
            'factors': [{
              'id': 1,
              'code': 'w01001',
              'title': 'PH',
              'alias': null,
              'past': '001',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '1',
              'restrictionName': null,
              'lower': 6,
              'upper': 9,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 6,
              'code': 'w01009',
              'title': '溶解氧',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '2',
              'restrictionName': null,
              'lower': 5,
              'upper': null,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 11,
              'code': 'w01019',
              'title': '高锰酸盐指数',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 6,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 2,
              'code': 'w01018',
              'title': '化学需氧量',
              'alias': null,
              'past': '011',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 20,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 10,
              'code': 'w01017',
              'title': '生化需氧量',
              'alias': null,
              'past': '010',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 4,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 18,
              'code': 'w21003',
              'title': '氨氮',
              'alias': null,
              'past': '060',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 1,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 20,
              'code': 'w21011',
              'title': '总磷',
              'alias': null,
              'past': '101',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.2,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 103,
              'code': 'w20122',
              'title': '铜',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 1,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 104,
              'code': 'w20123',
              'title': '锌',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 1,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 3,
              'code': 'w20141',
              'title': '砷',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.05,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 107,
              'code': 'w20120',
              'title': '铅',
              'alias': null,
              'past': null,
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.05,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }, {
              'id': 99,
              'code': 'w22001',
              'title': '石油类',
              'alias': null,
              'past': '080',
              'category': null,
              'categoryName': null,
              'st': null,
              'restriction': '3',
              'restrictionName': null,
              'lower': null,
              'upper': 0.05,
              'limitsLower': null,
              'limitsUpper': null,
              'intbits': null,
              'decimals': null,
              'unit': null,
              'unitName': null,
              'test': null,
              'stat': null,
              'warning': null,
              'visible': null,
              'sort': 1,
              'standardOptionId': null,
              'tenantId': null
            }],
            'tenantId': null
          }
        }
      }]
    });
    this.waterWarnList = [{
      siteName: "\u5927\u7F8A\u5377\u6751",
      warnContent: '暴雨（降雨量超标）',
      warnTime: '2023-03-20 15:04:05'
    }, {
      siteName: "\u4E01\u5BB6\u5B98\u5E84\u6751",
      warnContent: '黑臭水体溢出',
      warnTime: '2023-03-20 15:34:06'
    }, {
      siteName: "\u6768\u5BB6\u6D3C\u6751",
      warnContent: '台风',
      warnTime: '2023-03-20 15:04:05'
    }, {
      siteName: "\u5927\u6D3C\u6751",
      warnContent: '陌生人',
      warnTime: '2023-03-20 15:22:05'
    }, {
      siteName: "\u5C39\u5BB6\u5ED2\u5934\u4E09\u6751",
      warnContent: '危险区域生物闯入',
      warnTime: '2023-03-20 20:24:05'
    }, {
      siteName: "\u5B8B\u5BB6\u5768\u6751",
      warnContent: '站点离线',
      warnTime: '2023-03-20 15:04:05'
    }];
    var time = '2023-03';
    var month = new Date(time).getMonth() + 1; //获取当前月

    var year = new Date(time).getFullYear(); //获取当前年

    var datas = []; //新建日期数组

    var dataLength = new Date(year, month).toJSON().substring(0, 10).split('-')[2]; //获取当前年月日期最大值

    for (var i = 0; i < Number(dataLength); i++) {
      var months = month >= 10 ? month : '0' + month;
      var day = i + 1 >= 10 ? i + 1 : '0' + (i + 1);
      datas.push({
        date: year + '-' + months + '-' + day,
        total: Math.floor(Math.random() * 10) % 3
      }); //存入数组
    } // this.$refs.calendarRange.initBarChart(time, datas, 2)


    this.$refs.ball.initBarChart(0.9091, '数据上传率');
    this.$refs.typeBar.initBarChart([{
      value: 520,
      name: '地表水'
    }, {
      value: 280,
      name: '灌溉水'
    }, {
      value: 100,
      name: '规模化养殖场'
    }, {
      value: 100,
      name: '陆基渔业养殖'
    }]);
    this.$refs.autoPie.initBarChart([{
      name: '自动监测点',
      value: '600'
    }, {
      name: '手工监测点',
      value: '400'
    }]);
    this.$refs.pieData.initBarChart([{
      name: '达标',
      value: 18
    }, {
      name: '不达标',
      value: 8
    }]);
  },
  watch: {
    isFullscreen: function isFullscreen(val) {
      if (val) {
        this.marginTop = '50px';
        this.sideHeight = '98%';
      } else {
        this.marginTop = '45px';
        this.sideHeight = '97%';
      }
    },
    tab: function tab(val) {
      if (val == '1') {
        this.tagList = [{
          type: 1,
          title: '地表水',
          show: true,
          icon: 'icon-shuizhijiance',
          siteList: []
        }, {
          type: 2,
          title: '灌溉水',
          show: true,
          icon: 'icon-shuikushuiwenzhan',
          siteList: []
        }, {
          type: 3,
          title: '规模化养殖场',
          show: true,
          icon: 'icon-hangyefenbu',
          siteList: []
        }, {
          type: 4,
          title: '陆基渔业养殖',
          show: true,
          icon: 'icon-icon-test1',
          siteList: []
        }];
        this.setLayerGroup();
        this.onToSelectTag(this.tagList[0]);
        this.tabTitle = '面源分析';
        this.leftInfo = [{
          name: '村庄面积',
          icon: 'global',
          value: '104',
          unit: 'km²'
        }, {
          name: '人口',
          icon: 'team',
          value: '1743159',
          unit: '人'
        }, {
          name: '耕地面积',
          icon: 'flag',
          value: '86',
          unit: 'km²'
        }];
        this.$refs.typeBar.initBarChart([{
          value: 520,
          name: '地表水'
        }, {
          value: 280,
          name: '灌溉水'
        }, {
          value: 100,
          name: '规模化养殖场'
        }, {
          value: 100,
          name: '陆基渔业养殖'
        }]);
        this.$refs.autoPie.initBarChart([{
          name: '自动监测点',
          value: '600'
        }, {
          name: '手工监测点',
          value: '400'
        }]);
      } else {
        this.tagList = [{
          type: 5,
          title: '生活污水',
          show: true,
          icon: 'icon-duoyinzifenxi',
          siteList: []
        }, {
          type: 6,
          title: '黑臭水体',
          show: true,
          icon: 'icon-wushuifeishui',
          siteList: []
        }, {
          type: 7,
          title: '饮用水源',
          show: true,
          icon: 'icon-turang',
          siteList: []
        }, {
          type: 8,
          title: '农村垃圾',
          show: true,
          icon: 'icon-shuikushuiwenzhan',
          siteList: []
        }, {
          type: 9,
          title: '畜禽粪污',
          show: true,
          icon: 'icon-app_icons--',
          siteList: []
        }];
        this.setLayerGroup();
        this.onToSelectTag(this.tagList[0]);
        this.tabTitle = '环境整改';
        this.leftInfo = [{
          name: '村庄数量',
          icon: 'global',
          value: '128',
          unit: ''
        }, {
          name: '人口',
          icon: 'team',
          value: '1743159',
          unit: '人'
        }, {
          name: '产业',
          icon: 'flag',
          value: '124',
          unit: ''
        }];
        this.$refs.typeBar.initBarChart([{
          value: 520,
          name: '生活污水'
        }, {
          value: 280,
          name: '黑臭水体'
        }, {
          value: 100,
          name: '饮用水源'
        }, {
          value: 100,
          name: '农村垃圾'
        }, {
          value: 150,
          name: '畜禽粪污'
        }]);
        this.$refs.autoPie.initBarChart([{
          name: '自动监测点',
          value: '600'
        }, {
          name: '手工监测点',
          value: '550'
        }]);
      }
    },
    areaId: function areaId(val) {
      this.changeInfo(val);
    },
    tabId: function tabId(val) {
      var _this2 = this;

      if (val == 1) {
        this.ballState = true;
        this.$nextTick(function () {
          _this2.$refs.ball.initBarChart(0.9091, '数据上传率');
        });
      } else {
        clearInterval(this.$refs.ball.timer);
        this.ballState = false;
      }
    }
  },
  methods: {
    // 改变基础信息数据
    changeInfo: function changeInfo(val) {
      if (val == 0) {
        this.leftInfo[0].value = 104;
        this.leftInfo[1].value = 5634554;
        this.leftInfo[2].value = 86;
      } else if (val == '2') {
        this.leftInfo[0].value = 60;
        this.leftInfo[1].value = 45123;
        this.leftInfo[2].value = 46; // this.leftInfo = [{
        //   name: '监测站点',
        //   icon: 'global',
        //   value: '30',
        //   unit: '个'
        // },
        //   {
        //     name: '自然村数',
        //     icon: 'flag',
        //     value: '1101',
        //     unit: '个'
        //   },
        //   {
        //     name: '常住人口',
        //     icon: 'team',
        //     value: '804154',
        //     unit: '人'
        //   }
        // ]
      } else if (val == '2-15') {
        this.leftInfo[0].value = 35;
        this.leftInfo[1].value = 3256;
        this.leftInfo[2].value = 20; // this.leftInfo = [{
        //   name: '监测站点',
        //   icon: 'team',
        //   value: '10',
        //   unit: '个'
        // },
        //   {
        //     name: '自然村数',
        //     icon: 'flag',
        //     value: '46',
        //     unit: '个'
        //   },
        //   {
        //     name: '常住人口',
        //     icon: 'global',
        //     value: '44234',
        //     unit: '人'
        //   }
        // ]
      } else if (val == '2-15-1') {
        this.leftInfo[0].value = 22;
        this.leftInfo[1].value = 1201;
        this.leftInfo[2].value = 16; // this.leftInfo = [{
        //   name: '监测站点',
        //   icon: 'team',
        //   value: '2',
        //   unit: '个'
        // },
        //   {
        //     name: '常住户数',
        //     icon: 'flag',
        //     value: '246',
        //     unit: '户'
        //   },
        //   {
        //     name: '常住人口',
        //     icon: 'global',
        //     value: '1111',
        //     unit: '人'
        //   }
        // ]
      }
    },
    // 实时数据
    getDataList: function getDataList() {
      this.dateList = [{
        siteName: '下元一村',
        time: '2023-03-21 10:00:00',
        a: '32',
        b: '8.54',
        c: '3'
      }, {
        siteName: '簸箕笃子村',
        time: '2023-03-21 10:00:00',
        a: '29',
        b: '4.43',
        c: '2'
      }, {
        siteName: '李家村',
        time: '2023-03-21 10:00:00',
        a: '26',
        b: '5.75',
        c: '11'
      }, {
        siteName: '栈子一村',
        time: '2023-03-21 10:00:00',
        a: '32',
        b: '10.11',
        c: '4'
      }, {
        siteName: '西林子头村',
        time: '2023-03-21 10:00:00',
        a: '30.8',
        b: '9.36',
        c: '12'
      }, {
        siteName: '崔家庄子村',
        time: '2023-03-21 10:00:00',
        a: '32',
        b: '8.54',
        c: '3'
      }, {
        siteName: '华山村',
        time: '2023-03-21 10:00:00',
        a: '30',
        b: '7.9',
        c: '7'
      }, {
        siteName: '竹子河崖村',
        time: '2023-03-21 10:00:00',
        a: '27',
        b: '10.2',
        c: '2'
      }];
    },
    // 排名分析因子切换
    handleChange: function handleChange(val) {
      if (val == 1) {
        this.rankingList = [{
          city: '东辛庄子村',
          score: '1.03',
          state: 'up'
        }, {
          city: '夏庄一村',
          score: '1.152',
          state: 'down'
        }, {
          city: '王家营子村',
          score: '2.129',
          state: ''
        }, {
          city: '唐家湖村',
          score: '3.323',
          state: 'down'
        }];
      } else if (val == 2) {
        this.rankingList = [{
          city: '西徐家庄村',
          score: '6.95',
          state: 'up'
        }, {
          city: '双合村',
          score: '6.94',
          state: 'up'
        }, {
          city: '安岭村',
          score: '6.93',
          state: ''
        }, {
          city: '仇家官庄村',
          score: '6.92',
          state: 'down'
        }];
      } else if (val == 3) {
        this.rankingList = [{
          city: '罗米庄三村',
          score: '0.008',
          state: 'up'
        }, {
          city: '洛河崖村',
          score: '0.009',
          state: ''
        }, {
          city: '魏家庄村',
          score: '0.01',
          state: 'up'
        }, {
          city: '嵇家庄村',
          score: '0.011',
          state: 'down'
        }];
      }
    },
    // 地图
    // tag选中按钮状态
    onToSelectTag: function onToSelectTag(item) {
      // // 多选切换部分
      // item.show = !item.show
      // this.tagList.forEach((item, index) => {
      //   item.siteList.forEach((item1, index1) => {
      //     item.show ? item1.marker.show() : item1.marker.hide()
      //   })
      // })
      // 单选部分
      console.log('tagList', this.tagList);
      this.selectedTagType = item.type;
      this.tagList.forEach(function (item, index) {
        item.siteList.forEach(function (item1, index1) {
          item1.marker.hide();
        });
      });
      item.siteList.forEach(function (item1, index1) {
        item1.marker.show();
      });
    },
    // 标签按钮选中回显状态
    setTagSelected: function setTagSelected(selectedData) {
      // return selectedData.show?'#0ff':'#fff'
      return this.selectedTagType == selectedData.type ? '#0ff' : '#fff';
    },
    initMap: function initMap() {
      map = new AMap.Map('mapDiv', {
        center: this.center,
        disableSocket: true,
        viewMode: '3D',
        pitch: 40,
        zoom: this.zoom,
        mapStyle: 'amap://styles/darkblue',
        // 极夜蓝
        type: 0 // layers:[
        //   new AMap.TileLayer.RoadNet({
        //     //rejectMapMask:true
        //   }),
        //   new AMap.TileLayer.Satellite()
        // ]

      });
      this.setLayerGroup();
    },
    setBounding: function setBounding() {
      var bounds = this.selectedTreeNode.bounds.split(';');
      var arr = [];

      for (var i = 0; i < bounds.length; i += 1) {
        arr.push(new AMap.LngLat(bounds[i].split(',')[0], bounds[i].split(',')[1]));
      }

      var mask = [arr];
      bounds = mask;
      var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
      var holes = mask;
      var pathArray = [outer];
      pathArray.push.apply(pathArray, holes);
      this.polygon = new AMap.Polygon({
        map: map,
        pathL: pathArray,
        strokeColor: '#0ff',
        //城市边界颜色
        strokeWeight: 2,
        fillColor: '#363636',
        // 遮罩背景色黑色
        fillOpacity: 0.7,
        bubble: true
      });
      this.polygon.setPath(pathArray); //添加高度面

      this.object3Dlayer = new AMap.Object3DLayer({
        zIndex: 1
      });
      map.add(this.object3Dlayer);
      var height = -30000;
      var color = '#0088ffcc'; //rgba

      var wall = new AMap.Object3D.Wall({
        path: bounds,
        height: height,
        color: color
      });
      wall.transparent = true;
      this.object3Dlayer.add(wall);

      if (this.areaId == 0) {
        this.setAreaBound(this.bounds1.split(';'));
        this.setAreaBound(this.bounds2.split(';'));
        this.setAreaBound(this.bounds3.split(';'));
        this.setAreaBound(this.bounds4.split(';'));
      } else {
        this.setAreaBound(this.selectedTreeNode.bounds.split(';'));
      }
    },
    setAreaBound: function setAreaBound(bounds1) {
      var arr1 = [];

      for (var i = 0; i < bounds1.length; i += 1) {
        arr1.push(new AMap.LngLat(bounds1[i].split(',')[0], bounds1[i].split(',')[1]));
      }

      var mask1 = [arr1];
      this.polyLineArr = [];

      for (var i = 0; i < mask1.length; i += 1) {
        this.polyLineArr.push(new AMap.Polyline({
          path: mask1[i],
          strokeColor: '#99ffff',
          strokeWeight: 4,
          map: map
        }));
      }
    },
    setMarker: function setMarker() {
      var _this3 = this;

      this.markerList = []; // // 站点部分
      // if (this.areaType == 2) {
      //
      //   this.tagList.forEach(item => {
      //     item.siteList = []
      //     item.show = true
      //   })
      //   this.selectedTreeNode.children.forEach(item => {
      //
      //     // let data = this.tagList[item.type - 1]
      //     let data = this.tagList.filter(item1=>{
      //       return item1.type == item.type
      //     })[0]
      //     item.content = `<div class="marker-background"><div style="color: #fff;font-size: 22px" class="iconfont ${data.icon}"></div></div>`
      //     data.siteList.push(item)
      //   })
      //   this.tagList.forEach(item => {
      //     item.siteList.forEach(item1 => {
      //       let marker = new AMap.Marker({
      //         position: new AMap.LngLat(item1.longitude, item1.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      //         title: item1.label,
      //         offset: new AMap.Pixel(-20, -20),
      //         content: item1.content,
      //         visible: item.show,
      //         zIndex: 10000000
      //       })
      //       item1.marker = marker
      //       marker.on('click', e => {
      //         this.$emit('changeTab', 3, e.id)
      //       })
      //       this.markerList.push(marker)
      //       map.add(marker)
      //     })
      //   })
      //   // 站点显示镇的旗帜
      //   let countryData = this.selectedTreeNode
      //   let marker = new AMap.Marker({
      //     position: new AMap.LngLat(countryData.longitude, countryData.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      //     title: countryData.label,
      //     offset: new AMap.Pixel(-20, -20),
      //     content: `<img title="${countryData.label}" src="${flagImg}" style="width: 30px" />`,
      //     visible: countryData.label,
      //     zIndex: 10000000
      //   })
      //   marker.setLabel({
      //     content: countryData.label,
      //     direction: 'top'
      //   })
      //   marker.on('click', e => {
      //     this.$emit('changeTab', 2, e.id)
      //   })
      //   map.add(marker)
      //   this.markerList.push(marker)
      // } else {
      //   if (this.selectedTreeNode.children) {
      //     this.selectedTreeNode.children.forEach(item => {
      //       let marker = new AMap.Marker({
      //         position: new AMap.LngLat(item.longitude, item.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      //         title: item.label,
      //         offset: new AMap.Pixel(-20, -20),
      //         content: `<img title="${item.label}" src="${flagImg}" style="width: 30px" />`,
      //         visible: item.label,
      //         zIndex: 10000000
      //       })
      //       marker.setLabel({
      //         content: item.label,
      //         direction: 'top'
      //         // offset: new AMap.Pixel(-20, -25)
      //       })
      //       marker.on('click', e => {
      //         this.areaId = item.id
      //         let exterData = {
      //           triggerNode: {
      //             dataRef: item
      //           },
      //           preValue: [{
      //             label: this.selectedTreeNode.label,
      //             value: this.selectedTreeNode.value
      //           }]
      //         }
      //         this.treeChange(item.id, item.label, exterData)
      //       })
      //       this.markerList.push(marker)
      //       map.add(marker)
      //     })
      //   }
      // }

      if (this.selectedTreeNode.children) {
        if (this.areaType != 2) {
          this.selectedTreeNode.children.forEach(function (item) {
            var marker = new AMap.Marker({
              position: new AMap.LngLat(item.longitude, item.latitude),
              // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: item.label,
              offset: new AMap.Pixel(-20, -20),
              content: "<img title=\"".concat(item.label, "\" src=\"").concat(flagImg, "\" style=\"width: 30px\" />"),
              visible: item.label,
              zIndex: 10000000
            });
            marker.setLabel({
              content: item.label,
              direction: 'top' // offset: new AMap.Pixel(-20, -25)

            });
            marker.on('click', function (e) {
              _this3.areaId = item.id;
              var exterData = {
                triggerNode: {
                  dataRef: item
                },
                preValue: [{
                  label: _this3.selectedTreeNode.label,
                  value: _this3.selectedTreeNode.value
                }]
              };

              _this3.treeChange(item.id, item.label, exterData);
            });

            _this3.markerList.push(marker);

            map.add(marker);
          });
        } else {
          // 站点显示镇的旗帜
          var countryData = this.selectedTreeNode;
          var marker = new AMap.Marker({
            position: new AMap.LngLat(countryData.longitude, countryData.latitude),
            // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: countryData.label,
            offset: new AMap.Pixel(-20, -20),
            content: "<img title=\"".concat(countryData.label, "\" src=\"").concat(flagImg, "\" style=\"width: 30px\" />"),
            visible: countryData.label,
            zIndex: 10000000
          });
          marker.setLabel({
            content: countryData.label,
            direction: 'top'
          });
          marker.on('click', function (e) {
            _this3.$emit('changeTab', 2, e.id);
          });
          map.add(marker);
          this.markerList.push(marker);
        }
      }

      console.log('this.selectedTreeNode', this.selectedTreeNode);
      this.initSiteMarker();
    },
    // 初始化站点marker
    initSiteMarker: function initSiteMarker() {
      var _this4 = this;

      this.tagList.forEach(function (item) {
        item.siteList = [];
        item.show = true;
      });
      this.setSiteMarker(this.selectedTreeNode.children);
      this.tagList.forEach(function (item) {
        item.siteList.forEach(function (item1) {
          var marker = new AMap.Marker({
            position: new AMap.LngLat(item1.longitude, item1.latitude),
            // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item1.label,
            offset: new AMap.Pixel(-20, -20),
            content: item1.content,
            visible: item.show,
            zIndex: 10000000
          });
          item1.marker = marker;
          marker.on('click', function (e) {
            _this4.$emit('changeTab', 3, item1.type);
          });

          _this4.markerList.push(marker);

          map.add(marker);
        });
      });
      this.onToSelectTag(this.tagList.filter(function (item) {
        return item.type == _this4.selectedTagType;
      })[0]); // 初始化选中状态
    },
    // 处理树数据
    setSiteMarker: function setSiteMarker(data) {
      var _this5 = this;

      // 站点部分
      data.forEach(function (datas) {
        var areaType = datas.id.split('-').length - 1;

        if (areaType == 3) {
          console.log('datas.type', datas.type);

          var _data = _this5.tagList.filter(function (item) {
            return item.type == datas.type;
          });

          if (_data.length > 0) {
            _data = _data[0];
            datas.content = "<div class=\"marker-background\"><div style=\"color: #fff;font-size: 22px\" class=\"iconfont ".concat(_data.icon, "\"></div></div>");

            _data.siteList.push(datas);
          } // // 站点显示镇的旗帜
          // let countryData = this.selectedTreeNode
          // let marker = new AMap.Marker({
          //   position: new AMap.LngLat(countryData.longitude, countryData.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          //   title: countryData.label,
          //   offset: new AMap.Pixel(-20, -20),
          //   content: `<img title="${countryData.label}" src="${flagImg}" style="width: 30px" />`,
          //   visible: countryData.label,
          //   zIndex: 10000000
          // })
          // marker.setLabel({
          //   content: countryData.label,
          //   direction: 'top'
          // })
          // marker.on('click', e => {
          //   this.$emit('changeTab', 2, e.id)
          // })
          // map.add(marker)
          // this.markerList.push(marker)

        }

        _this5.setLine(datas);

        if (datas.children && datas.children.length > 0) {
          _this5.setSiteMarker(datas.children);
        }
      });
    },
    setLine: function setLine(treeNode) {
      var _this6 = this;

      if (treeNode.line) {
        this.polyLineArr = [];
        treeNode.line.forEach(function (data) {
          var path = data.line; // let path = [[118.835994, 35.714552], [118.83602, 35.814325]]

          var polyline = new AMap.Polyline({
            map: map,
            path: path,
            isOutline: false,
            outlineColor: '#ffeeff',
            borderWeight: 3,
            strokeColor: '#01ddfd',
            strokeOpacity: 1,
            strokeWeight: 3,
            // 折线样式还支持 'dashed'
            strokeStyle: 'solid',
            // strokeStyle是dashed时有效
            strokeDasharray: [10, 5],
            lineJoin: 'round',
            lineCap: 'round',
            zIndex: 50
          });
          var position = [path[0].lng, path[0].lat];
          var marker = new AMap.Marker({
            map: map,
            position: new AMap.LngLat(position[0], position[1]) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]

          });
          marker.setLabel({
            content: data.name,
            direction: 'top'
          });

          _this6.markerList.push(marker);

          _this6.polyLineArr.push(polyline);
        });
      }
    },
    setArea: function setArea() {
      var _this7 = this;

      if (this.selectedTreeNode.area) {
        this.selectedTreeNode.area.forEach(function (item) {
          var path = [];
          item.area.forEach(function (item1) {
            path.push(new AMap.LngLat(item1[0] - 0, item1[1] - 0));
          }); // let path = [
          //   new AMap.LngLat(118.87119,35.79587),
          //   new AMap.LngLat(118.89119,35.83587),
          //   new AMap.LngLat(118.95119,35.85587),
          //   new AMap.LngLat(118.91119,35.82587),
          //   new AMap.LngLat(118.87119,35.79587)
          // ]

          var polygon = new AMap.Polygon({
            path: path,
            fillColor: '#18b4d2',
            // 多边形填充颜色
            borderWeight: 1,
            // 线条宽度，默认为 1
            strokeColor: '#111c5d' // 线条颜色

          });

          _this7.polygonList.push(polygon);

          var position = [path[0].lng, path[0].lat];
          var marker = new AMap.Marker({
            map: map,
            position: new AMap.LngLat(position[0], position[1]) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]

          });
          marker.setLabel({
            content: item.name,
            direction: 'top'
          });

          _this7.markerList.push(marker);

          map.add(polygon);
        });
      }
    },
    // 地图 新增部分  start
    handleTreeData: function handleTreeData(data) {
      var dataCopy = _.cloneDeep(data); // delete dataCopy.children


      return dataCopy;
    },
    treeChange: function treeChange(e, label, extra) {
      this.areaType = e.split('-').length - 1;
      this.selectedTreeNode = this.handleTreeData(extra.triggerNode.dataRef); //站点部分

      if (this.areaType == 3) {
        this.$emit('changeTab', 3, this.selectedTreeNode.id);
      } else {
        // if(this.areaType == 2){
        //   // 村档案部分
        //     this.$emit('changeTab', 2, this.selectedTreeNode.id)
        // }
        this.setLayerGroup();
      }
    },
    // 删除对应地图上的坐标点
    removeMapLayer: function removeMapLayer() {
      var _this8 = this;

      return new Promise(function (resolve, reject) {
        map.clearMap();
        _this8.object3Dlayer ? map.remove(_this8.object3Dlayer) : ''; // this.polygon ? map.remove(this.polygon) : ''
        // this.removeUtil('polyLineArr')
        // this.removeUtil('markerList')
        // this.removeUtil('polyLineArr')
        // this.removeUtil('polygonList')

        resolve();
      });
    },
    removeUtil: function removeUtil(dataString) {
      if (this[dataString].length > 0) {
        this[dataString].forEach(function (item) {
          map.remove(item);
        });
      }
    },
    setLayerGroup: function () {
      var _setLayerGroup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                map.setCenter([this.selectedTreeNode.longitude - 0, this.selectedTreeNode.latitude - 0 - 0.05]);
                map.setZoom(this.zoom + (this.areaType - 0) + (this.areaType == 0 ? 0 : this.areaType == 1 ? 2 : 0.8));
                _context.next = 4;
                return this.removeMapLayer();

              case 4:
                if (this.areaType < 1) {
                  this.setBounding();
                }

                this.setMarker();

                if (this.areaType == 2) {
                  this.setLine(this.selectedTreeNode);
                  this.setArea();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setLayerGroup() {
        return _setLayerGroup.apply(this, arguments);
      }

      return setLayerGroup;
    }() // 新增部分  end

  }
};